import { compileVixScript, runVixScriptBar } from './vixScriptEngine';

export const SYMBOL_MAP = {
  forex: [
    'EURUSD',
    'GBPUSD',
    'USDJPY',
    'AUDUSD',
    'USDCAD',
    'NZDUSD',
    'EURGBP',
    'USDCHF',
    'EURJPY',
    'GBPJPY',
    'AUDJPY',
    'CADJPY',
    'CHFJPY',
    'EURCHF',
    'EURAUD',
    'EURCAD',
    'EURNZD',
    'GBPAUD',
    'GBPCAD',
    'GBPCHF',
    'AUDCAD',
    'AUDCHF',
    'AUDNZD',
    'NZDJPY',
    'NZDCAD',
    'NZDCHF',
  ],
  indices: ['US500', 'NAS100', 'GER40', 'UK100', 'JPN225', 'AUS200'],
  synthetics: ['VOLATILITY10INDEX', 'VOLATILITY25INDEX', 'VOLATILITY50INDEX', 'VOLATILITY75INDEX', 'VOLATILITY100INDEX', 'BOOM1000INDEX', 'CRASH1000INDEX', 'STEPINDEX'],
  crypto: ['BTCUSD', 'ETHUSD', 'SOLUSD', 'BNBUSD', 'XRPUSD'],
  commodities: ['USOIL', 'UKOIL', 'NATGAS', 'WHEAT', 'CORN'],
  metals: ['XAUUSD', 'XAGUSD', 'XPTUSD', 'XPDUSD'],
};

// Timeframes the chart/setup can run on directly (these are fetchable from the
// market-data provider).
export const TIMEFRAME_OPTIONS = ['M1', 'M5', 'M15', 'M30', 'H1', 'H4', 'D1'];

// Timeframes a rule condition can reference. Higher-than-chart frames (incl. W1
// and MN1) are produced by aggregating the chart's candles, so they extend the
// chart set even though they are not directly fetchable. 'Current' (PERIOD_CURRENT
// in MQL5) is represented by the special 'chart' value.
export const CONDITION_TIMEFRAME_OPTIONS = ['M1', 'M5', 'M15', 'M30', 'H1', 'H4', 'D1', 'W1', 'MN1'];

export const SESSION_OPTIONS = [
  { id: 'London', label: 'London', start: 7, end: 16 },
  { id: 'New York', label: 'New York', start: 13, end: 22 },
  { id: 'Tokyo', label: 'Tokyo', start: 0, end: 9 },
  { id: 'Sydney', label: 'Sydney', start: 21, end: 6 },
];

export const DAY_FILTER_OPTIONS = [
  { id: 'Mon', label: 'Mon', index: 1 },
  { id: 'Tue', label: 'Tue', index: 2 },
  { id: 'Wed', label: 'Wed', index: 3 },
  { id: 'Thu', label: 'Thu', index: 4 },
  { id: 'Fri', label: 'Fri', index: 5 },
  { id: 'Sat', label: 'Sat', index: 6 },
  { id: 'Sun', label: 'Sun', index: 0 },
];

export const STRATEGY_TIMEZONE_OPTIONS = [
  { id: 'utc', label: 'UTC' },
  { id: 'broker', label: 'Broker Server' },
  { id: 'custom', label: 'UTC Offset' },
];

export const INDICATOR_LIBRARY = {
  EMA: {
    type: 'EMA',
    label: 'EMA',
    area: 'price',
    color: '#59a6ff',
    params: [{ key: 'period', label: 'Period', defaultValue: '20' }],
  },
  SMA: {
    type: 'SMA',
    label: 'SMA',
    area: 'price',
    color: '#f7c94f',
    params: [{ key: 'period', label: 'Period', defaultValue: '50' }],
  },
  WMA: {
    type: 'WMA',
    label: 'WMA',
    area: 'price',
    color: '#ff9e64',
    params: [{ key: 'period', label: 'Period', defaultValue: '30' }],
  },
  LWMA: {
    type: 'LWMA',
    label: 'LWMA',
    area: 'price',
    color: '#fdba74',
    params: [{ key: 'period', label: 'Period', defaultValue: '30' }],
  },
  SMMA: {
    type: 'SMMA',
    label: 'SMMA',
    area: 'price',
    color: '#9e7cff',
    params: [{ key: 'period', label: 'Period', defaultValue: '34' }],
  },
  DEMA: {
    type: 'DEMA',
    label: 'DEMA',
    area: 'price',
    color: '#f97316',
    params: [{ key: 'period', label: 'Period', defaultValue: '21' }],
  },
  TEMA: {
    type: 'TEMA',
    label: 'TEMA',
    area: 'price',
    color: '#f43f5e',
    params: [{ key: 'period', label: 'Period', defaultValue: '21' }],
  },
  BB: {
    type: 'BB',
    label: 'Bollinger Bands',
    area: 'price',
    color: '#22c55e',
    params: [
      { key: 'period', label: 'Period', defaultValue: '20' },
      { key: 'deviation', label: 'Dev', defaultValue: '2' },
    ],
  },
  ENVELOPES: {
    type: 'ENVELOPES',
    label: 'Envelopes',
    area: 'price',
    color: '#38bdf8',
    params: [
      { key: 'period', label: 'Period', defaultValue: '20' },
      { key: 'deviation', label: 'Dev %', defaultValue: '0.2' },
    ],
  },
  DONCHIAN: {
    type: 'DONCHIAN',
    label: 'Donchian Channel',
    area: 'price',
    color: '#eab308',
    params: [{ key: 'period', label: 'Period', defaultValue: '20' }],
  },
  KELTNER: {
    type: 'KELTNER',
    label: 'Keltner Channel',
    area: 'price',
    color: '#14b8a6',
    params: [
      { key: 'period', label: 'EMA', defaultValue: '20' },
      { key: 'atrPeriod', label: 'ATR', defaultValue: '10' },
      { key: 'multiplier', label: 'Mult', defaultValue: '2' },
    ],
  },
  ALLIGATOR: {
    type: 'ALLIGATOR',
    label: 'Alligator',
    area: 'price',
    color: '#8b5cf6',
    params: [
      { key: 'jaw', label: 'Jaw', defaultValue: '13' },
      { key: 'teeth', label: 'Teeth', defaultValue: '8' },
      { key: 'lips', label: 'Lips', defaultValue: '5' },
    ],
  },
  ICHIMOKU: {
    type: 'ICHIMOKU',
    label: 'Ichimoku',
    area: 'price',
    color: '#f59e0b',
    params: [
      { key: 'tenkan', label: 'Tenkan', defaultValue: '9' },
      { key: 'kijun', label: 'Kijun', defaultValue: '26' },
      { key: 'senkou', label: 'Senkou', defaultValue: '52' },
    ],
  },
  PARABOLIC_SAR: {
    type: 'PARABOLIC_SAR',
    label: 'Parabolic SAR',
    area: 'price',
    color: '#ef4444',
    params: [
      { key: 'step', label: 'Step', defaultValue: '0.02' },
      { key: 'maxStep', label: 'Max', defaultValue: '0.2' },
    ],
  },
  FRACTALS: {
    type: 'FRACTALS',
    label: 'Fractals',
    area: 'price',
    color: '#60a5fa',
    params: [{ key: 'depth', label: 'Depth', defaultValue: '2' }],
  },
  RSI: {
    type: 'RSI',
    label: 'RSI',
    area: 'oscillator',
    color: '#38f2c1',
    params: [
      { key: 'period', label: 'Period', defaultValue: '14' },
      { key: 'ob', label: 'OB', defaultValue: '70' },
      { key: 'os', label: 'OS', defaultValue: '30' },
    ],
  },
  STOCHASTIC: {
    type: 'STOCHASTIC',
    label: 'Stochastic',
    area: 'oscillator',
    color: '#7dd3fc',
    params: [
      { key: 'period', label: 'K', defaultValue: '14' },
      { key: 'signal', label: 'D', defaultValue: '3' },
      { key: 'slowing', label: 'Slow', defaultValue: '3' },
      { key: 'ob', label: 'OB', defaultValue: '80' },
      { key: 'os', label: 'OS', defaultValue: '20' },
    ],
  },
  ATR: {
    type: 'ATR',
    label: 'ATR',
    area: 'oscillator',
    color: '#ff8f66',
    params: [{ key: 'period', label: 'Period', defaultValue: '14' }],
  },
  CCI: {
    type: 'CCI',
    label: 'CCI',
    area: 'oscillator',
    color: '#ffd166',
    params: [{ key: 'period', label: 'Period', defaultValue: '20' }],
  },
  ADX: {
    type: 'ADX',
    label: 'ADX',
    area: 'oscillator',
    color: '#ff6b74',
    params: [{ key: 'period', label: 'Period', defaultValue: '14' }],
  },
  MOMENTUM: {
    type: 'MOMENTUM',
    label: 'Momentum',
    area: 'oscillator',
    color: '#6aa5ff',
    params: [{ key: 'period', label: 'Period', defaultValue: '14' }],
  },
  DEMARKER: {
    type: 'DEMARKER',
    label: 'DeMarker',
    area: 'oscillator',
    color: '#f59e0b',
    params: [{ key: 'period', label: 'Period', defaultValue: '14' }],
  },
  WILLIAMS_R: {
    type: 'WILLIAMS_R',
    label: 'Williams %R',
    area: 'oscillator',
    color: '#60a5fa',
    params: [{ key: 'period', label: 'Period', defaultValue: '14' }],
  },
  STDDEV: {
    type: 'STDDEV',
    label: 'Std Dev',
    area: 'oscillator',
    color: '#f472b6',
    params: [{ key: 'period', label: 'Period', defaultValue: '20' }],
  },
  BULLS_POWER: {
    type: 'BULLS_POWER',
    label: 'Bulls Power',
    area: 'oscillator',
    color: '#22c55e',
    params: [{ key: 'period', label: 'EMA', defaultValue: '13' }],
  },
  BEARS_POWER: {
    type: 'BEARS_POWER',
    label: 'Bears Power',
    area: 'oscillator',
    color: '#ef4444',
    params: [{ key: 'period', label: 'EMA', defaultValue: '13' }],
  },
  MACD: {
    type: 'MACD',
    label: 'MACD',
    area: 'oscillator',
    color: '#8b5cf6',
    params: [
      { key: 'fast', label: 'Fast', defaultValue: '12' },
      { key: 'slow', label: 'Slow', defaultValue: '26' },
      { key: 'signal', label: 'Signal', defaultValue: '9' },
    ],
  },
  OSMA: {
    type: 'OSMA',
    label: 'OsMA',
    area: 'oscillator',
    color: '#22c55e',
    params: [
      { key: 'fast', label: 'Fast', defaultValue: '12' },
      { key: 'slow', label: 'Slow', defaultValue: '26' },
      { key: 'signal', label: 'Signal', defaultValue: '9' },
    ],
  },
  AO: {
    type: 'AO',
    label: 'Awesome Oscillator',
    area: 'oscillator',
    color: '#14b8a6',
    params: [],
  },
  MFI: {
    type: 'MFI',
    label: 'MFI',
    area: 'oscillator',
    color: '#fb7185',
    params: [
      { key: 'period', label: 'Period', defaultValue: '14' },
      { key: 'ob', label: 'OB', defaultValue: '80' },
      { key: 'os', label: 'OS', defaultValue: '20' },
    ],
  },
  TRIX: {
    type: 'TRIX',
    label: 'TRIX',
    area: 'oscillator',
    color: '#c084fc',
    params: [{ key: 'period', label: 'Period', defaultValue: '14' }],
  },
  SWING_HIGH: {
    type: 'SWING_HIGH',
    label: 'Swing High',
    area: 'price',
    color: '#f87171',
    params: [{ key: 'period', label: 'Period', defaultValue: '5' }],
  },
  SWING_LOW: {
    type: 'SWING_LOW',
    label: 'Swing Low',
    area: 'price',
    color: '#4ade80',
    params: [{ key: 'period', label: 'Period', defaultValue: '5' }],
  },
};
function formatTodayForInput() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function formatOneYearAgoForInput() {
  const now = new Date();
  const oneYearAgo = new Date(now);
  oneYearAgo.setFullYear(now.getFullYear() - 1);
  const year = oneYearAgo.getFullYear();
  const month = String(oneYearAgo.getMonth() + 1).padStart(2, '0');
  const day = String(oneYearAgo.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export const DEFAULT_SETUP = {
  assetClass: 'forex',
  symbol: 'EURUSD',
  timeframe: 'H1',
  chartType: 'Candles',
  dataSource: 'deriv',
  modelingMode: 'open_prices',
  brokerProfileId: 'deriv-svg-server-03',
  from: formatOneYearAgoForInput(),
  to: formatTodayForInput(),
  initialBalance: '10000',
  lotSize: '0.1',
  commission: '2',
  slippage: '1',
  stopLevelPoints: '0',
  freezeLevelPoints: '0',
  swapLongPerLot: '',
  swapShortPerLot: '',
};

export const DEFAULT_INDICATORS = [
  { id: 'ma_default', type: 'EMA', params: { period: '20' }, color: '#59a6ff' },
];

export const RULE_OPERATOR_OPTIONS = [
  { id: 'crossesAbove', label: 'Crosses Above' },
  { id: 'crossesBelow', label: 'Crosses Below' },
  { id: 'greaterThan', label: 'Greater Than' },
  { id: 'greaterOrEqual', label: 'Greater or Equal' },
  { id: 'lessThan', label: 'Less Than' },
  { id: 'lessOrEqual', label: 'Less or Equal' },
];

export function createRuleCondition(seed = 'rule', overrides = {}) {
  return {
    id: `${seed}_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    timeframe: 'chart',
    left: 'close',
    leftShift: '0',
    operator: 'greaterThan',
    rightMode: 'operand',
    rightOperand: 'close',
    rightShift: '0',
    rightValue: '',
    ...overrides,
  };
}

export const DEFAULT_RULES = {
  indicatorEntriesEnabled: false,
  timezoneMode: 'utc',
  brokerUtcOffsetHours: '0',
  customUtcOffsetHours: '0',
  longMode: 'all',
  shortMode: 'all',
  longConditions: [
    createRuleCondition('long', {
      left: 'close',
      operator: 'greaterThan',
      rightOperand: 'close',
      rightShift: '1',
    }),
  ],
  shortConditions: [
    createRuleCondition('short', {
      left: 'close',
      operator: 'lessThan',
      rightOperand: 'close',
      rightShift: '1',
    }),
  ],
  stopLoss: '30',
  takeProfit: '60',
  trailingStop: '0',
  breakEvenTrigger: '0',
  breakEvenOffset: '0',
  structureTrailingEnabled: false,
  structureTrailingLookback: '10',
  structureTrailingBuffer: '5',
  partialTpEnabled: false,
  partialTpPoints: '300',
  partialTpPercent: '50',
  partialTpMoveBreakeven: true,
  closeOnOpposite: true,
  maxOpenTrades: '1',
  dayFilters: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
  timeExitEnabled: false,
  timeExitHour: '23',
  timeExitMinute: '0',
  rangeBreakoutEnabled: false,
  rangeBreakoutSide: 'both',
  rangeStartHour: '7',
  rangeStartMinute: '0',
  rangeEndHour: '9',
  rangeEndMinute: '0',
  rangeBreakoutBuffer: '0',
  rangeBreakoutOnce: true,
  martingaleEnabled: false,
  martingaleFactor: '1.5',
  martingaleMaxSteps: '3',
  pendingOrderEnabled: false,
  pendingOrderType: 'stop',
  pendingOffsetPoints: '10',
  pendingExpiryBars: '0',
  pendingDeleteOpposite: true,
  gridEnabled: false,
  gridOrderCount: '3',
  gridSpacingPoints: '30',
  gridLotMultiplier: '1',
  gridBasketTpPoints: '0',
  gridBasketSlPoints: '0',
  riskMode: 'flat_lot',
  riskAmount: '100',
  maxDailyLossMode: 'off',
  maxDailyLossValue: '200',
  maxDrawdownPct: '0',
  maxConsecutiveLosses: '0',
  cooldownBars: '0',
  // Phase 2 filters (AND-gate any entry model)
  spreadFilterEnabled: false,
  maxSpreadPoints: '20',
  trendFilterEnabled: false,
  trendFilterTimeframe: 'H4',
  trendFilterMaType: 'EMA',
  trendFilterMaPeriod: '50',
  trendFilterMode: 'slope',
  timedEntryEnabled: false,
  timedEntryStartHour: '8',
  timedEntryStartMinute: '0',
  timedEntryEndHour: '20',
  timedEntryEndMinute: '0',
  // Phase 2 entry models (OR-combine with indicator/range)
  structuralBreakoutEnabled: false,
  structuralBreakoutRef: 'prevDayHL',
  structuralBreakoutSide: 'both',
  structuralBreakoutBuffer: '0',
  structuralBreakoutOnce: false,
  donchianPeriod: '20',
  atrBreakoutPeriod: '14',
  atrBreakoutMultiple: '1.5',
  candlePatternEntryEnabled: false,
  candlePatternList: [],
  candlePatternSide: 'both',
  // Pattern-by-example entry model: match a user-selected candle shape via correlation.
  // patternTemplate holds the raw closes from the selection start up to (and including) the
  // entry bar; matching is scale/offset invariant so the template can be stored as raw prices.
  patternEntryEnabled: false,
  patternMatchMode: 'close',
  patternSimilarity: 'correlation',
  patternLongTemplates: [],
  patternShortTemplates: [],
  patternThreshold: '0.85',
  // VixScript entry model (Phase B): deterministic scripted logic, interpreted identically
  // in both engines. Not MQ5-exportable until the Phase C transpiler.
  scriptEnabled: false,
  scriptSource: '',
  // Phase 2 overlays (position/risk mgmt, independent of entry)
  breakevenOnlyEnabled: false,
  basketTpEnabled: false,
  basketTpUsd: '0',
  basketSlUsd: '0',
  equityProtectionEnabled: false,
  equityProtectionMode: 'pct',
  equityProtectionValue: '5',
  antiMartingaleEnabled: false,
  antiMartingaleFactor: '1.5',
  antiMartingaleMaxSteps: '3',
  newsFilterEnabled: false,
  newsFilterCurrencies: ['USD'],
  newsFilterImpact: ['high'],
  newsFilterMinutesBefore: '30',
  newsFilterMinutesAfter: '30',
  panelEnabled: false,
  panelTemplate: 'trade_monitor',
  panelPosition: 'top-right',
  panelTheme: 'dark',
  panelWidgets: ['symbol_tf', 'spread', 'floating_pnl', 'equity', 'open_trades'],
};

// Phase 2 candle-pattern entry ids (directional). Used by normalizeRules + detectCandlePatterns.
const CANDLE_PATTERN_IDS = ['pinBarBull', 'pinBarBear', 'engulfBull', 'engulfBear', 'hammer', 'shootingStar', 'morningStar', 'eveningStar'];

const timeframeMinutes = {
  M1: 1,
  M5: 5,
  M15: 15,
  M30: 30,
  H1: 60,
  H4: 240,
  D1: 1440,
  W1: 10080,
  MN1: 43200,
};

function hashString(value) {
  let hash = 2166136261;
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
  }
  return Math.abs(hash >>> 0);
}

function createRng(seedText) {
  let seed = hashString(seedText) || 1;
  return () => {
    seed = (seed * 1664525 + 1013904223) >>> 0;
    return seed / 4294967296;
  };
}

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

function getBaseProfile(symbol) {
  const normalizedSymbol = String(symbol || '').toUpperCase();
  if (/VOLATILITY|BOOM|CRASH|STEP|JUMP|RANGE/.test(normalizedSymbol)) {
    return { base: 1000, digits: 2, point: 0.01, volatility: 12, drift: 0.04, pointValue: 1, instrumentSpec: null };
  }
  if (symbol.includes('JPY')) {
    return { base: 149.2, digits: 3, point: 0.01, volatility: 0.18, drift: 0.006, pointValue: 9.2, instrumentSpec: null };
  }
  if (symbol.startsWith('XAU')) {
    return { base: 2325, digits: 2, point: 0.1, volatility: 9.5, drift: 0.08, pointValue: 1.7, instrumentSpec: null };
  }
  if (symbol.startsWith('XAG')) {
    return { base: 27.4, digits: 3, point: 0.01, volatility: 0.36, drift: 0.012, pointValue: 4.4, instrumentSpec: null };
  }
  if (symbol.includes('BTC')) {
    return { base: 62400, digits: 0, point: 1, volatility: 520, drift: 4.5, pointValue: 0.12, instrumentSpec: null };
  }
  if (symbol.includes('ETH')) {
    return { base: 3160, digits: 1, point: 0.1, volatility: 38, drift: 0.8, pointValue: 0.2, instrumentSpec: null };
  }
  if (symbol.includes('US500') || symbol.includes('NAS100') || symbol.includes('GER40')) {
    return { base: 5200, digits: 1, point: 0.1, volatility: 28, drift: 0.6, pointValue: 0.8, instrumentSpec: null };
  }
  if (symbol.includes('OIL') || symbol.includes('NATGAS')) {
    return { base: 78.5, digits: 2, point: 0.01, volatility: 0.8, drift: 0.02, pointValue: 3.5, instrumentSpec: null };
  }
  return { base: 1.0832, digits: 5, point: 0.0001, volatility: 0.0018, drift: 0.00002, pointValue: 10, instrumentSpec: null };
}

function resolveDisplayDigits(digitsOrProfile) {
  if (digitsOrProfile && typeof digitsOrProfile === 'object') {
    const specPrecision = Number(digitsOrProfile.instrumentSpec?.pricePrecision);
    const profileDigits = Number(digitsOrProfile.digits);
    if (Number.isFinite(specPrecision) && specPrecision >= 0) {
      return Math.max(0, Math.min(8, specPrecision));
    }
    if (Number.isFinite(profileDigits) && profileDigits >= 0) {
      return Math.max(0, Math.min(8, profileDigits));
    }
    return 5;
  }

  const numericDigits = Number(digitsOrProfile);
  if (Number.isFinite(numericDigits) && numericDigits >= 0) {
    return Math.max(0, Math.min(8, numericDigits));
  }
  return 5;
}

export function formatPrice(value, digitsOrProfile) {
  return Number(value || 0).toFixed(resolveDisplayDigits(digitsOrProfile));
}

export function getProfile(symbol) {
  return getBaseProfile(symbol);
}

function normalizeInstrumentSpec(spec, fallbackProfile) {
  if (!spec) {
    return null;
  }
  const pricePrecision = Number(spec.pricePrecision);
  const pointFromPrecision = Number.isFinite(pricePrecision) && pricePrecision >= 0
    ? 10 ** (-pricePrecision)
    : null;
  const rawTickSize = Number(spec.tickSize);
  return {
    ...spec,
    contractSize: Number(spec.contractSize) || 1,
    tickSize: Number.isFinite(rawTickSize) && rawTickSize > 0
      ? (pointFromPrecision ? Math.min(rawTickSize, pointFromPrecision) : rawTickSize)
      : (pointFromPrecision || fallbackProfile.point),
    pricePrecision: Number.isFinite(pricePrecision) ? pricePrecision : fallbackProfile.digits,
    accountCurrency: spec.accountCurrency || 'USD',
  };
}

export function buildProfile(symbol, overrides = {}) {
  const profile = getBaseProfile(symbol);
  const point = overrides.point ?? profile.point;
  const digits = overrides.digits ?? (String(point).includes('.') ? String(point).split('.')[1].length : profile.digits);
  const instrumentSpec = normalizeInstrumentSpec(overrides.instrumentSpec ?? profile.instrumentSpec, { ...profile, point, digits });
  return {
    ...profile,
    ...overrides,
    point,
    digits,
    instrumentSpec,
  };
}

function applyDirectionalSlippage(rawPrice, side, point, slippagePoints, isExit = false) {
  const slip = Math.max(0, Number(slippagePoints) || 0) * point;
  if (!slip) {
    return rawPrice;
  }
  if (side === 'long') {
    return isExit ? rawPrice - slip : rawPrice + slip;
  }
  return isExit ? rawPrice + slip : rawPrice - slip;
}

function getExecutionSpreadPoints(setup, profile) {
  const explicit = Number(setup?.spreadPoints ?? setup?.spread);
  if (Number.isFinite(explicit) && explicit >= 0) {
    return explicit;
  }
  // Per-symbol spread sampled from Deriv's live bid/ask (attached to the profile by the
  // backend) — a realistic default beats the tick-size guess, which is the same for every symbol.
  const sampled = Number(profile?.sampledSpreadPoints);
  if (Number.isFinite(sampled) && sampled >= 0) {
    return sampled;
  }
  const tickSize = Number(profile?.instrumentSpec?.tickSize) || profile?.point || 0;
  const point = Number(profile?.point) || 0;
  if (tickSize > 0 && point > 0) {
    return Math.max(0, Math.round(tickSize / point));
  }
  return 0;
}

function getCandleSpreadPoints(candle, fallbackSpreadPoints) {
  // A missing per-candle spread (null/undefined/'') must fall back to the profile default —
  // NOT coerce to 0. Number(null) === 0 would silently give every Deriv candle a zero spread,
  // since Deriv's candle feed carries no spread at all.
  const raw = candle?.spread;
  if (raw === null || raw === undefined || raw === '') {
    return fallbackSpreadPoints;
  }
  const spread = Number(raw);
  if (Number.isFinite(spread) && spread >= 0) {
    return spread;
  }
  return fallbackSpreadPoints;
}

function normalizePriceToTick(price, profile) {
  if (!Number.isFinite(price)) {
    return price;
  }
  const tickSize = Number(profile?.instrumentSpec?.tickSize) || Number(profile?.point) || 0;
  const digits = Number.isFinite(Number(profile?.digits)) ? Number(profile.digits) : 8;
  if (!tickSize) {
    return Number(price.toFixed(digits));
  }
  return Number((Math.round(price / tickSize) * tickSize).toFixed(digits));
}

function clampStopForBroker(side, proposedStop, currentPrice, profile, stopLevelPoints, freezeLevelPoints) {
  if (!Number.isFinite(proposedStop) || !Number.isFinite(currentPrice)) {
    return null;
  }
  const point = Number(profile?.point) || 0;
  const minDistancePoints = Math.max(0, Number(stopLevelPoints) || 0, Number(freezeLevelPoints) || 0);
  const minDistance = minDistancePoints * point;
  if (!minDistance) {
    return normalizePriceToTick(proposedStop, profile);
  }
  if (side === 'long') {
    const maxStop = currentPrice - minDistance;
    if (maxStop <= 0) {
      return null;
    }
    return normalizePriceToTick(Math.min(proposedStop, maxStop), profile);
  }
  return normalizePriceToTick(Math.max(proposedStop, currentPrice + minDistance), profile);
}

function convertQuotePnlToAccountCurrency(pnlQuote, spec, referencePrice) {
  if (!spec) {
    return pnlQuote;
  }

  const quoteCurrency = spec.quoteCurrency || spec.accountCurrency;
  const accountCurrency = spec.accountCurrency || 'USD';
  const baseCurrency = spec.baseCurrency || null;

  if (quoteCurrency === accountCurrency) {
    return pnlQuote;
  }
  if (baseCurrency && baseCurrency === accountCurrency && Number(referencePrice)) {
    return pnlQuote / Number(referencePrice);
  }
  return pnlQuote;
}

// MT5 SYMBOL_SWAP_MODE has several units. We collapse them to three the engine can price:
// 'points' (swap value is in points), 'percent' (annual interest %), or 'money' (a fixed charge
// per lot in the account currency). Unknown/absent modes default to 'money', which is the
// long-standing behavior — so symbols without a swapMode are completely unaffected.
function normalizeSwapMode(raw) {
  const text = String(raw ?? '').toLowerCase();
  if (text) {
    if (text.includes('point')) return 'points';
    if (text.includes('interest') || text.includes('percent')) return 'percent';
    if (text.includes('currency') || text.includes('money') || text.includes('deposit')
      || text.includes('margin') || text.includes('symbol') || text.includes('reopen')) return 'money';
  }
  const code = Number(raw);
  if (Number.isFinite(code)) {
    if (code === 1) return 'points';                 // SYMBOL_SWAP_MODE_POINTS
    if (code === 5 || code === 6) return 'percent';  // INTEREST_CURRENT / INTEREST_OPEN
    return 'money';                                  // disabled/currency/reopen → fixed money-per-lot
  }
  return 'money';
}

// Money charged per 1.0 lot for a single daily rollover, honoring the swap mode. `swapValue` is
// the raw per-lot swap for the position side (points, annual %, or money depending on mode). The
// 'points' path reuses the exact P&L conversion so it matches how a point is valued elsewhere.
function swapChargePerLot(mode, swapValue, profile, referencePrice) {
  const value = Number(swapValue) || 0;
  if (!value) return 0;
  const spec = profile?.instrumentSpec || null;
  if (mode === 'points') {
    const point = Number(profile?.point) || 0;
    if (spec && Number.isFinite(Number(spec.contractSize))) {
      const quotePerPoint = point * Number(spec.contractSize);
      return value * convertQuotePnlToAccountCurrency(quotePerPoint, spec, referencePrice);
    }
    return value * (Number(profile?.pointValue) || 0);
  }
  if (mode === 'percent') {
    // Annual interest rate in percent, charged daily on the position's notional value.
    const contractSize = spec && Number.isFinite(Number(spec.contractSize)) ? Number(spec.contractSize) : 1;
    const notionalQuote = Number(referencePrice) * contractSize;
    const notionalAccount = spec
      ? convertQuotePnlToAccountCurrency(notionalQuote, spec, referencePrice)
      : notionalQuote;
    return (notionalAccount * (value / 100)) / 360;
  }
  return value; // 'money' — a fixed charge per lot already in the account currency
}

function calculateRealizedPnl(entryPrice, exitPrice, side, lotSize, profile) {
  const move = side === 'long' ? exitPrice - entryPrice : entryPrice - exitPrice;
  if (profile.instrumentSpec) {
    const spec = profile.instrumentSpec;
    const pnlQuote = move * spec.contractSize * lotSize;
    return convertQuotePnlToAccountCurrency(pnlQuote, spec, exitPrice);
  }
  return (move / profile.point) * profile.pointValue * lotSize;
}

function calculateFloatingPnl(entryPrice, markPrice, side, lotSize, profile) {
  return calculateRealizedPnl(entryPrice, markPrice, side, lotSize, profile);
}

function calculateCommissionCost(commissionPerLot, lotSize) {
  return Math.max(0, Number(commissionPerLot) || 0) * lotSize;
}

function getFiniteNumber(...values) {
  for (const value of values) {
    const numeric = Number(value);
    if (Number.isFinite(numeric)) {
      return numeric;
    }
  }
  return null;
}

function resolveBrokerDistancePoints(configuredValue, ...fallbackValues) {
  const fallback = getFiniteNumber(...fallbackValues);
  const fallbackPoints = Number.isFinite(fallback) ? Math.max(0, fallback) : 0;
  if (configuredValue === '' || configuredValue === null || configuredValue === undefined) {
    return fallbackPoints;
  }
  const numeric = Number(configuredValue);
  if (Number.isFinite(numeric)) {
    return numeric === 0 && fallbackPoints > 0 ? fallbackPoints : Math.max(0, numeric);
  }
  return fallbackPoints;
}

function normalizeLotSizeForSpec(rawLotSize, spec) {
  let lotSize = Number(rawLotSize);
  if (!Number.isFinite(lotSize) || lotSize <= 0) {
    return 0;
  }

  // Fall back to standard MT5 broker volume constraints (min/step 0.01) when the instrument
  // spec does not supply them, so the backtest never trades an invalid sub-minimum volume.
  const minLot = getFiniteNumber(spec?.minLot, spec?.volumeMin) ?? 0.01;
  const maxLot = getFiniteNumber(spec?.maxLot, spec?.volumeMax);
  const lotStep = getFiniteNumber(spec?.lotStep, spec?.volumeStep) ?? 0.01;
  if (Number.isFinite(minLot) && minLot > 0) {
    lotSize = Math.max(lotSize, minLot);
  }
  if (Number.isFinite(maxLot) && maxLot > 0) {
    lotSize = Math.min(lotSize, maxLot);
  }
  if (Number.isFinite(lotStep) && lotStep > 0) {
    lotSize = Math.floor((lotSize + 1e-12) / lotStep) * lotStep;
    if (Number.isFinite(minLot) && minLot > 0 && lotSize < minLot) {
      lotSize = minLot;
    }
  }
  return Number(lotSize.toFixed(8));
}

function estimateMarginRequired(lotSize, profile, referencePrice = null) {
  const spec = profile?.instrumentSpec || null;
  const marginPerLot = getFiniteNumber(
    spec?.marginInitialPerLot,
    spec?.marginRequiredPerLot,
    spec?.marginPerLot,
  );
  if (Number.isFinite(marginPerLot) && marginPerLot > 0) {
    return marginPerLot * lotSize;
  }
  // No fixed per-lot margin: derive it from notional ÷ leverage, the way MT5 sizes margin for
  // most forex/CFD symbols. Only used when a leverage is actually known — otherwise unchanged.
  const leverage = getFiniteNumber(spec?.leverage, profile?.leverage);
  const price = Number(referencePrice);
  const contractSize = Number(spec?.contractSize);
  if (spec && Number.isFinite(leverage) && leverage > 0 && Number.isFinite(price) && price > 0
      && Number.isFinite(contractSize) && contractSize > 0) {
    const notionalQuote = price * contractSize * lotSize;
    const notionalAccount = convertQuotePnlToAccountCurrency(notionalQuote, spec, price);
    return notionalAccount / leverage;
  }
  return 0;
}

export function formatCurrency(value) {
  const amount = Number(value || 0);
  return `${amount >= 0 ? '+' : '-'}$${Math.abs(amount).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

function toDateLabel(timestamp) {
  return new Date(timestamp).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

export function createIndicator(type, index) {
  const definition = INDICATOR_LIBRARY[type];
  return {
    id: `${type.toLowerCase()}_${Date.now()}_${index}`,
    type,
    color: definition.color,
    params: definition.params.reduce((acc, param) => {
      acc[param.key] = param.defaultValue;
      return acc;
    }, {}),
  };
}

export function getIndicatorLabel(indicator) {
  const definition = INDICATOR_LIBRARY[indicator.type];
  const label = definition?.label || indicator.type;
  if (indicator.type === 'MACD' || indicator.type === 'OSMA') {
    return `${label}(${indicator.params.fast || '12'},${indicator.params.slow || '26'},${indicator.params.signal || '9'})`;
  }
  if (indicator.type === 'STOCHASTIC') {
    return `${label}(${indicator.params.period || '14'},${indicator.params.signal || '3'},${indicator.params.slowing || '3'})`;
  }
  if (indicator.type === 'BB' || indicator.type === 'ENVELOPES') {
    return `${label}(${indicator.params.period || '20'},${indicator.params.deviation || '2'})`;
  }
  if (indicator.type === 'KELTNER') {
    return `${label}(${indicator.params.period || '20'},${indicator.params.atrPeriod || '10'},${indicator.params.multiplier || '2'})`;
  }
  if (indicator.type === 'ALLIGATOR') {
    return `${label}(${indicator.params.jaw || '13'},${indicator.params.teeth || '8'},${indicator.params.lips || '5'})`;
  }
  if (indicator.type === 'ICHIMOKU') {
    return `${label}(${indicator.params.tenkan || '9'},${indicator.params.kijun || '26'},${indicator.params.senkou || '52'})`;
  }
  if (indicator.type === 'PARABOLIC_SAR') {
    return `${label}(${indicator.params.step || '0.02'},${indicator.params.maxStep || '0.2'})`;
  }
  if (indicator.params.period) {
    return `${label}(${indicator.params.period})`;
  }
  return label;
}

const INDICATOR_OPERAND_SERIES = {
  EMA: [{ key: 'main', label: 'Main' }],
  SMA: [{ key: 'main', label: 'Main' }],
  WMA: [{ key: 'main', label: 'Main' }],
  LWMA: [{ key: 'main', label: 'Main' }],
  SMMA: [{ key: 'main', label: 'Main' }],
  DEMA: [{ key: 'main', label: 'Main' }],
  TEMA: [{ key: 'main', label: 'Main' }],
  BB: [
    { key: 'upper', label: 'Upper Band' },
    { key: 'middle', label: 'Middle Band' },
    { key: 'lower', label: 'Lower Band' },
  ],
  ENVELOPES: [
    { key: 'upper', label: 'Upper Envelope' },
    { key: 'middle', label: 'Middle Envelope' },
    { key: 'lower', label: 'Lower Envelope' },
  ],
  DONCHIAN: [
    { key: 'upper', label: 'Upper Channel' },
    { key: 'middle', label: 'Middle Channel' },
    { key: 'lower', label: 'Lower Channel' },
  ],
  KELTNER: [
    { key: 'upper', label: 'Upper Channel' },
    { key: 'basis', label: 'Basis' },
    { key: 'lower', label: 'Lower Channel' },
  ],
  ALLIGATOR: [
    { key: 'jaw', label: 'Jaw' },
    { key: 'teeth', label: 'Teeth' },
    { key: 'lips', label: 'Lips' },
  ],
  ICHIMOKU: [
    { key: 'tenkan', label: 'Tenkan' },
    { key: 'kijun', label: 'Kijun' },
    { key: 'spanA', label: 'Senkou A' },
    { key: 'spanB', label: 'Senkou B' },
    { key: 'chikou', label: 'Chikou' },
  ],
  PARABOLIC_SAR: [{ key: 'sar', label: 'SAR' }],
  FRACTALS: [
    { key: 'upper', label: 'Upper Fractal' },
    { key: 'lower', label: 'Lower Fractal' },
  ],
  RSI: [{ key: 'main', label: 'Main' }],
  STOCHASTIC: [
    { key: 'k', label: '%K' },
    { key: 'd', label: '%D' },
  ],
  ATR: [{ key: 'main', label: 'Main' }],
  CCI: [{ key: 'main', label: 'Main' }],
  ADX: [
    { key: 'adx', label: 'ADX' },
    { key: 'plus', label: '+DI' },
    { key: 'minus', label: '-DI' },
  ],
  MOMENTUM: [{ key: 'main', label: 'Main' }],
  DEMARKER: [{ key: 'main', label: 'Main' }],
  WILLIAMS_R: [{ key: 'main', label: 'Main' }],
  STDDEV: [{ key: 'main', label: 'Main' }],
  BULLS_POWER: [{ key: 'main', label: 'Main' }],
  BEARS_POWER: [{ key: 'main', label: 'Main' }],
  MACD: [
    { key: 'main', label: 'Main' },
    { key: 'signal', label: 'Signal' },
  ],
  OSMA: [{ key: 'main', label: 'Main' }],
  AO: [{ key: 'main', label: 'Main' }],
  MFI: [{ key: 'main', label: 'Main' }],
  TRIX: [{ key: 'main', label: 'Main' }],
};

const INDICATOR_PRIMARY_SERIES = {
  BB: 'middle',
  ENVELOPES: 'middle',
  DONCHIAN: 'middle',
  KELTNER: 'basis',
  ALLIGATOR: 'lips',
  ICHIMOKU: 'kijun',
  PARABOLIC_SAR: 'sar',
  FRACTALS: 'upper',
  STOCHASTIC: 'k',
  ADX: 'adx',
  MACD: 'main',
};

function getIndicatorOperandSeries(indicator) {
  return INDICATOR_OPERAND_SERIES[indicator.type] || [{ key: 'main', label: 'Main' }];
}

function getIndicatorPrimarySeriesKey(indicator) {
  return INDICATOR_PRIMARY_SERIES[indicator.type] || getIndicatorOperandSeries(indicator)[0]?.key || 'main';
}

// "Conditions by Example": analyse the price/indicator behaviour across a selected candle range
// (lo..hi, hi = entry bar = builder shift 0) and draft standard indicator conditions for `side`.
// Front-end only — the output is normal conditions the engine/export already evaluate.
export function inferConditionsFromSelection(engine, lo, hi, side) {
  const candles = Array.isArray(engine?.candles) ? engine.candles : [];
  const indicatorMap = engine?.indicatorMap || {};
  const indicators = Array.isArray(engine?.indicators) ? engine.indicators : [];
  if (hi <= lo || !candles[hi] || !candles[lo]) return [];
  const indById = new Map(indicators.map((ind) => [ind.id, ind]));
  const operands = getOperandOptions(indicators).filter((o) => o.indicatorId);
  const areaOf = (op) => INDICATOR_LIBRARY[indById.get(op.indicatorId)?.type]?.area;
  const overlayOps = operands.filter((op) => areaOf(op) === 'price');
  const overlayIds = new Set(overlayOps.map((op) => op.id));
  const oscillatorOps = operands.filter((op) => areaOf(op) === 'oscillator');
  const num = (v) => typeof v === 'number' && Number.isFinite(v);
  const sgn = (x) => (x > 0 ? 1 : x < 0 ? -1 : 0);
  const shiftOf = (b) => hi - b;
  const readVal = (operandId, b) => {
    const c = candles[b];
    if (!c) return null;
    if (operandId === 'open') return c.open;
    if (operandId === 'high') return c.high;
    if (operandId === 'low') return c.low;
    if (operandId === 'close') return c.close;
    const series = indicatorMap[operandId];
    return Array.isArray(series) ? series[b] : null;
  };
  const out = [];
  const seen = new Set();
  const keyOf = (c) => `${c.left}|${c.leftShift}|${c.operator}|${c.rightMode}|${c.rightMode === 'value' ? c.rightValue : `${c.rightOperand}@${c.rightShift}`}`;
  const pushOp = (left, ls, operator, rightOperand, rs) => {
    const cond = createRuleCondition(side, { left, leftShift: String(ls), operator, rightMode: 'operand', rightOperand, rightShift: String(rs) });
    const k = keyOf(cond);
    if (!seen.has(k)) { seen.add(k); out.push(cond); }
  };
  const pushVal = (left, ls, operator, value) => {
    const cond = createRuleCondition(side, { left, leftShift: String(ls), operator, rightMode: 'value', rightValue: String(value) });
    const k = keyOf(cond);
    if (!seen.has(k)) { seen.add(k); out.push(cond); }
  };

  // Every drafted condition must include the entry bar (shift 0): the entry candle is the last
  // one in the selection, so earlier bars are only ever described RELATIVE to it. This keeps the
  // strictness slider anchored on the entry — loosening it can never drop the entry signal itself.
  // 1. Candle direction at the entry bar (close vs open).
  {
    const c = candles[hi];
    if (c.close > c.open) pushOp('close', 0, 'greaterThan', 'open', 0);
    else if (c.close < c.open) pushOp('close', 0, 'lessThan', 'open', 0);
  }
  // 2. Close vs each overlay indicator at the entry bar.
  for (const op of overlayOps) {
    const v = readVal(op.id, hi);
    const c = candles[hi];
    if (!c || !num(v)) continue;
    if (c.close > v) pushOp('close', 0, 'greaterThan', op.id, 0);
    else if (c.close < v) pushOp('close', 0, 'lessThan', op.id, 0);
  }
  // 3. Prior-bar price extremes vs the entry bar (low/high at shift k vs shift 0).
  for (let b = lo; b < hi; b += 1) {
    const o = candles[b];
    const n = candles[hi];
    if (!o || !n) continue;
    if (o.low !== n.low) pushOp('low', shiftOf(b), o.low < n.low ? 'lessThan' : 'greaterThan', 'low', 0);
    if (o.high !== n.high) pushOp('high', shiftOf(b), o.high < n.high ? 'lessThan' : 'greaterThan', 'high', 0);
  }
  // 4. Indicator level at prior bars vs at the entry bar (e.g. EMA50 rising into the entry).
  for (const op of operands) {
    const vn = readVal(op.id, hi);
    if (!num(vn)) continue;
    for (let b = lo; b < hi; b += 1) {
      const vo = readVal(op.id, b);
      if (!num(vo) || vo === vn) continue;
      pushOp(op.id, shiftOf(b), vo < vn ? 'lessThan' : 'greaterThan', op.id, 0);
    }
  }
  // 5. Indicator vs indicator at the entry bar — same-indicator buffers or two overlays — + crossover.
  for (let i = 0; i < operands.length; i += 1) {
    for (let j = i + 1; j < operands.length; j += 1) {
      const A = operands[i];
      const B = operands[j];
      const eligible = A.indicatorId === B.indicatorId || (overlayIds.has(A.id) && overlayIds.has(B.id));
      if (!eligible) continue;
      const a0 = readVal(A.id, hi);
      const b0 = readVal(B.id, hi);
      if (!num(a0) || !num(b0) || a0 === b0) continue;
      const aP = readVal(A.id, hi - 1);
      const bP = readVal(B.id, hi - 1);
      if (num(aP) && num(bP) && sgn(aP - bP) !== 0 && sgn(a0 - b0) !== sgn(aP - bP)) {
        pushOp(A.id, 0, a0 > b0 ? 'crossesAbove' : 'crossesBelow', B.id, 0);
      } else {
        pushOp(A.id, 0, a0 > b0 ? 'greaterThan' : 'lessThan', B.id, 0);
      }
    }
  }
  // 6. Close vs overlay crossover at the entry bar.
  for (const op of overlayOps) {
    const v0 = readVal(op.id, hi);
    const vP = readVal(op.id, hi - 1);
    const c0 = candles[hi];
    const cP = candles[hi - 1];
    if (!c0 || !cP || !num(v0) || !num(vP)) continue;
    if (sgn(c0.close - v0) !== 0 && sgn(cP.close - vP) !== 0 && sgn(c0.close - v0) !== sgn(cP.close - vP)) {
      pushOp('close', 0, c0.close > v0 ? 'crossesAbove' : 'crossesBelow', op.id, 0);
    }
  }
  // 7. Oscillator threshold at the entry bar (only when clearly beyond OB/OS).
  for (const op of oscillatorOps) {
    const v0 = readVal(op.id, hi);
    if (!num(v0)) continue;
    const lib = INDICATOR_LIBRARY[indById.get(op.indicatorId)?.type];
    const lvl = (key) => {
      const p = (lib?.params || []).find((x) => x.key === key);
      if (!p) return null;
      const ind = indById.get(op.indicatorId);
      const val = Number(ind?.params?.[key] ?? p.defaultValue);
      return Number.isFinite(val) ? val : null;
    };
    const ob = lvl('ob');
    const os = lvl('os');
    if (os !== null && v0 <= os) pushVal(op.id, 0, 'lessThan', os);
    else if (ob !== null && v0 >= ob) pushVal(op.id, 0, 'greaterThan', ob);
  }
  return out;
}

// Front-end-only live preview: candle indices where `conditions` hold with that candle as the
// signal bar (shift 0). Mirrors evaluateCondition/evaluateOperator semantics on the chart
// timeframe so what lights up is exactly where the backtest would raise a signal (the trade
// itself then opens at the NEXT candle's open, like the exported EA). Conditions referencing
// other timeframes are skipped — captures only ever produce chart-timeframe conditions.
export function findConditionSignalIndices(engine, conditions, mode = 'all') {
  const candles = Array.isArray(engine?.candles) ? engine.candles : [];
  const list = (Array.isArray(conditions) ? conditions : [])
    .filter((condition) => (condition?.timeframe || 'chart') === 'chart');
  if (!candles.length || !list.length) return [];
  const context = { candles, indicatorMap: engine?.indicatorMap || {} };
  const evaluateAt = (condition, anchor) => {
    const leftIndex = anchor - getConditionShiftValue(condition.leftShift);
    const rightIndex = anchor - getConditionShiftValue(condition.rightShift);
    const leftCurrent = resolveOperandValue(condition.left, context, leftIndex);
    const leftPrevious = resolveOperandValue(condition.left, context, leftIndex - 1);
    const rightCurrent = condition.rightMode === 'value'
      ? Number(condition.rightValue)
      : resolveOperandValue(condition.rightOperand, context, rightIndex);
    const rightPrevious = condition.rightMode === 'value'
      ? Number(condition.rightValue)
      : resolveOperandValue(condition.rightOperand, context, rightIndex - 1);
    if (condition.rightMode === 'value' && Number.isNaN(rightCurrent)) {
      return false;
    }
    return evaluateOperator(condition.operator, leftCurrent, leftPrevious, rightCurrent, rightPrevious);
  };
  const maxShift = list.reduce((maximum, condition) => (
    Math.max(maximum, getConditionShiftValue(condition.leftShift), getConditionShiftValue(condition.rightShift))
  ), 0);
  const matches = [];
  for (let index = maxShift + 1; index < candles.length; index += 1) {
    const results = list.map((condition) => evaluateAt(condition, index));
    if (mode === 'any' ? results.some(Boolean) : results.every(Boolean)) {
      matches.push(index);
    }
  }
  return matches;
}

// Human-readable operand label for debugger rows ("Stochastic(14,3,3) %K", "Close", ...).
export function getOperandDisplayLabel(indicators, operandId) {
  if (['open', 'high', 'low', 'close'].includes(operandId)) {
    return operandId.charAt(0).toUpperCase() + operandId.slice(1);
  }
  const match = getOperandOptions(indicators || []).find((option) => option.id === operandId);
  if (!match) {
    return operandId;
  }
  return match.group && match.group !== match.label && match.group !== 'Price'
    ? `${match.group} ${match.label}`
    : match.label;
}

// Strategy debugger (frontend-only): explain the signal evaluation at/before `barIndex`.
// The verdicts come straight from the engine's recorded signalTrace — never re-derived —
// while the per-condition VALUES are resolved through the same evaluateCondition machinery
// (same contexts, same anchor time) so the numbers shown are the numbers the engine compared.
export function explainSignalBar(engine, barIndex) {
  const candles = Array.isArray(engine?.candles) ? engine.candles : [];
  const trace = Array.isArray(engine?.signalTrace) ? engine.signalTrace : [];
  if (!candles.length || !trace.length) {
    return null;
  }
  const clamped = Math.max(0, Math.min(candles.length - 1, Math.trunc(Number(barIndex) || 0)));
  let entry = null;
  for (let i = trace.length - 1; i >= 0; i -= 1) {
    if (trace[i].index <= clamped) {
      entry = trace[i];
      break;
    }
  }
  if (!entry) {
    return null;
  }
  const indicators = Array.isArray(engine.indicators) ? engine.indicators : [];
  const rules = normalizeRules(engine.rules, getOperandOptions(indicators).map((option) => option.id));
  const setupTimeframe = String(engine.setup?.timeframe || 'H1').toUpperCase();
  // engine.candles are the execution candles: the signal timeframe itself in Open Prices
  // mode, M1 otherwise. Contexts aggregate up from them exactly like the simulation.
  const contextTimeframe = (engine.setup?.modelingMode || 'open_prices') === 'open_prices'
    ? setupTimeframe
    : 'M1';
  const referencedTimeframes = getReferencedConditionTimeframes(rules, setupTimeframe);
  const contexts = buildEvaluationContexts(setupTimeframe, indicators, candles, referencedTimeframes, contextTimeframe);
  const baseTime = entry.signalTime ?? candles[entry.index]?.time;
  const explainCondition = (condition) => {
    const timeframe = getResolvedConditionTimeframe(condition, setupTimeframe);
    const context = contexts[timeframe];
    const row = {
      condition,
      timeframe,
      leftValue: null,
      rightValue: null,
      leftPrevious: null,
      rightPrevious: null,
      pass: false,
      available: false,
    };
    if (!context?.candles?.length) {
      return row;
    }
    const anchor = findLastOpenCandleIndex(context.openTimes, baseTime);
    if (anchor < 0) {
      return row;
    }
    const leftIndex = anchor - getConditionShiftValue(condition.leftShift);
    const rightIndex = anchor - getConditionShiftValue(condition.rightShift);
    row.available = true;
    row.leftValue = resolveOperandValue(condition.left, context, leftIndex);
    row.leftPrevious = resolveOperandValue(condition.left, context, leftIndex - 1);
    row.rightValue = condition.rightMode === 'value'
      ? Number(condition.rightValue)
      : resolveOperandValue(condition.rightOperand, context, rightIndex);
    row.rightPrevious = condition.rightMode === 'value'
      ? Number(condition.rightValue)
      : resolveOperandValue(condition.rightOperand, context, rightIndex - 1);
    row.pass = condition.rightMode === 'value' && Number.isNaN(row.rightValue)
      ? false
      : evaluateOperator(condition.operator, row.leftValue, row.leftPrevious, row.rightValue, row.rightPrevious);
    return row;
  };
  return {
    barIndex: entry.index,
    signalTime: baseTime,
    trace: entry,
    rules,
    long: {
      verdict: Boolean(entry.conditionLong),
      mode: rules.longMode,
      rows: rules.indicatorEntriesEnabled ? rules.longConditions.map(explainCondition) : [],
    },
    short: {
      verdict: Boolean(entry.conditionShort),
      mode: rules.shortMode,
      rows: rules.indicatorEntriesEnabled ? rules.shortConditions.map(explainCondition) : [],
    },
  };
}

export function getOperandOptions(indicators) {
  const base = [
    { id: 'open', label: 'Open', group: 'Price' },
    { id: 'high', label: 'High', group: 'Price' },
    { id: 'low', label: 'Low', group: 'Price' },
    { id: 'close', label: 'Close', group: 'Price' },
  ];
  const indicatorOptions = indicators.flatMap((indicator) => {
    const appliedTargetId = getAppliedIndicatorTargetId(indicator);
    const appliedTarget = appliedTargetId ? indicators.find((entry) => entry.id === appliedTargetId) : null;
    const label = appliedTarget
      ? `${getIndicatorLabel(indicator)} on ${getIndicatorLabel(appliedTarget)}`
      : getIndicatorLabel(indicator);
    const series = getIndicatorOperandSeries(indicator);
    const primarySeriesKey = getIndicatorPrimarySeriesKey(indicator);
    const primarySeries = series.find((entry) => entry.key === primarySeriesKey) || series[0];
    if (series.length === 1) {
      return [{
        id: indicator.id,
        label,
        group: label,
        indicatorId: indicator.id,
        seriesKey: primarySeries.key,
      }];
    }
    return [
      {
        id: indicator.id,
        label: `Primary (${primarySeries.label})`,
        group: label,
        indicatorId: indicator.id,
        seriesKey: primarySeries.key,
      },
      ...series.map((entry) => ({
        id: `${indicator.id}:${entry.key}`,
        label: entry.label,
        group: label,
        indicatorId: indicator.id,
        seriesKey: entry.key,
      })),
    ];
  });
  return [...base, ...indicatorOptions];
}

function normalizeRuleCondition(condition, fallbackSeed, validOperands = null) {
  const normalized = createRuleCondition(fallbackSeed, condition || {});
  const allowed = validOperands ? new Set(validOperands) : null;
  if (normalized.timeframe !== 'chart' && !TIMEFRAME_OPTIONS.includes(normalized.timeframe)) {
    normalized.timeframe = 'chart';
  }
  if (allowed && !allowed.has(normalized.left)) {
    normalized.left = 'close';
  }
  if (normalized.rightMode === 'operand' && allowed && !allowed.has(normalized.rightOperand)) {
    normalized.rightOperand = 'close';
  }
  if (normalized.rightMode !== 'value') {
    normalized.rightMode = 'operand';
  }
  normalized.leftShift = String(Math.max(0, Math.trunc(Number(normalized.leftShift) || 0)));
  normalized.rightShift = String(Math.max(0, Math.trunc(Number(normalized.rightShift) || 0)));
  return normalized;
}

export function normalizeRules(rules, validOperands = null) {
  const source = rules || DEFAULT_RULES;
  const legacyLong = source.longConditions?.length
    ? source.longConditions
    : [createRuleCondition('long', {
      left: source.longLeft || 'close',
      operator: source.longOperator || 'greaterThan',
      rightOperand: source.longRight || 'close',
      rightMode: 'operand',
    })];
  const legacyShort = source.shortConditions?.length
    ? source.shortConditions
    : [createRuleCondition('short', {
      left: source.shortLeft || 'close',
      operator: source.shortOperator || 'lessThan',
      rightOperand: source.shortRight || 'close',
      rightMode: 'operand',
    })];

  return {
    ...DEFAULT_RULES,
    ...source,
    indicatorEntriesEnabled: source.indicatorEntriesEnabled !== false,
    timezoneMode: ['utc', 'broker', 'custom'].includes(source.timezoneMode) ? source.timezoneMode : 'utc',
    longMode: source.longMode === 'any' ? 'any' : 'all',
    shortMode: source.shortMode === 'any' ? 'any' : 'all',
    longConditions: legacyLong.map((condition, index) => normalizeRuleCondition(condition, `long_${index}`, validOperands)),
    shortConditions: legacyShort.map((condition, index) => normalizeRuleCondition(condition, `short_${index}`, validOperands)),
    closeOnOpposite: source.closeOnOpposite !== false,
    maxOpenTrades: String(Math.max(1, Math.trunc(Number(source.maxOpenTrades ?? source.maxTrades ?? 1) || 1))),
    dayFilters: Array.isArray(source.dayFilters) && source.dayFilters.length
      ? source.dayFilters.filter((day) => DAY_FILTER_OPTIONS.some((option) => option.id === day))
      : [...DEFAULT_RULES.dayFilters],
    timeExitEnabled: Boolean(source.timeExitEnabled ?? source.enableTimeExit),
    rangeBreakoutEnabled: Boolean(source.rangeBreakoutEnabled ?? source.useRangeBreakout),
    rangeBreakoutSide: ['long', 'short'].includes(source.rangeBreakoutSide) ? source.rangeBreakoutSide : 'both',
    rangeBreakoutOnce: source.rangeBreakoutOnce !== false,
    martingaleEnabled: Boolean(source.martingaleEnabled ?? source.useMartingale),
    pendingOrderEnabled: Boolean(source.pendingOrderEnabled),
    pendingOrderType: ['stop', 'limit'].includes(source.pendingOrderType) ? source.pendingOrderType : 'stop',
    pendingDeleteOpposite: source.pendingDeleteOpposite !== false,
    gridEnabled: Boolean(source.gridEnabled),
    riskMode: ['flat_lot', 'fixed_usd', 'pct_balance', 'pct_equity'].includes(source.riskMode) ? source.riskMode : 'flat_lot',
    maxDailyLossMode: ['off', 'usd', 'pct'].includes(source.maxDailyLossMode) ? source.maxDailyLossMode : 'off',
    cooldownBars: String(Math.max(0, Math.trunc(Number(source.cooldownBars) || 0))),
    spreadFilterEnabled: Boolean(source.spreadFilterEnabled),
    trendFilterEnabled: Boolean(source.trendFilterEnabled),
    trendFilterTimeframe: CONDITION_TIMEFRAME_OPTIONS.includes(source.trendFilterTimeframe) ? source.trendFilterTimeframe : 'H4',
    trendFilterMaType: ['EMA', 'SMA'].includes(source.trendFilterMaType) ? source.trendFilterMaType : 'EMA',
    trendFilterMode: ['slope', 'price'].includes(source.trendFilterMode) ? source.trendFilterMode : 'slope',
    timedEntryEnabled: Boolean(source.timedEntryEnabled),
    structuralBreakoutEnabled: Boolean(source.structuralBreakoutEnabled),
    structuralBreakoutRef: ['prevDayHL', 'prevWeekHL', 'donchian', 'atrVolatility'].includes(source.structuralBreakoutRef) ? source.structuralBreakoutRef : 'prevDayHL',
    structuralBreakoutSide: ['both', 'long', 'short'].includes(source.structuralBreakoutSide) ? source.structuralBreakoutSide : 'both',
    structuralBreakoutOnce: source.structuralBreakoutOnce === true,
    candlePatternEntryEnabled: Boolean(source.candlePatternEntryEnabled),
    candlePatternList: Array.isArray(source.candlePatternList) ? source.candlePatternList.filter((p) => CANDLE_PATTERN_IDS.includes(p)) : [],
    candlePatternSide: ['both', 'long', 'short'].includes(source.candlePatternSide) ? source.candlePatternSide : 'both',
    patternEntryEnabled: Boolean(source.patternEntryEnabled),
    patternMatchMode: source.patternMatchMode === 'ohlc' ? 'ohlc' : 'close',
    patternSimilarity: source.patternSimilarity === 'dtw' ? 'dtw' : 'correlation',
    patternLongTemplates: normalizePatternTemplates(source, 'long'),
    patternShortTemplates: normalizePatternTemplates(source, 'short'),
    patternThreshold: String(Math.max(0, Math.min(1, Number(source.patternThreshold ?? 0.85) || 0.85))),
    scriptEnabled: Boolean(source.scriptEnabled),
    scriptSource: typeof source.scriptSource === 'string' ? source.scriptSource.slice(0, 20000) : '',
    breakevenOnlyEnabled: Boolean(source.breakevenOnlyEnabled),
    structureTrailingEnabled: Boolean(source.structureTrailingEnabled),
    partialTpEnabled: Boolean(source.partialTpEnabled),
    partialTpMoveBreakeven: source.partialTpMoveBreakeven !== false,
    basketTpEnabled: Boolean(source.basketTpEnabled),
    equityProtectionEnabled: Boolean(source.equityProtectionEnabled),
    equityProtectionMode: ['pct', 'usd'].includes(source.equityProtectionMode) ? source.equityProtectionMode : 'pct',
    antiMartingaleEnabled: Boolean(source.antiMartingaleEnabled),
    newsFilterEnabled: Boolean(source.newsFilterEnabled),
    newsFilterCurrencies: Array.isArray(source.newsFilterCurrencies) && source.newsFilterCurrencies.length
      ? source.newsFilterCurrencies
      : ['USD'],
    newsFilterImpact: Array.isArray(source.newsFilterImpact) && source.newsFilterImpact.length
      ? source.newsFilterImpact.filter((v) => ['high', 'medium', 'low'].includes(v))
      : ['high'],
    panelEnabled: Boolean(source.panelEnabled),
    panelTemplate: ['minimal', 'trade_monitor', 'full_hud', 'custom'].includes(source.panelTemplate) ? source.panelTemplate : 'trade_monitor',
    panelPosition: ['top-left', 'top-right', 'bottom-left', 'bottom-right'].includes(source.panelPosition) ? source.panelPosition : 'top-right',
    panelWidgets: Array.isArray(source.panelWidgets) ? source.panelWidgets : [...DEFAULT_RULES.panelWidgets],
  };
}

export function ensureSymbol(setup) {
  const symbols = SYMBOL_MAP[setup.assetClass] || SYMBOL_MAP.forex;
  if (symbols.includes(setup.symbol)) {
    return setup.symbol;
  }
  return symbols[0];
}

export function generateCandles(setup) {
  const symbol = ensureSymbol(setup);
  const profile = getBaseProfile(symbol);
  const rng = createRng(`${symbol}-${setup.timeframe}-${setup.from}-${setup.to}`);
  const fromTime = new Date(`${setup.from}T00:00:00Z`).getTime();
  const toTime = new Date(`${setup.to}T00:00:00Z`).getTime();
  const stepMinutes = timeframeMinutes[setup.timeframe] || 60;
  const totalMinutes = Math.max(stepMinutes * 220, (toTime - fromTime) / 60000);
  const estimatedBars = Math.floor(totalMinutes / stepMinutes);
  const barCount = clamp(estimatedBars, 180, 420);
  const stepMs = stepMinutes * 60000;
  const startTime = toTime - (barCount * stepMs);
  let price = profile.base * (0.99 + rng() * 0.025);
  const candles = [];

  for (let index = 0; index < barCount; index += 1) {
    const trend = Math.sin(index / 17) * profile.volatility * 0.5;
    const rotation = Math.cos(index / 39) * profile.volatility * 0.22;
    const shock = (rng() - 0.48) * profile.volatility * 0.94;
    const open = price;
    const close = open + trend + rotation + shock + profile.drift;
    const high = Math.max(open, close) + Math.abs(shock) * (0.65 + rng()) + (profile.volatility * 0.08);
    const low = Math.min(open, close) - Math.abs(shock) * (0.65 + rng()) - (profile.volatility * 0.08);
    candles.push({
      index,
      time: startTime + (index * stepMs),
      label: toDateLabel(startTime + (index * stepMs)),
      open: Number(open.toFixed(profile.digits)),
      high: Number(high.toFixed(profile.digits)),
      low: Number(low.toFixed(profile.digits)),
      close: Number(close.toFixed(profile.digits)),
    });
    price = close;
  }

  return { candles, profile };
}
function calculateEma(values, period) {
  const normalized = Math.max(1, Number(period) || 1);
  const k = 2 / (normalized + 1);
  let previous = values[0];
  return values.map((value, index) => {
    if (index === 0) {
      previous = value;
    } else {
      previous = (value * k) + (previous * (1 - k));
    }
    return previous;
  });
}

function calculateSma(values, period) {
  const normalized = Math.max(1, Number(period) || 1);
  const result = [];
  let rolling = 0;
  values.forEach((value, index) => {
    rolling += value;
    if (index >= normalized) {
      rolling -= values[index - normalized];
    }
    if (index < normalized - 1) {
      result.push(null);
    } else {
      result.push(rolling / normalized);
    }
  });
  return result;
}

function calculateRsi(values, period) {
  const normalized = Math.max(2, Number(period) || 14);
  const result = Array(values.length).fill(null);
  let gains = 0;
  let losses = 0;
  for (let index = 1; index <= normalized; index += 1) {
    const delta = values[index] - values[index - 1];
    gains += delta > 0 ? delta : 0;
    losses += delta < 0 ? Math.abs(delta) : 0;
  }
  let avgGain = gains / normalized;
  let avgLoss = losses / normalized;
  result[normalized] = avgLoss === 0 ? 100 : 100 - (100 / (1 + (avgGain / avgLoss)));
  for (let index = normalized + 1; index < values.length; index += 1) {
    const delta = values[index] - values[index - 1];
    avgGain = ((avgGain * (normalized - 1)) + (delta > 0 ? delta : 0)) / normalized;
    avgLoss = ((avgLoss * (normalized - 1)) + (delta < 0 ? Math.abs(delta) : 0)) / normalized;
    result[index] = avgLoss === 0 ? 100 : 100 - (100 / (1 + (avgGain / avgLoss)));
  }
  return result;
}

function getTimeframeMinutes(timeframe) {
  return timeframeMinutes[timeframe] || timeframeMinutes.H1;
}

function getTimeframeMs(timeframe) {
  return getTimeframeMinutes(timeframe) * 60000;
}

function getResolvedConditionTimeframe(condition, setupTimeframe) {
  if (!condition?.timeframe || condition.timeframe === 'chart') {
    return setupTimeframe;
  }
  if (!CONDITION_TIMEFRAME_OPTIONS.includes(condition.timeframe)) {
    return setupTimeframe;
  }
  return getTimeframeMinutes(condition.timeframe) >= getTimeframeMinutes(setupTimeframe)
    ? condition.timeframe
    : setupTimeframe;
}

// Bucket start for a candle's open time at the target timeframe. Intraday/daily
// frames use fixed-size buckets; weekly bars align to Monday 00:00 UTC and
// monthly bars to the 1st of the calendar month (UTC), matching MT5's W1/MN1.
function timeframeBucketStart(timeMs, targetTimeframe) {
  if (targetTimeframe === 'MN1') {
    const date = new Date(timeMs);
    return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 1);
  }
  if (targetTimeframe === 'W1') {
    const date = new Date(timeMs);
    const dayStart = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
    const isoDayIndex = (date.getUTCDay() + 6) % 7; // Monday = 0 ... Sunday = 6
    return dayStart - (isoDayIndex * 86400000);
  }
  const targetMs = getTimeframeMs(targetTimeframe);
  return Math.floor(timeMs / targetMs) * targetMs;
}

function aggregateCandlesToTimeframe(baseCandles, targetTimeframe) {
  const aggregated = [];
  let current = null;

  baseCandles.forEach((candle) => {
    const bucketStart = timeframeBucketStart(candle.time, targetTimeframe);
    if (!current || current.time !== bucketStart) {
      current = {
        index: aggregated.length,
        time: bucketStart,
        label: new Date(bucketStart).toLocaleDateString(undefined, { month: 'short', day: 'numeric' }),
        open: candle.open,
        high: candle.high,
        low: candle.low,
        close: candle.close,
      };
      aggregated.push(current);
      return;
    }
    current.high = Math.max(current.high, candle.high);
    current.low = Math.min(current.low, candle.low);
    current.close = candle.close;
  });

  return aggregated;
}

function getReferencedConditionTimeframes(rules, setupTimeframe) {
  const referenced = new Set([setupTimeframe]);
  [...(rules?.longConditions || []), ...(rules?.shortConditions || [])].forEach((condition) => {
    referenced.add(getResolvedConditionTimeframe(condition, setupTimeframe));
  });
  return [...referenced];
}

function buildEvaluationContexts(setupTimeframe, indicators, baseCandles, referencedTimeframes, rawContextTimeframe = setupTimeframe) {
  return referencedTimeframes.reduce((contexts, timeframe) => {
    const candles = timeframe === rawContextTimeframe
      ? baseCandles
      : aggregateCandlesToTimeframe(baseCandles, timeframe);
    const { indicatorOutputs, indicatorMap } = getIndicatorOutputs(indicators, candles);
    contexts[timeframe] = {
      timeframe,
      candles,
      indicatorOutputs,
      indicatorMap,
      openTimes: candles.map((candle) => candle.time),
    };
    return contexts;
  }, {});
}

function findLastOpenCandleIndex(openTimes, evaluationTime) {
  let low = 0;
  let high = openTimes.length - 1;
  let match = -1;

  while (low <= high) {
    const middle = Math.floor((low + high) / 2);
    // Match MQL5 iBarShift(..., exact=false): when the evaluation boundary
    // lands exactly on a new bar open, shift 0 is that current bar and
    // shift 1 is the just-closed bar.
    if (openTimes[middle] <= evaluationTime) {
      match = middle;
      low = middle + 1;
    } else {
      high = middle - 1;
    }
  }

  return match;
}

function getConditionShiftValue(rawShift) {
  return Math.max(0, Math.trunc(Number(rawShift) || 0));
}

function getMaxConditionShift(rules) {
  return [...(rules?.longConditions || []), ...(rules?.shortConditions || [])].reduce((maximum, condition) => (
    Math.max(maximum, getConditionShiftValue(condition.leftShift), getConditionShiftValue(condition.rightShift))
  ), 0);
}

function calculateAtr(candles, period) {
  const trueRanges = candles.map((candle, index) => {
    if (index === 0) {
      return candle.high - candle.low;
    }
    const previousClose = candles[index - 1].close;
    return Math.max(
      candle.high - candle.low,
      Math.abs(candle.high - previousClose),
      Math.abs(candle.low - previousClose),
    );
  });
  return calculateEma(trueRanges, period);
}

// Pattern-by-example: Pearson correlation between a live close window and a stored template.
// Pearson is invariant to price level and scale, so the same shape matches at any price/vol.
// Returns a score in [-1, 1] (0 when either series is flat). Kept identical in both engines.
export function patternCorrelationScore(windowCloses, template) {
  const len = template.length;
  if (!len || windowCloses.length !== len) return 0;
  let sumX = 0;
  let sumY = 0;
  for (let i = 0; i < len; i += 1) {
    sumX += windowCloses[i];
    sumY += template[i];
  }
  const meanX = sumX / len;
  const meanY = sumY / len;
  let cov = 0;
  let varX = 0;
  let varY = 0;
  for (let i = 0; i < len; i += 1) {
    const dx = windowCloses[i] - meanX;
    const dy = template[i] - meanY;
    cov += dx * dy;
    varX += dx * dx;
    varY += dy * dy;
  }
  if (varX <= 0 || varY <= 0) return 0;
  return cov / Math.sqrt(varX * varY);
}

// Z-normalize a vector (mean 0, unit population stddev). Returns null if flat. Used by DTW.
function patternZNorm(values) {
  const len = values.length;
  if (!len) return null;
  let sum = 0;
  for (let i = 0; i < len; i += 1) sum += values[i];
  const mean = sum / len;
  let varAcc = 0;
  for (let i = 0; i < len; i += 1) { const d = values[i] - mean; varAcc += d * d; }
  if (varAcc <= 0) return null;
  const sd = Math.sqrt(varAcc / len);
  const out = new Array(len);
  for (let i = 0; i < len; i += 1) out[i] = (values[i] - mean) / sd;
  return out;
}

// Dynamic time warping similarity in [0,1] between two series (z-normalized first, so it is
// scale/offset invariant like the correlation path). A Sakoe-Chiba band keeps it O(n*band).
function patternDtwScore(windowVec, template) {
  const a = patternZNorm(windowVec);
  const b = patternZNorm(template);
  if (!a || !b) return 0;
  const n = a.length;
  const m = b.length;
  const band = Math.max(2, Math.floor(Math.max(n, m) * 0.15));
  const INF = 1e18;
  let prev = new Array(m + 1).fill(INF);
  let curr = new Array(m + 1).fill(INF);
  prev[0] = 0;
  for (let i = 1; i <= n; i += 1) {
    curr.fill(INF);
    const jStart = Math.max(1, i - band);
    const jEnd = Math.min(m, i + band);
    for (let j = jStart; j <= jEnd; j += 1) {
      const d = a[i - 1] - b[j - 1];
      const best = Math.min(prev[j], curr[j - 1], prev[j - 1]);
      curr[j] = (d * d) + (best >= INF ? 0 : best);
    }
    const tmp = prev; prev = curr; curr = tmp;
  }
  const dist = prev[m];
  if (!Number.isFinite(dist) || dist >= INF) return 0;
  return 1 / (1 + (dist / Math.max(1, (n + m) / 2)));
}

// Builds a flat feature vector for the `bars` candles ending at lastIndex. valsPerBar is 1
// (close only) or 4 (open/high/low/close), matching how the template was captured.
function patternBuildWindow(candles, lastIndex, bars, valsPerBar) {
  if (bars < 2 || lastIndex < bars - 1) return null;
  const out = new Array(bars * valsPerBar);
  let w = 0;
  for (let i = 0; i < bars; i += 1) {
    const candle = candles[lastIndex - bars + 1 + i];
    if (!candle) return null;
    if (valsPerBar === 4) {
      out[w] = candle.open; out[w + 1] = candle.high; out[w + 2] = candle.low; out[w + 3] = candle.close;
      w += 4;
    } else {
      out[w] = candle.close; w += 1;
    }
  }
  return out;
}

// Returns the bar-length of the FIRST stored example template that matches the closed candles
// ending at lastIndex (using the close/ohlc encoding and correlation/dtw similarity), else 0.
// Look-ahead safe. patternMatchAny is the boolean form used by the entry signal.
export function patternMatchAnyLength(candles, lastIndex, templates, mode, similarity, threshold) {
  if (!Array.isArray(templates) || !templates.length) return 0;
  const valsPerBar = mode === 'ohlc' ? 4 : 1;
  for (let t = 0; t < templates.length; t += 1) {
    const template = templates[t];
    if (!Array.isArray(template) || template.length < valsPerBar * 2) continue;
    const bars = Math.floor(template.length / valsPerBar);
    const windowVec = patternBuildWindow(candles, lastIndex, bars, valsPerBar);
    if (!windowVec) continue;
    const score = similarity === 'dtw'
      ? patternDtwScore(windowVec, template)
      : patternCorrelationScore(windowVec, template);
    if (score >= threshold) return bars;
  }
  return 0;
}

function patternMatchAny(candles, lastIndex, templates, mode, similarity, threshold) {
  return patternMatchAnyLength(candles, lastIndex, templates, mode, similarity, threshold) > 0;
}

// Resolves the long/short example templates (array of flat vectors), migrating the V2 single
// template and the V1 (patternTemplate + patternDirection) formats into the plural arrays.
function normalizePatternTemplates(source, side) {
  const cleanVec = (vec) => (Array.isArray(vec) ? vec.map(Number).filter((n) => Number.isFinite(n)) : []);
  const pluralKey = side === 'short' ? 'patternShortTemplates' : 'patternLongTemplates';
  const singularKey = side === 'short' ? 'patternShortTemplate' : 'patternLongTemplate';
  if (Array.isArray(source[pluralKey])) {
    return source[pluralKey].map(cleanVec).filter((vec) => vec.length >= 2);
  }
  if (Array.isArray(source[singularKey]) && source[singularKey].length >= 2) {
    return [cleanVec(source[singularKey])];
  }
  if (Array.isArray(source.patternTemplate) && source.patternTemplate.length >= 2
    && (source.patternDirection === 'short' ? 'short' : 'long') === side) {
    return [cleanVec(source.patternTemplate)];
  }
  return [];
}

// Phase 2: directional candlestick-pattern detection on closed signal candles.
// Returns { long, short } — OR-combines into the entry signal like any entry model.
function detectCandlePatterns(patternList, cur, prev, prev2) {
  const out = { long: false, short: false };
  if (!cur || !Array.isArray(patternList) || !patternList.length) return out;
  const body = Math.abs(cur.close - cur.open);
  const range = Math.max(1e-9, cur.high - cur.low);
  const upperWick = cur.high - Math.max(cur.open, cur.close);
  const lowerWick = Math.min(cur.open, cur.close) - cur.low;
  const bullish = cur.close > cur.open;
  const bearish = cur.close < cur.open;
  for (const p of patternList) {
    switch (p) {
      case 'pinBarBull':
      case 'hammer':
        if (lowerWick >= 2 * body && lowerWick >= 0.6 * range && upperWick <= 0.25 * range) out.long = true;
        break;
      case 'pinBarBear':
      case 'shootingStar':
        if (upperWick >= 2 * body && upperWick >= 0.6 * range && lowerWick <= 0.25 * range) out.short = true;
        break;
      case 'engulfBull':
        if (prev && bullish && prev.close < prev.open && cur.close >= prev.open && cur.open <= prev.close) out.long = true;
        break;
      case 'engulfBear':
        if (prev && bearish && prev.close > prev.open && cur.open >= prev.close && cur.close <= prev.open) out.short = true;
        break;
      case 'morningStar':
        if (prev && prev2 && prev2.close < prev2.open
          && Math.abs(prev.close - prev.open) <= 0.5 * Math.abs(prev2.close - prev2.open)
          && bullish && cur.close > (prev2.open + prev2.close) / 2) out.long = true;
        break;
      case 'eveningStar':
        if (prev && prev2 && prev2.close > prev2.open
          && Math.abs(prev.close - prev.open) <= 0.5 * Math.abs(prev2.close - prev2.open)
          && bearish && cur.close < (prev2.open + prev2.close) / 2) out.short = true;
        break;
      default:
        break;
    }
  }
  return out;
}

function calculateWma(values, period) {
  const normalized = Math.max(1, Number(period) || 1);
  const denominator = (normalized * (normalized + 1)) / 2;
  return values.map((_, index) => {
    if (index < normalized - 1) {
      return null;
    }
    const window = values.slice(index - normalized + 1, index + 1);
    let weighted = 0;
    window.forEach((value, offset) => {
      weighted += value * (offset + 1);
    });
    return weighted / denominator;
  });
}

function calculateSmma(values, period) {
  const normalized = Math.max(1, Number(period) || 1);
  const result = Array(values.length).fill(null);
  let previous = null;
  for (let index = 0; index < values.length; index += 1) {
    if (index < normalized - 1) {
      continue;
    }
    if (previous === null) {
      const window = values.slice(index - normalized + 1, index + 1);
      previous = window.reduce((sum, value) => sum + value, 0) / normalized;
    } else {
      previous = ((previous * (normalized - 1)) + values[index]) / normalized;
    }
    result[index] = previous;
  }
  return result;
}

function calculateCci(candles, period) {
  const normalized = Math.max(2, Number(period) || 20);
  const typical = candles.map((candle) => (candle.high + candle.low + candle.close) / 3);
  return candles.map((_, index) => {
    if (index < normalized - 1) {
      return null;
    }
    const window = typical.slice(index - normalized + 1, index + 1);
    const mean = window.reduce((sum, value) => sum + value, 0) / normalized;
    const deviation = window.reduce((sum, value) => sum + Math.abs(value - mean), 0) / normalized;
    return deviation === 0 ? 0 : (typical[index] - mean) / (0.015 * deviation);
  });
}

function calculateMomentum(values, period) {
  const normalized = Math.max(1, Number(period) || 14);
  return values.map((value, index) => {
    if (index < normalized || values[index - normalized] === 0) {
      return null;
    }
    return (value / values[index - normalized]) * 100;
  });
}

function calculateWilliamsR(candles, period) {
  const normalized = Math.max(2, Number(period) || 14);
  return candles.map((candle, index) => {
    if (index < normalized - 1) {
      return null;
    }
    const window = candles.slice(index - normalized + 1, index + 1);
    const highestBar = Math.max(...window.map((item) => item.high));
    const lowestBar = Math.min(...window.map((item) => item.low));
    const range = highestBar - lowestBar;
    return range === 0 ? 0 : ((highestBar - candle.close) / range) * -100;
  });
}

function calculateDeMarker(candles, period) {
  const normalized = Math.max(2, Number(period) || 14);
  const deMax = candles.map((candle, index) => (index === 0 ? 0 : Math.max(candle.high - candles[index - 1].high, 0)));
  const deMin = candles.map((candle, index) => (index === 0 ? 0 : Math.max(candles[index - 1].low - candle.low, 0)));
  const maxSeries = calculateSma(deMax, normalized);
  const minSeries = calculateSma(deMin, normalized);
  return candles.map((_, index) => {
    if (maxSeries[index] === null || minSeries[index] === null) {
      return null;
    }
    const total = maxSeries[index] + minSeries[index];
    return total === 0 ? 0.5 : maxSeries[index] / total;
  });
}

function calculateMacd(values, fast, slow, signalPeriod) {
  const fastEma = calculateEma(values, fast);
  const slowEma = calculateEma(values, slow);
  const main = values.map((_, index) => fastEma[index] - slowEma[index]);
  const signal = calculateSma(main, signalPeriod);
  return {
    main,
    signal,
    histogram: main.map((value, index) => (signal[index] === null ? null : value - signal[index])),
  };
}

function calculateAwesomeOscillator(candles) {
  const median = candles.map((candle) => (candle.high + candle.low) / 2);
  const fast = calculateSma(median, 5);
  const slow = calculateSma(median, 34);
  return median.map((_, index) => (
    fast[index] === null || slow[index] === null
      ? null
      : fast[index] - slow[index]
  ));
}

function calculateAdx(candles, period) {
  const normalized = Math.max(2, Number(period) || 14);
  const tr = Array(candles.length).fill(0);
  const plusDm = Array(candles.length).fill(0);
  const minusDm = Array(candles.length).fill(0);
  for (let index = 1; index < candles.length; index += 1) {
    const upMove = candles[index].high - candles[index - 1].high;
    const downMove = candles[index - 1].low - candles[index].low;
    plusDm[index] = upMove > downMove && upMove > 0 ? upMove : 0;
    minusDm[index] = downMove > upMove && downMove > 0 ? downMove : 0;
    tr[index] = Math.max(
      candles[index].high - candles[index].low,
      Math.abs(candles[index].high - candles[index - 1].close),
      Math.abs(candles[index].low - candles[index - 1].close),
    );
  }
  let trSmooth = 0;
  let plusSmooth = 0;
  let minusSmooth = 0;
  for (let index = 1; index <= normalized && index < candles.length; index += 1) {
    trSmooth += tr[index];
    plusSmooth += plusDm[index];
    minusSmooth += minusDm[index];
  }
  const dx = Array(candles.length).fill(null);
  const plusDiSeries = Array(candles.length).fill(null);
  const minusDiSeries = Array(candles.length).fill(null);
  for (let index = normalized; index < candles.length; index += 1) {
    if (index > normalized) {
      trSmooth = trSmooth - (trSmooth / normalized) + tr[index];
      plusSmooth = plusSmooth - (plusSmooth / normalized) + plusDm[index];
      minusSmooth = minusSmooth - (minusSmooth / normalized) + minusDm[index];
    }
    if (trSmooth === 0) {
      dx[index] = 0;
      continue;
    }
    const plusDi = (plusSmooth / trSmooth) * 100;
    const minusDi = (minusSmooth / trSmooth) * 100;
    plusDiSeries[index] = plusDi;
    minusDiSeries[index] = minusDi;
    const total = plusDi + minusDi;
    dx[index] = total === 0 ? 0 : (Math.abs(plusDi - minusDi) / total) * 100;
  }
  const adx = Array(candles.length).fill(null);
  let rolling = 0;
  let count = 0;
  for (let index = normalized; index < candles.length; index += 1) {
    if (dx[index] === null) {
      continue;
    }
    if (count < normalized) {
      rolling += dx[index];
      count += 1;
      if (count === normalized) {
        adx[index] = rolling / normalized;
      }
      continue;
    }
    adx[index] = ((adx[index - 1] * (normalized - 1)) + dx[index]) / normalized;
  }
  return { adx, plusDi: plusDiSeries, minusDi: minusDiSeries };
}

function calculateStdDev(values, period) {
  const normalized = Math.max(2, Number(period) || 20);
  const sma = calculateSma(values, normalized);
  return values.map((_, index) => {
    if (index < normalized - 1 || sma[index] === null) {
      return null;
    }
    const window = values.slice(index - normalized + 1, index + 1);
    const variance = window.reduce((sum, value) => sum + ((value - sma[index]) ** 2), 0) / normalized;
    return Math.sqrt(variance);
  });
}

function calculateSparseSma(values, period) {
  const normalized = Math.max(1, Number(period) || 1);
  return values.map((_, index) => {
    if (index < normalized - 1) {
      return null;
    }
    const window = values.slice(index - normalized + 1, index + 1);
    if (window.some((value) => !isFinite(value))) {
      return null;
    }
    return window.reduce((sum, value) => sum + value, 0) / normalized;
  });
}

function calculateStochastic(candles, period, slowing, signalPeriod) {
  const normalized = Math.max(2, Number(period) || 14);
  const smoothed = Math.max(1, Number(slowing) || 3);
  const signalLength = Math.max(1, Number(signalPeriod) || 3);
  const raw = candles.map((candle, index) => {
    if (index < normalized - 1) {
      return null;
    }
    const window = candles.slice(index - normalized + 1, index + 1);
    const highestBar = Math.max(...window.map((item) => item.high));
    const lowestBar = Math.min(...window.map((item) => item.low));
    const range = highestBar - lowestBar;
    return range === 0 ? 50 : ((candle.close - lowestBar) / range) * 100;
  });

  const main = calculateSparseSma(raw, smoothed);
  const signal = calculateSparseSma(main, signalLength);
  return { main, signal };
}

function calculateBullsPower(candles, period) {
  const ema = calculateEma(candles.map((candle) => candle.close), period);
  return candles.map((candle, index) => candle.high - ema[index]);
}

function calculateBearsPower(candles, period) {
  const ema = calculateEma(candles.map((candle) => candle.close), period);
  return candles.map((candle, index) => candle.low - ema[index]);
}

function shiftSeries(values, shift) {
  const offset = Math.trunc(Number(shift) || 0);
  const shifted = Array(values.length).fill(null);
  values.forEach((value, index) => {
    const targetIndex = index + offset;
    if (targetIndex >= 0 && targetIndex < values.length) {
      shifted[targetIndex] = value;
    }
  });
  return shifted;
}

function highestHigh(candles, start, length) {
  let highest = -Infinity;
  for (let index = start; index < start + length; index += 1) {
    highest = Math.max(highest, candles[index].high);
  }
  return highest;
}

function lowestLow(candles, start, length) {
  let lowest = Infinity;
  for (let index = start; index < start + length; index += 1) {
    lowest = Math.min(lowest, candles[index].low);
  }
  return lowest;
}

function calculateDema(values, period) {
  const ema1 = calculateEma(values, period);
  const ema2 = calculateEma(ema1, period);
  return values.map((_, index) => (2 * ema1[index]) - ema2[index]);
}

function calculateTema(values, period) {
  const ema1 = calculateEma(values, period);
  const ema2 = calculateEma(ema1, period);
  const ema3 = calculateEma(ema2, period);
  return values.map((_, index) => ((3 * ema1[index]) - (3 * ema2[index])) + ema3[index]);
}

function calculateTrix(values, period) {
  const normalized = Math.max(1, Number(period) || 14);
  const ema1 = calculateEma(values, normalized);
  const ema2 = calculateEma(ema1, normalized);
  const ema3 = calculateEma(ema2, normalized);
  return ema3.map((value, index) => {
    if (index === 0 || !isFinite(value) || !isFinite(ema3[index - 1]) || ema3[index - 1] === 0) {
      return null;
    }
    return ((value - ema3[index - 1]) / ema3[index - 1]) * 100;
  });
}

function calculateBollinger(values, period, deviationMultiplier) {
  const middle = calculateSma(values, period);
  const deviation = calculateStdDev(values, period);
  const multiplier = Math.max(0.1, Number(deviationMultiplier) || 2);
  return {
    middle,
    upper: middle.map((value, index) => (value === null || deviation[index] === null ? null : value + (deviation[index] * multiplier))),
    lower: middle.map((value, index) => (value === null || deviation[index] === null ? null : value - (deviation[index] * multiplier))),
  };
}

function calculateEnvelopes(values, period, deviationPercent) {
  const middle = calculateSma(values, period);
  const multiplier = Math.max(0, Number(deviationPercent) || 0.2) / 100;
  return {
    middle,
    upper: middle.map((value) => (value === null ? null : value * (1 + multiplier))),
    lower: middle.map((value) => (value === null ? null : value * (1 - multiplier))),
  };
}

function calculateDonchian(candles, period) {
  const normalized = Math.max(2, Number(period) || 20);
  const upper = Array(candles.length).fill(null);
  const lower = Array(candles.length).fill(null);
  const middle = Array(candles.length).fill(null);
  for (let index = normalized; index < candles.length; index += 1) {
    const start = index - normalized;
    const high = highestHigh(candles, start, normalized);
    const low = lowestLow(candles, start, normalized);
    upper[index] = high;
    lower[index] = low;
    middle[index] = (high + low) / 2;
  }
  return { upper, middle, lower };
}

function calculateKeltner(candles, period, atrPeriod, multiplier) {
  const closes = candles.map((candle) => candle.close);
  const basis = calculateEma(closes, period);
  const atr = calculateAtr(candles, atrPeriod);
  const width = Math.max(0.1, Number(multiplier) || 2);
  return {
    basis,
    upper: basis.map((value, index) => (value === null || atr[index] === null ? null : value + (atr[index] * width))),
    lower: basis.map((value, index) => (value === null || atr[index] === null ? null : value - (atr[index] * width))),
  };
}

function calculateAlligator(candles, jawPeriod, teethPeriod, lipsPeriod) {
  const median = candles.map((candle) => (candle.high + candle.low) / 2);
  return {
    jaw: shiftSeries(calculateSmma(median, jawPeriod), 8),
    teeth: shiftSeries(calculateSmma(median, teethPeriod), 5),
    lips: shiftSeries(calculateSmma(median, lipsPeriod), 3),
  };
}

function calculateIchimoku(candles, tenkanPeriod, kijunPeriod, senkouPeriod) {
  const tenkan = Array(candles.length).fill(null);
  const kijun = Array(candles.length).fill(null);
  const spanA = Array(candles.length).fill(null);
  const spanB = Array(candles.length).fill(null);
  const chikou = shiftSeries(candles.map((candle) => candle.close), -Math.max(1, Number(kijunPeriod) || 26));
  for (let index = 0; index < candles.length; index += 1) {
    if (index >= tenkanPeriod - 1) {
      const high = highestHigh(candles, index - tenkanPeriod + 1, tenkanPeriod);
      const low = lowestLow(candles, index - tenkanPeriod + 1, tenkanPeriod);
      tenkan[index] = (high + low) / 2;
    }
    if (index >= kijunPeriod - 1) {
      const high = highestHigh(candles, index - kijunPeriod + 1, kijunPeriod);
      const low = lowestLow(candles, index - kijunPeriod + 1, kijunPeriod);
      kijun[index] = (high + low) / 2;
    }
    if (index >= senkouPeriod - 1) {
      const high = highestHigh(candles, index - senkouPeriod + 1, senkouPeriod);
      const low = lowestLow(candles, index - senkouPeriod + 1, senkouPeriod);
      spanB[index] = (high + low) / 2;
    }
    if (tenkan[index] !== null && kijun[index] !== null) {
      spanA[index] = (tenkan[index] + kijun[index]) / 2;
    }
  }
  return {
    tenkan,
    kijun,
    spanA: shiftSeries(spanA, kijunPeriod),
    spanB: shiftSeries(spanB, kijunPeriod),
    chikou,
  };
}

function calculateParabolicSar(candles, stepValue, maxStepValue) {
  const step = Math.max(0.001, Number(stepValue) || 0.02);
  const maxStep = Math.max(step, Number(maxStepValue) || 0.2);
  const result = Array(candles.length).fill(null);
  if (candles.length < 2) {
    return result;
  }

  let rising = candles[1].close >= candles[0].close;
  let sar = rising ? candles[0].low : candles[0].high;
  let extremePoint = rising ? Math.max(candles[0].high, candles[1].high) : Math.min(candles[0].low, candles[1].low);
  let acceleration = step;
  result[0] = sar;

  for (let index = 1; index < candles.length; index += 1) {
    sar = sar + (acceleration * (extremePoint - sar));
    if (rising) {
      sar = Math.min(sar, candles[Math.max(0, index - 1)].low, candles[Math.max(0, index - 2)]?.low ?? sar);
      if (candles[index].low < sar) {
        rising = false;
        sar = extremePoint;
        extremePoint = candles[index].low;
        acceleration = step;
      } else if (candles[index].high > extremePoint) {
        extremePoint = candles[index].high;
        acceleration = Math.min(maxStep, acceleration + step);
      }
    } else {
      sar = Math.max(sar, candles[Math.max(0, index - 1)].high, candles[Math.max(0, index - 2)]?.high ?? sar);
      if (candles[index].high > sar) {
        rising = true;
        sar = extremePoint;
        extremePoint = candles[index].high;
        acceleration = step;
      } else if (candles[index].low < extremePoint) {
        extremePoint = candles[index].low;
        acceleration = Math.min(maxStep, acceleration + step);
      }
    }
    result[index] = sar;
  }

  return result;
}

function calculateFractals(candles, depth) {
  const normalized = Math.max(2, Number(depth) || 2);
  const upper = Array(candles.length).fill(null);
  const lower = Array(candles.length).fill(null);
  for (let index = normalized; index < candles.length - normalized; index += 1) {
    const candle = candles[index];
    let upperMatch = true;
    let lowerMatch = true;
    for (let offset = 1; offset <= normalized; offset += 1) {
      upperMatch = upperMatch
        && candle.high > candles[index - offset].high
        && candle.high >= candles[index + offset].high;
      lowerMatch = lowerMatch
        && candle.low < candles[index - offset].low
        && candle.low <= candles[index + offset].low;
    }
    if (upperMatch) {
      upper[index] = candle.high;
    }
    if (lowerMatch) {
      lower[index] = candle.low;
    }
  }
  return { upper, lower };
}

function calculateMfi(candles, period) {
  const normalized = Math.max(2, Number(period) || 14);
  const typical = candles.map((candle) => (candle.high + candle.low + candle.close) / 3);
  const positiveFlow = Array(candles.length).fill(0);
  const negativeFlow = Array(candles.length).fill(0);
  for (let index = 1; index < candles.length; index += 1) {
    const volume = Math.max(
      1,
      Number(candles[index].volume)
      || Number(candles[index].tickVolume)
      || Math.round(Math.abs(candles[index].high - candles[index].low) * 10000)
      || 1,
    );
    const rawFlow = typical[index] * volume;
    if (typical[index] > typical[index - 1]) {
      positiveFlow[index] = rawFlow;
    } else if (typical[index] < typical[index - 1]) {
      negativeFlow[index] = rawFlow;
    }
  }
  return candles.map((_, index) => {
    if (index < normalized) {
      return null;
    }
    const start = index - normalized + 1;
    const positive = positiveFlow.slice(start, index + 1).reduce((sum, value) => sum + value, 0);
    const negative = negativeFlow.slice(start, index + 1).reduce((sum, value) => sum + value, 0);
    if (negative === 0) {
      return 100;
    }
    const ratio = positive / negative;
    return 100 - (100 / (1 + ratio));
  });
}

function createLineSeries(indicator, key, label, values, color, extras = {}) {
  return {
    id: `${indicator.id}_${key}`,
    type: 'line',
    label,
    values,
    color,
    strokeWidth: extras.strokeWidth || 2,
    dashArray: extras.dashArray || null,
  };
}

function createHistogramSeries(indicator, key, label, values, positiveColor, negativeColor, baseValue = 0) {
  return {
    id: `${indicator.id}_${key}`,
    type: 'histogram',
    label,
    values,
    color: positiveColor,
    positiveColor,
    negativeColor,
    baseValue,
  };
}

function createMarkerSeries(indicator, key, label, values, color, shape = 'dot') {
  return {
    id: `${indicator.id}_${key}`,
    type: 'markers',
    label,
    values,
    color,
    shape,
  };
}

function createIndicatorOutput(indicator, primary, series, extras = {}) {
  return {
    id: indicator.id,
    label: getIndicatorLabel(indicator),
    color: indicator.color,
    primary,
    series,
    min: extras.min ?? null,
    max: extras.max ?? null,
    guides: extras.guides || [],
  };
}

function buildIndicatorOutput(indicator, candles, appliedSource = null) {
  const closes = candles.map((candle) => candle.close);
  // MT5-style "apply to indicator data": MA types can run over another indicator's series
  // instead of price. With no applied source this is exactly the old price-based behaviour.
  const maSource = Array.isArray(appliedSource) ? appliedSource : closes;
  switch (indicator.type) {
    case 'EMA': {
      const values = calculateOverSeries(maSource, (source) => calculateEma(source, indicator.params.period));
      return createIndicatorOutput(indicator, values, [createLineSeries(indicator, 'main', getIndicatorLabel(indicator), values, indicator.color)]);
    }
    case 'SMA': {
      const values = calculateOverSeries(maSource, (source) => calculateSma(source, indicator.params.period));
      return createIndicatorOutput(indicator, values, [createLineSeries(indicator, 'main', getIndicatorLabel(indicator), values, indicator.color)]);
    }
    case 'WMA':
    case 'LWMA': {
      const values = calculateOverSeries(maSource, (source) => calculateWma(source, indicator.params.period));
      return createIndicatorOutput(indicator, values, [createLineSeries(indicator, 'main', getIndicatorLabel(indicator), values, indicator.color)]);
    }
    case 'SMMA': {
      const values = calculateOverSeries(maSource, (source) => calculateSmma(source, indicator.params.period));
      return createIndicatorOutput(indicator, values, [createLineSeries(indicator, 'main', getIndicatorLabel(indicator), values, indicator.color)]);
    }
    case 'DEMA': {
      const values = calculateDema(closes, indicator.params.period);
      return createIndicatorOutput(indicator, values, [createLineSeries(indicator, 'main', getIndicatorLabel(indicator), values, indicator.color)]);
    }
    case 'TEMA': {
      const values = calculateTema(closes, indicator.params.period);
      return createIndicatorOutput(indicator, values, [createLineSeries(indicator, 'main', getIndicatorLabel(indicator), values, indicator.color)]);
    }
    case 'BB': {
      const bands = calculateBollinger(closes, indicator.params.period, indicator.params.deviation);
      return createIndicatorOutput(indicator, bands.middle, [
        createLineSeries(indicator, 'upper', 'Upper Band', bands.upper, '#5eead4'),
        createLineSeries(indicator, 'middle', 'Middle Band', bands.middle, indicator.color),
        createLineSeries(indicator, 'lower', 'Lower Band', bands.lower, '#60a5fa'),
      ]);
    }
    case 'ENVELOPES': {
      const envelopes = calculateEnvelopes(closes, indicator.params.period, indicator.params.deviation);
      return createIndicatorOutput(indicator, envelopes.middle, [
        createLineSeries(indicator, 'upper', 'Upper Envelope', envelopes.upper, '#38bdf8'),
        createLineSeries(indicator, 'middle', 'Middle Envelope', envelopes.middle, indicator.color),
        createLineSeries(indicator, 'lower', 'Lower Envelope', envelopes.lower, '#f59e0b'),
      ]);
    }
    case 'DONCHIAN': {
      const channel = calculateDonchian(candles, indicator.params.period);
      return createIndicatorOutput(indicator, channel.middle, [
        createLineSeries(indicator, 'upper', 'Upper Donchian', channel.upper, '#60a5fa'),
        createLineSeries(indicator, 'middle', 'Middle Donchian', channel.middle, indicator.color),
        createLineSeries(indicator, 'lower', 'Lower Donchian', channel.lower, '#f97316'),
      ]);
    }
    case 'KELTNER': {
      const channel = calculateKeltner(candles, indicator.params.period, indicator.params.atrPeriod, indicator.params.multiplier);
      return createIndicatorOutput(indicator, channel.basis, [
        createLineSeries(indicator, 'upper', 'Upper Keltner', channel.upper, '#2dd4bf'),
        createLineSeries(indicator, 'basis', 'Basis', channel.basis, indicator.color),
        createLineSeries(indicator, 'lower', 'Lower Keltner', channel.lower, '#22d3ee'),
      ]);
    }
    case 'ALLIGATOR': {
      const lines = calculateAlligator(candles, indicator.params.jaw, indicator.params.teeth, indicator.params.lips);
      return createIndicatorOutput(indicator, lines.lips, [
        createLineSeries(indicator, 'jaw', 'Jaw', lines.jaw, '#3b82f6'),
        createLineSeries(indicator, 'teeth', 'Teeth', lines.teeth, '#ef4444'),
        createLineSeries(indicator, 'lips', 'Lips', lines.lips, '#22c55e'),
      ]);
    }
    case 'ICHIMOKU': {
      const lines = calculateIchimoku(
        candles,
        Math.max(2, Number(indicator.params.tenkan) || 9),
        Math.max(2, Number(indicator.params.kijun) || 26),
        Math.max(2, Number(indicator.params.senkou) || 52),
      );
      return createIndicatorOutput(indicator, lines.kijun, [
        createLineSeries(indicator, 'tenkan', 'Tenkan', lines.tenkan, '#fb7185'),
        createLineSeries(indicator, 'kijun', 'Kijun', lines.kijun, '#60a5fa'),
        createLineSeries(indicator, 'spanA', 'Senkou A', lines.spanA, '#34d399', { dashArray: '5 4' }),
        createLineSeries(indicator, 'spanB', 'Senkou B', lines.spanB, '#f59e0b', { dashArray: '5 4' }),
        createLineSeries(indicator, 'chikou', 'Chikou', lines.chikou, '#c084fc'),
      ]);
    }
    case 'PARABOLIC_SAR': {
      const values = calculateParabolicSar(candles, indicator.params.step, indicator.params.maxStep);
      return createIndicatorOutput(indicator, values, [
        createMarkerSeries(indicator, 'sar', 'Parabolic SAR', values, indicator.color, 'circle'),
      ]);
    }
    case 'FRACTALS': {
      const fractals = calculateFractals(candles, indicator.params.depth);
      return createIndicatorOutput(indicator, fractals.upper, [
        createMarkerSeries(indicator, 'upper', 'Upper Fractal', fractals.upper, '#60a5fa', 'triangle-down'),
        createMarkerSeries(indicator, 'lower', 'Lower Fractal', fractals.lower, '#22c55e', 'triangle-up'),
      ]);
    }
    case 'RSI': {
      const values = calculateRsi(closes, indicator.params.period);
      return createIndicatorOutput(indicator, values, [
        createLineSeries(indicator, 'main', getIndicatorLabel(indicator), values, indicator.color),
      ], {
        min: 0,
        max: 100,
        guides: [Number(indicator.params.ob || 70), 50, Number(indicator.params.os || 30)],
      });
    }
    case 'STOCHASTIC': {
      const stochastic = calculateStochastic(candles, indicator.params.period, indicator.params.slowing, indicator.params.signal);
      return createIndicatorOutput(indicator, stochastic.main, [
        createLineSeries(indicator, 'k', '%K', stochastic.main, indicator.color),
        createLineSeries(indicator, 'd', '%D', stochastic.signal, '#f97316'),
      ], {
        min: 0,
        max: 100,
        guides: [Number(indicator.params.ob || 80), 50, Number(indicator.params.os || 20)],
      });
    }
    case 'ATR': {
      const values = calculateAtr(candles, indicator.params.period);
      return createIndicatorOutput(indicator, values, [
        createLineSeries(indicator, 'main', getIndicatorLabel(indicator), values, indicator.color),
      ], { min: 0 });
    }
    case 'CCI': {
      const values = calculateCci(candles, indicator.params.period);
      return createIndicatorOutput(indicator, values, [
        createLineSeries(indicator, 'main', getIndicatorLabel(indicator), values, indicator.color),
      ], {
        min: -250,
        max: 250,
        guides: [100, 0, -100],
      });
    }
    case 'ADX': {
      const adx = calculateAdx(candles, indicator.params.period);
      return createIndicatorOutput(indicator, adx.adx, [
        createLineSeries(indicator, 'adx', 'ADX', adx.adx, indicator.color),
        createLineSeries(indicator, 'plus', '+DI', adx.plusDi, '#22c55e'),
        createLineSeries(indicator, 'minus', '-DI', adx.minusDi, '#ef4444'),
      ], {
        min: 0,
        max: 100,
        guides: [20, 40, 60],
      });
    }
    case 'MOMENTUM': {
      const values = calculateMomentum(closes, indicator.params.period);
      return createIndicatorOutput(indicator, values, [
        createLineSeries(indicator, 'main', getIndicatorLabel(indicator), values, indicator.color),
      ], {
        min: 80,
        max: 120,
        guides: [100],
      });
    }
    case 'DEMARKER': {
      const values = calculateDeMarker(candles, indicator.params.period);
      return createIndicatorOutput(indicator, values, [
        createLineSeries(indicator, 'main', getIndicatorLabel(indicator), values, indicator.color),
      ], {
        min: 0,
        max: 1,
        guides: [0.7, 0.5, 0.3],
      });
    }
    case 'WILLIAMS_R': {
      const values = calculateWilliamsR(candles, indicator.params.period);
      return createIndicatorOutput(indicator, values, [
        createLineSeries(indicator, 'main', getIndicatorLabel(indicator), values, indicator.color),
      ], {
        min: -100,
        max: 0,
        guides: [-20, -50, -80],
      });
    }
    case 'STDDEV': {
      const values = calculateStdDev(closes, indicator.params.period);
      return createIndicatorOutput(indicator, values, [
        createLineSeries(indicator, 'main', getIndicatorLabel(indicator), values, indicator.color),
      ], { min: 0 });
    }
    case 'BULLS_POWER': {
      const values = calculateBullsPower(candles, indicator.params.period);
      return createIndicatorOutput(indicator, values, [
        createHistogramSeries(indicator, 'main', getIndicatorLabel(indicator), values, '#22c55e', '#ef4444', 0),
      ], { guides: [0] });
    }
    case 'BEARS_POWER': {
      const values = calculateBearsPower(candles, indicator.params.period);
      return createIndicatorOutput(indicator, values, [
        createHistogramSeries(indicator, 'main', getIndicatorLabel(indicator), values, '#22c55e', '#ef4444', 0),
      ], { guides: [0] });
    }
    case 'MACD': {
      const macd = calculateMacd(closes, indicator.params.fast, indicator.params.slow, indicator.params.signal);
      return createIndicatorOutput(indicator, macd.main, [
        createHistogramSeries(indicator, 'main', 'MACD', macd.main, '#cbd5e1', '#64748b', 0),
        createLineSeries(indicator, 'signal', 'Signal', macd.signal, '#f87171'),
      ], { guides: [0] });
    }
    case 'OSMA': {
      const macd = calculateMacd(closes, indicator.params.fast, indicator.params.slow, indicator.params.signal);
      return createIndicatorOutput(indicator, macd.histogram, [
        createHistogramSeries(indicator, 'main', getIndicatorLabel(indicator), macd.histogram, '#34d399', '#ef4444', 0),
      ], { guides: [0] });
    }
    case 'AO': {
      const values = calculateAwesomeOscillator(candles);
      return createIndicatorOutput(indicator, values, [
        createHistogramSeries(indicator, 'main', getIndicatorLabel(indicator), values, '#22c55e', '#ef4444', 0),
      ], { guides: [0] });
    }
    case 'MFI': {
      const values = calculateMfi(candles, indicator.params.period);
      return createIndicatorOutput(indicator, values, [
        createLineSeries(indicator, 'main', getIndicatorLabel(indicator), values, indicator.color),
      ], {
        min: 0,
        max: 100,
        guides: [Number(indicator.params.ob || 80), 50, Number(indicator.params.os || 20)],
      });
    }
    case 'TRIX': {
      const values = calculateTrix(closes, indicator.params.period);
      return createIndicatorOutput(indicator, values, [
        createLineSeries(indicator, 'main', getIndicatorLabel(indicator), values, indicator.color),
      ], { guides: [0] });
    }
    case 'SWING_HIGH': {
      const period = Math.max(1, Number(indicator.params.period) || 5);
      const highs = candles.map((candle) => candle.high);
      const values = highs.map((_, index) => {
        if (index < period) return null;
        let max = -Infinity;
        for (let i = index - period; i < index; i += 1) max = Math.max(max, highs[i]);
        return max;
      });
      return createIndicatorOutput(indicator, values, [createLineSeries(indicator, 'main', getIndicatorLabel(indicator), values, indicator.color)]);
    }
    case 'SWING_LOW': {
      const period = Math.max(1, Number(indicator.params.period) || 5);
      const lows = candles.map((candle) => candle.low);
      const values = lows.map((_, index) => {
        if (index < period) return null;
        let min = Infinity;
        for (let i = index - period; i < index; i += 1) min = Math.min(min, lows[i]);
        return min;
      });
      return createIndicatorOutput(indicator, values, [createLineSeries(indicator, 'main', getIndicatorLabel(indicator), values, indicator.color)]);
    }
    default:
      return createIndicatorOutput(indicator, closes, [
        createLineSeries(indicator, 'main', getIndicatorLabel(indicator), closes, indicator.color),
      ]);
  }
}

// Indicator types that can be applied to another indicator's data (MT5's "apply to" for a
// moving average dropped into a subwindow). Restricted to iMA-native methods so the MQ5
// export can chain the target handle as the applied price.
const APPLY_TO_INDICATOR_TYPES = new Set(['EMA', 'SMA', 'WMA', 'LWMA', 'SMMA']);

// Returns the id of the indicator this MA is applied to, or null when it applies to price.
function getAppliedIndicatorTargetId(indicator) {
  if (!indicator || !APPLY_TO_INDICATOR_TYPES.has(indicator.type)) {
    return null;
  }
  const target = indicator.applyTo;
  return typeof target === 'string' && target && target !== 'price' ? target : null;
}

// Runs a moving-average calculation over a series that may have an invalid warm-up head
// (applied-to-indicator sources like RSI start as nulls): the head stays null and the
// calculation only sees the valid tail. With a fully valid series this is calculate(values).
function calculateOverSeries(values, calculate) {
  let first = 0;
  while (first < values.length && !(values[first] !== null && values[first] !== undefined && Number.isFinite(values[first]))) {
    first += 1;
  }
  if (first === 0) {
    return calculate(values);
  }
  if (first >= values.length) {
    return values.map(() => null);
  }
  return [...Array(first).fill(null), ...calculate(values.slice(first))];
}

function getIndicatorOutputs(indicators, candles) {
  const indicatorOutputs = {};
  const indicatorMap = {};
  const register = (indicator, output) => {
    indicatorOutputs[indicator.id] = output;
    indicatorMap[indicator.id] = output.primary;
    output.series.forEach((series) => {
      const seriesKey = series.id.startsWith(`${indicator.id}_`)
        ? series.id.slice(indicator.id.length + 1)
        : series.id;
      indicatorMap[`${indicator.id}:${seriesKey}`] = series.values;
    });
  };
  // Two passes so an applied MA's target series always exists before the MA is computed,
  // regardless of the order indicators were added in.
  indicators.filter((indicator) => !getAppliedIndicatorTargetId(indicator)).forEach((indicator) => {
    register(indicator, buildIndicatorOutput(indicator, candles));
  });
  indicators.filter((indicator) => getAppliedIndicatorTargetId(indicator)).forEach((indicator) => {
    const target = indicatorOutputs[getAppliedIndicatorTargetId(indicator)];
    const source = Array.isArray(target?.primary) ? target.primary : null;
    register(indicator, buildIndicatorOutput(indicator, candles, source));
  });
  return { indicatorOutputs, indicatorMap };
}

function resolveOperandValue(operandId, context, index) {
  const candle = context?.candles?.[index];
  if (!candle) {
    return null;
  }
  switch (operandId) {
    case 'open':
      return candle.open;
    case 'high':
      return candle.high;
    case 'low':
      return candle.low;
    case 'close':
      return candle.close;
    default:
      return context.indicatorMap[operandId]?.[index] ?? null;
  }
}

function getStrategyOffsetHours(rules) {
  if (rules?.timezoneMode === 'broker') {
    return 0;
  }
  const brokerOffsetHours = Number(rules?.brokerUtcOffsetHours) || 0;
  if (rules?.timezoneMode === 'custom') {
    return (Number(rules.customUtcOffsetHours) || 0) - brokerOffsetHours;
  }
  return -brokerOffsetHours;
}

function getStrategyTimestamp(timestamp, rules) {
  return timestamp + (getStrategyOffsetHours(rules) * 3600000);
}

function getStrategyDate(timestamp, rules) {
  return new Date(getStrategyTimestamp(timestamp, rules));
}

function getStrategyDayKey(timestamp, rules) {
  const date = getStrategyDate(timestamp, rules);
  return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')}`;
}

function getStrategyMinutesOfDay(timestamp, rules) {
  const date = getStrategyDate(timestamp, rules);
  return (date.getUTCHours() * 60) + date.getUTCMinutes();
}

function getStrategyDayIndex(timestamp, rules) {
  return getStrategyDate(timestamp, rules).getUTCDay();
}

function isDayAllowed(timestamp, dayFilters, rules) {
  if (!Array.isArray(dayFilters) || !dayFilters.length) {
    return true;
  }
  const dayIndex = getStrategyDayIndex(timestamp, rules);
  return dayFilters.some((day) => DAY_FILTER_OPTIONS.find((option) => option.id === day)?.index === dayIndex);
}

function evaluateOperator(operator, leftCurrent, leftPrevious, rightCurrent, rightPrevious) {
  if ([leftCurrent, rightCurrent].some((value) => value === null || Number.isNaN(value))) {
    return false;
  }
  switch (operator) {
    case 'crossesAbove':
      return leftPrevious !== null && rightPrevious !== null && leftPrevious <= rightPrevious && leftCurrent > rightCurrent;
    case 'crossesBelow':
      return leftPrevious !== null && rightPrevious !== null && leftPrevious >= rightPrevious && leftCurrent < rightCurrent;
    case 'greaterThan':
      return leftCurrent > rightCurrent;
    case 'greaterOrEqual':
      return leftCurrent >= rightCurrent;
    case 'lessThan':
      return leftCurrent < rightCurrent;
    case 'lessOrEqual':
      return leftCurrent <= rightCurrent;
    default:
      return false;
  }
}

function evaluateCondition(condition, contexts, baseCandleTime, baseTimeframe) {
  const timeframe = getResolvedConditionTimeframe(condition, baseTimeframe);
  const context = contexts[timeframe];
  if (!context?.candles?.length) {
    return false;
  }

  const anchor = findLastOpenCandleIndex(context.openTimes, baseCandleTime);
  if (anchor < 0) {
    return false;
  }

  const leftIndex = anchor - getConditionShiftValue(condition.leftShift);
  const leftPreviousIndex = leftIndex - 1;
  const rightIndex = anchor - getConditionShiftValue(condition.rightShift);
  const rightPreviousIndex = rightIndex - 1;
  const leftCurrent = resolveOperandValue(condition.left, context, leftIndex);
  const leftPrevious = resolveOperandValue(condition.left, context, leftPreviousIndex);
  const rightCurrent = condition.rightMode === 'value'
    ? Number(condition.rightValue)
    : resolveOperandValue(condition.rightOperand, context, rightIndex);
  const rightPrevious = condition.rightMode === 'value'
    ? Number(condition.rightValue)
    : resolveOperandValue(condition.rightOperand, context, rightPreviousIndex);
  if (condition.rightMode === 'value' && Number.isNaN(rightCurrent)) {
    return false;
  }
  return evaluateOperator(condition.operator, leftCurrent, leftPrevious, rightCurrent, rightPrevious);
}

function evaluateConditionGroup(conditions, mode, contexts, baseCandleTime, baseTimeframe) {
  if (!conditions.length) {
    return false;
  }
  const evaluations = conditions.map((condition) => evaluateCondition(condition, contexts, baseCandleTime, baseTimeframe));
  return mode === 'any' ? evaluations.some(Boolean) : evaluations.every(Boolean);
}

function isSessionActive(time, sessions, rules) {
  if (!sessions.length) {
    return true;
  }
  const hour = getStrategyDate(time, rules).getUTCHours();
  return sessions.some((sessionId) => {
    const session = SESSION_OPTIONS.find((item) => item.id === sessionId);
    if (!session) {
      return false;
    }
    if (session.start < session.end) {
      return hour >= session.start && hour < session.end;
    }
    return hour >= session.start || hour < session.end;
  });
}

function chooseIntrabarExit(position, candle) {
  const hasStop = Number.isFinite(position.stop);
  const hasTarget = Number.isFinite(position.target);
  if (position.side === 'long') {
    const low = candle.bidLow ?? candle.low;
    const high = candle.bidHigh ?? candle.high;
    const open = candle.bidOpen ?? candle.open;
    if (hasStop && open <= position.stop) {
      return { price: position.stop, reason: 'SL' };
    }
    if (hasTarget && open >= position.target) {
      return { price: position.target, reason: 'TP' };
    }
    const stopHit = hasStop && low <= position.stop;
    const targetHit = hasTarget && high >= position.target;
    if (stopHit && targetHit) {
      return open - position.stop < position.target - open
        ? { price: position.stop, reason: 'SL' }
        : { price: position.target, reason: 'TP' };
    }
    if (stopHit) {
      return { price: position.stop, reason: 'SL' };
    }
    if (targetHit) {
      return { price: position.target, reason: 'TP' };
    }
    return null;
  }
  const high = candle.askHigh ?? candle.high;
  const low = candle.askLow ?? candle.low;
  const open = candle.askOpen ?? candle.open;
  if (hasStop && open >= position.stop) {
    return { price: position.stop, reason: 'SL' };
  }
  if (hasTarget && open <= position.target) {
    return { price: position.target, reason: 'TP' };
  }
  const stopHit = hasStop && high >= position.stop;
  const targetHit = hasTarget && low <= position.target;
  if (stopHit && targetHit) {
    return position.stop - open < open - position.target
      ? { price: position.stop, reason: 'SL' }
      : { price: position.target, reason: 'TP' };
  }
  if (stopHit) {
    return { price: position.stop, reason: 'SL' };
  }
  if (targetHit) {
    return { price: position.target, reason: 'TP' };
  }
  return null;
}

function chooseBarOpenExit(position, candle) {
  const hasStop = Number.isFinite(position.stop);
  const hasTarget = Number.isFinite(position.target);
  if (position.side === 'long') {
    const open = candle.bidOpen ?? candle.open;
    if (hasStop && open <= position.stop) {
      return { price: position.stop, reason: 'SL' };
    }
    if (hasTarget && open >= position.target) {
      return { price: position.target, reason: 'TP' };
    }
    return null;
  }
  const open = candle.askOpen ?? candle.open;
  if (hasStop && open >= position.stop) {
    return { price: position.stop, reason: 'SL' };
  }
  if (hasTarget && open <= position.target) {
    return { price: position.target, reason: 'TP' };
  }
  return null;
}

function buildTickSnapshot(tick, spreadPoints, profile) {
  const bid = Number(tick?.bid);
  const ask = Number(tick?.ask);
  if (Number.isFinite(bid) && Number.isFinite(ask) && ask >= bid) {
    return { bid, ask };
  }
  const quote = Number(tick?.quote ?? tick?.price);
  if (!Number.isFinite(quote)) {
    return null;
  }
  // Bid-based like the bars: the derived quote is the bid, ask = bid + full spread.
  const spread = Math.max(0, Number(spreadPoints) || 0) * profile.point;
  return {
    bid: quote,
    ask: quote + spread,
  };
}

function buildExecutionTickBuckets(executionTicks, executionTimeframe) {
  const bucketMs = Math.max(60000, getTimeframeMs(executionTimeframe));
  const buckets = new Map();
  for (const tick of Array.isArray(executionTicks) ? executionTicks : []) {
    const tickTime = Number(tick?.time);
    if (!Number.isFinite(tickTime)) {
      continue;
    }
    const bucketTime = Math.floor(tickTime / bucketMs) * bucketMs;
    if (!buckets.has(bucketTime)) {
      buckets.set(bucketTime, []);
    }
    buckets.get(bucketTime).push(tick);
  }
  return buckets;
}

function chooseTickExit(position, ticks, spreadPoints, profile) {
  if (!Array.isArray(ticks) || !ticks.length) {
    return null;
  }
  const hasStop = Number.isFinite(position.stop);
  const hasTarget = Number.isFinite(position.target);
  for (const tick of ticks) {
    const snapshot = buildTickSnapshot(tick, spreadPoints, profile);
    if (!snapshot) {
      continue;
    }
    if (position.side === 'long') {
      if (hasStop && snapshot.bid <= position.stop) {
        return { price: snapshot.bid, reason: 'SL' };
      }
      if (hasTarget && snapshot.bid >= position.target) {
        return { price: snapshot.bid, reason: 'TP' };
      }
      continue;
    }
    if (hasStop && snapshot.ask >= position.stop) {
      return { price: snapshot.ask, reason: 'SL' };
    }
    if (hasTarget && snapshot.ask <= position.target) {
      return { price: snapshot.ask, reason: 'TP' };
    }
  }
  return null;
}

function isMarketReopenExecutionBar(candle, previousCandle, executionTimeframe) {
  if (!previousCandle) {
    return false;
  }
  return Number(candle.time) - Number(previousCandle.time) > getTimeframeMs(executionTimeframe);
}

function applyManagedStops(position, candle, rules, profile, structureLevels = null) {
  const trailingStopPoints = Math.max(0, Number(rules.trailingStop) || 0);
  const breakEvenTriggerPoints = Math.max(0, Number(rules.breakEvenTrigger) || 0);
  const breakEvenOffsetPoints = Math.max(0, Number(rules.breakEvenOffset) || 0);
  const stopLevelPoints = Math.max(0, Number(position.stopLevelPoints) || 0);
  const freezeLevelPoints = Math.max(0, Number(position.freezeLevelPoints) || 0);
  // Structure trailing: ratchet the stop to the most recent swing low (long) / high (short)
  // once price has moved past entry, so the stop follows market structure, not a fixed gap.
  const structureTrailingEnabled = Boolean(rules.structureTrailingEnabled);
  const structureBuffer = Math.max(0, Number(rules.structureTrailingBuffer) || 0) * profile.point;
  const swingLow = structureLevels ? structureLevels.swingLow : null;
  const swingHigh = structureLevels ? structureLevels.swingHigh : null;

  if (position.side === 'long') {
    const currentBid = candle.bidOpen ?? candle.bidClose ?? candle.close;
    let nextStop = Number.isFinite(position.stop) ? position.stop : null;
    if (breakEvenTriggerPoints > 0) {
      const currentMove = (currentBid - position.entry) / profile.point;
      if (currentMove >= breakEvenTriggerPoints) {
        const candidate = position.entry + (breakEvenOffsetPoints * profile.point);
        nextStop = nextStop === null ? candidate : Math.max(nextStop, candidate);
      }
    }
    if (trailingStopPoints > 0) {
      const currentMove = (currentBid - position.entry) / profile.point;
      if (currentMove >= trailingStopPoints) {
        const candidate = currentBid - (trailingStopPoints * profile.point);
        nextStop = nextStop === null ? candidate : Math.max(nextStop, candidate);
      }
    }
    if (structureTrailingEnabled && Number.isFinite(swingLow) && swingLow < currentBid) {
      const candidate = swingLow - structureBuffer;
      if (candidate < currentBid) {
        nextStop = nextStop === null ? candidate : Math.max(nextStop, candidate);
      }
    }
    if (nextStop === null) {
      return;
    }
    if (Number.isFinite(position.target)) {
      nextStop = Math.min(nextStop, position.target);
    }
    const clamped = clampStopForBroker('long', nextStop, currentBid, profile, stopLevelPoints, freezeLevelPoints);
    if (clamped !== null && (!Number.isFinite(position.stop) || clamped > position.stop)) {
      position.stop = Number.isFinite(position.target) ? Math.min(clamped, position.target) : clamped;
    }
    return;
  }

  const currentAsk = candle.askOpen ?? candle.askClose ?? candle.close;
  let nextStop = Number.isFinite(position.stop) ? position.stop : null;
  if (breakEvenTriggerPoints > 0) {
    const currentMove = (position.entry - currentAsk) / profile.point;
    if (currentMove >= breakEvenTriggerPoints) {
      const candidate = position.entry - (breakEvenOffsetPoints * profile.point);
      nextStop = nextStop === null ? candidate : Math.min(nextStop, candidate);
    }
  }
  if (trailingStopPoints > 0) {
    const currentMove = (position.entry - currentAsk) / profile.point;
    if (currentMove >= trailingStopPoints) {
      const candidate = currentAsk + (trailingStopPoints * profile.point);
      nextStop = nextStop === null ? candidate : Math.min(nextStop, candidate);
    }
  }
  if (structureTrailingEnabled && Number.isFinite(swingHigh) && swingHigh > currentAsk) {
    const candidate = swingHigh + structureBuffer;
    if (candidate > currentAsk) {
      nextStop = nextStop === null ? candidate : Math.min(nextStop, candidate);
    }
  }
  if (nextStop === null) {
    return;
  }
  if (Number.isFinite(position.target)) {
    nextStop = Math.max(nextStop, position.target);
  }
  const clamped = clampStopForBroker('short', nextStop, currentAsk, profile, stopLevelPoints, freezeLevelPoints);
  if (clamped !== null && (!Number.isFinite(position.stop) || clamped < position.stop)) {
    position.stop = Number.isFinite(position.target) ? Math.max(clamped, position.target) : clamped;
  }
}

function buildOscillatorDescriptor(indicator, output) {
  if (!indicator || !output) {
    return null;
  }
  const values = output.series.flatMap((series) => {
    const baseSeries = series.type === 'histogram'
      ? [...series.values, series.baseValue ?? 0]
      : series.values;
    return baseSeries.filter((value) => value !== null && Number.isFinite(value));
  });
  const min = output.min ?? (values.length ? Math.min(...values) : 0);
  const max = output.max ?? (values.length ? Math.max(...values) : 100);
  return {
    id: indicator.id,
    label: output.label,
    color: output.color,
    values: output.primary,
    series: output.series,
    min,
    max,
    guides: output.guides || [],
  };
}

function buildRangeBreakoutOverlay(candles, rules, profile) {
  if (!rules?.rangeBreakoutEnabled || !Array.isArray(candles) || !candles.length) {
    return null;
  }
  const rangeStartMinutes = (Math.max(0, Math.min(23, Number(rules.rangeStartHour) || 0)) * 60) + Math.max(0, Math.min(59, Number(rules.rangeStartMinute) || 0));
  const rangeEndMinutes = (Math.max(0, Math.min(23, Number(rules.rangeEndHour) || 0)) * 60) + Math.max(0, Math.min(59, Number(rules.rangeEndMinute) || 0));
  if (rangeStartMinutes > rangeEndMinutes) {
    return null;
  }

  const rangeHigh = Array(candles.length).fill(null);
  const rangeLow = Array(candles.length).fill(null);
  const longBarrier = Array(candles.length).fill(null);
  const shortBarrier = Array(candles.length).fill(null);
  const buffer = Math.max(0, Number(rules.rangeBreakoutBuffer) || 0) * (profile?.point || 0);
  let state = { dayKey: '', high: null, low: null, ready: false };

  candles.forEach((candle, index) => {
    const dayKey = getStrategyDayKey(candle.time, rules);
    const minuteOfDay = getStrategyMinutesOfDay(candle.time, rules);
    if (state.dayKey !== dayKey) {
      state = { dayKey, high: null, low: null, ready: false };
    }

    if (minuteOfDay >= rangeStartMinutes && minuteOfDay < rangeEndMinutes) {
      state.high = state.high === null ? candle.high : Math.max(state.high, candle.high);
      state.low = state.low === null ? candle.low : Math.min(state.low, candle.low);
    } else if (minuteOfDay >= rangeEndMinutes && state.high !== null && state.low !== null) {
      state.ready = true;
    }

    if (state.high !== null && state.low !== null && minuteOfDay >= rangeStartMinutes) {
      rangeHigh[index] = state.high;
      rangeLow[index] = state.low;
      if (state.ready && buffer > 0) {
        longBarrier[index] = state.high + buffer;
        shortBarrier[index] = state.low - buffer;
      }
    }
  });

  return {
    id: 'range_breakout_visual',
    color: '#f59e0b',
    label: 'Range Breakout',
    values: rangeHigh,
    series: [
      { id: 'range_high', label: 'Range High', color: '#f59e0b', values: rangeHigh, strokeWidth: 1.6, dashArray: '5 4' },
      { id: 'range_low', label: 'Range Low', color: '#f97316', values: rangeLow, strokeWidth: 1.6, dashArray: '5 4' },
      { id: 'range_long_barrier', label: 'Long Breakout', color: '#22c55e', values: longBarrier, strokeWidth: 1.2, dashArray: '2 5' },
      { id: 'range_short_barrier', label: 'Short Breakout', color: '#ef4444', values: shortBarrier, strokeWidth: 1.2, dashArray: '2 5' },
    ],
  };
}

function createProfitByDayTemplate() {
  return DAY_FILTER_OPTIONS.map((day) => ({
    id: day.id,
    label: day.label,
    index: day.index,
    pnl: 0,
    trades: 0,
    wins: 0,
    losses: 0,
  }));
}

function createEntriesByHourTemplate() {
  return Array.from({ length: 24 }, (_, hour) => ({
    hour,
    label: `${String(hour).padStart(2, '0')}:00`,
    entries: 0,
    buyEntries: 0,
    sellEntries: 0,
    wins: 0,
    losses: 0,
    pnl: 0,
  }));
}

// Draws the actual structure being broken for entry, for every structural-breakout ref:
// prev day/week High & Low, the Donchian channel, or the ATR volatility bands. Recomputes
// the same barriers the engine uses (on the chart candles) so the lines match the signals.
function buildStructuralBreakoutOverlay(candles, rules, profile) {
  if (!rules?.structuralBreakoutEnabled || !Array.isArray(candles) || !candles.length) {
    return null;
  }
  const ref = ['prevDayHL', 'prevWeekHL', 'donchian', 'atrVolatility'].includes(rules.structuralBreakoutRef)
    ? rules.structuralBreakoutRef
    : 'prevDayHL';
  const point = profile?.point || 0;
  const buffer = Math.max(0, Number(rules.structuralBreakoutBuffer) || 0) * point;
  const upper = Array(candles.length).fill(null);
  const lower = Array(candles.length).fill(null);

  if (ref === 'prevDayHL' || ref === 'prevWeekHL') {
    const keyOf = (time) => {
      if (ref === 'prevWeekHL') {
        const d = getStrategyDate(time, rules);
        const isoDay = (d.getUTCDay() + 6) % 7;
        return String(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()) - (isoDay * 86400000));
      }
      return getStrategyDayKey(time, rules);
    };
    let state = { key: null, curHigh: null, curLow: null, prevHigh: null, prevLow: null };
    candles.forEach((candle, index) => {
      const key = keyOf(candle.time);
      if (state.key !== key) {
        state = { key, curHigh: candle.high, curLow: candle.low, prevHigh: state.curHigh, prevLow: state.curLow };
      } else {
        state.curHigh = Math.max(state.curHigh, candle.high);
        state.curLow = Math.min(state.curLow, candle.low);
      }
      if (state.prevHigh !== null && state.prevLow !== null) {
        upper[index] = state.prevHigh + buffer;
        lower[index] = state.prevLow - buffer;
      }
    });
  } else if (ref === 'donchian') {
    const n = Math.max(2, Math.trunc(Number(rules.donchianPeriod) || 20));
    candles.forEach((candle, index) => {
      const start = index - n;
      if (start < 0) return;
      let hi = -Infinity;
      let lo = Infinity;
      for (let k = start; k < index; k += 1) {
        hi = Math.max(hi, candles[k].high);
        lo = Math.min(lo, candles[k].low);
      }
      if (Number.isFinite(hi) && Number.isFinite(lo)) {
        upper[index] = hi + buffer;
        lower[index] = lo - buffer;
      }
    });
  } else if (ref === 'atrVolatility') {
    const p = Math.max(2, Math.trunc(Number(rules.atrBreakoutPeriod) || 14));
    const mult = Math.max(0, Number(rules.atrBreakoutMultiple) || 1.5);
    candles.forEach((candle, index) => {
      const start = index - p;
      if (start < 1) return;
      let trSum = 0;
      let cnt = 0;
      for (let k = start; k < index; k += 1) {
        const c = candles[k];
        const pc = candles[k - 1];
        trSum += Math.max(c.high - c.low, Math.abs(c.high - pc.close), Math.abs(c.low - pc.close));
        cnt += 1;
      }
      if (cnt) {
        const atr = trSum / cnt;
        const prevClose = candles[index - 1].close;
        upper[index] = prevClose + (mult * atr); // ATR bands carry no extra buffer (matches engine)
        lower[index] = prevClose - (mult * atr);
      }
    });
  }

  const labels = {
    prevDayHL: ['Prev Day High', 'Prev Day Low'],
    prevWeekHL: ['Prev Week High', 'Prev Week Low'],
    donchian: ['Donchian Upper', 'Donchian Lower'],
    atrVolatility: ['ATR Upper Band', 'ATR Lower Band'],
  }[ref];

  return {
    id: 'structural_breakout_visual',
    color: '#a855f7',
    label: 'Structural Breakout',
    values: upper,
    series: [
      { id: 'structural_upper', label: labels[0], color: '#22c55e', values: upper, strokeWidth: 1.4, dashArray: '4 4' },
      { id: 'structural_lower', label: labels[1], color: '#ef4444', values: lower, strokeWidth: 1.4, dashArray: '4 4' },
    ],
  };
}

function aggregateEquityPointsByTimeframe(equityPoints, timeframe) {
  const timeframeMs = getTimeframeMs(timeframe);
  const aggregated = [];
  let current = null;
  (equityPoints || []).forEach((point) => {
    const bucketTime = Math.floor(Number(point.time || 0) / timeframeMs) * timeframeMs;
    if (!current || current.bucketTime !== bucketTime) {
      current = { bucketTime, point };
      aggregated.push(current);
      return;
    }
    current.point = point;
  });
  return aggregated.map((bucket) => bucket.point);
}

function calculateMt5StyleSharpe(equityPoints, timeframe) {
  const sampledEquity = aggregateEquityPointsByTimeframe(equityPoints, timeframe);
  const returns = [];
  for (let index = 1; index < sampledEquity.length; index += 1) {
    const previousEquity = Number(sampledEquity[index - 1]?.equity);
    const currentEquity = Number(sampledEquity[index]?.equity);
    if (previousEquity > 0 && currentEquity > 0) {
      returns.push(Math.log(currentEquity / previousEquity));
    }
  }
  if (returns.length < 2) {
    return 0;
  }
  const averageReturn = returns.reduce((sum, value) => sum + value, 0) / returns.length;
  const variance = returns.reduce((sum, value) => sum + ((value - averageReturn) ** 2), 0) / returns.length;
  const deviation = Math.sqrt(variance);
  return deviation ? (averageReturn / deviation) * Math.sqrt(returns.length) : 0;
}

function buildSummary(engine, currentBar) {
  const trades = engine.trades.filter((trade) => trade.exitIndex <= currentBar);
  const visibleEquity = engine.equity.filter((point) => point.index <= currentBar);
  const equityPoint = visibleEquity[Math.max(0, visibleEquity.length - 1)] || engine.equity[engine.equity.length - 1];
  const wins = trades.filter((trade) => trade.pnl > 0);
  const losses = trades.filter((trade) => trade.pnl <= 0);
  const grossProfit = wins.reduce((sum, trade) => sum + trade.pnl, 0);
  const grossLoss = losses.reduce((sum, trade) => sum + Math.abs(trade.pnl), 0);
  const averagePnl = trades.length ? trades.reduce((sum, trade) => sum + trade.pnl, 0) / trades.length : 0;
  const maxDrawdown = visibleEquity.reduce((maxValue, point) => Math.max(maxValue, point.drawdown), 0);
  let runningPeak = engine.initialBalance;
  let maxDrawdownValue = 0;
  visibleEquity.forEach((point) => {
    runningPeak = Math.max(runningPeak, point.equity);
    maxDrawdownValue = Math.max(maxDrawdownValue, runningPeak - point.equity);
  });
  const monthly = monthTemplate();
  const profitByDay = createProfitByDayTemplate();
  const entriesByHour = createEntriesByHourTemplate();
  let consecutiveWins = 0;
  let consecutiveLosses = 0;
  let maxConsecutiveWins = 0;
  let maxConsecutiveLosses = 0;
  let totalBarsHeld = 0;
  let totalDurationMinutes = 0;

  trades.forEach((trade) => {
    monthly[new Date(trade.exitTime).getUTCMonth()] += trade.pnl;
    const exitDayIndex = getStrategyDayIndex(trade.exitTime, engine.rules);
    const dayBucket = profitByDay.find((day) => day.index === exitDayIndex);
    if (dayBucket) {
      dayBucket.pnl += trade.pnl;
      dayBucket.trades += 1;
      if (trade.pnl > 0) {
        dayBucket.wins += 1;
      } else {
        dayBucket.losses += 1;
      }
    }

    const entryHour = getStrategyDate(trade.entryTime, engine.rules).getUTCHours();
    const hourBucket = entriesByHour[entryHour];
    if (hourBucket) {
      hourBucket.entries += 1;
      hourBucket.pnl += trade.pnl;
      if (trade.side === 'BUY') {
        hourBucket.buyEntries += 1;
      } else {
        hourBucket.sellEntries += 1;
      }
      if (trade.pnl > 0) {
        hourBucket.wins += 1;
      } else {
        hourBucket.losses += 1;
      }
    }

    const barsHeld = Math.max(1, (trade.exitIndex - trade.entryIndex) + 1);
    totalBarsHeld += barsHeld;
    totalDurationMinutes += Math.max(0, (trade.exitTime - trade.entryTime) / 60000);

    if (trade.pnl > 0) {
      consecutiveWins += 1;
      consecutiveLosses = 0;
      maxConsecutiveWins = Math.max(maxConsecutiveWins, consecutiveWins);
    } else {
      consecutiveLosses += 1;
      consecutiveWins = 0;
      maxConsecutiveLosses = Math.max(maxConsecutiveLosses, consecutiveLosses);
    }
  });

  const buyTrades = trades.filter((trade) => trade.side === 'BUY');
  const sellTrades = trades.filter((trade) => trade.side === 'SELL');
  const largestWin = wins.length ? Math.max(...wins.map((trade) => trade.pnl)) : 0;
  const largestLoss = losses.length ? Math.min(...losses.map((trade) => trade.pnl)) : 0;
  const bestDay = profitByDay.reduce((best, day) => (day.pnl > best.pnl ? day : best), profitByDay[0] || { label: '-', pnl: 0 });
  const worstDay = profitByDay.reduce((worst, day) => (day.pnl < worst.pnl ? day : worst), profitByDay[0] || { label: '-', pnl: 0 });
  const netProfit = equityPoint.equity - engine.initialBalance;

  return {
    metrics: {
      netProfit,
      winRate: trades.length ? (wins.length / trades.length) * 100 : 0,
      maxDrawdown,
      profitFactor: grossLoss ? grossProfit / grossLoss : grossProfit,
      totalTrades: trades.length,
      sharpe: calculateMt5StyleSharpe(visibleEquity, engine.setup?.timeframe || 'H1'),
      averageWin: wins.length ? grossProfit / wins.length : 0,
      averageLoss: losses.length ? losses.reduce((sum, trade) => sum + trade.pnl, 0) / losses.length : 0,
    },
    analysis: {
      grossProfit,
      grossLoss,
      expectancy: trades.length ? netProfit / trades.length : 0,
      largestWin,
      largestLoss,
      maxConsecutiveWins,
      maxConsecutiveLosses,
      buyTrades: buyTrades.length,
      sellTrades: sellTrades.length,
      buyWinRate: buyTrades.length ? (buyTrades.filter((trade) => trade.pnl > 0).length / buyTrades.length) * 100 : 0,
      sellWinRate: sellTrades.length ? (sellTrades.filter((trade) => trade.pnl > 0).length / sellTrades.length) * 100 : 0,
      buyNetProfit: buyTrades.reduce((sum, trade) => sum + trade.pnl, 0),
      sellNetProfit: sellTrades.reduce((sum, trade) => sum + trade.pnl, 0),
      averageTrade: averagePnl,
      averageBarsHeld: trades.length ? totalBarsHeld / trades.length : 0,
      averageDurationMinutes: trades.length ? totalDurationMinutes / trades.length : 0,
      maxDrawdownValue,
      recoveryFactor: maxDrawdownValue ? netProfit / maxDrawdownValue : 0,
      bestDay,
      worstDay,
      profitByDay,
      entriesByHour,
    },
    trades,
    monthly,
    equity: visibleEquity,
  };
}

function monthTemplate() {
  return [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
}

export function simulateBacktest(setup, indicators, rawRules, sessions, marketData = null) {
  const normalizedSetup = { ...setup, symbol: ensureSymbol(setup) };
  const rules = normalizeRules(rawRules, getOperandOptions(indicators).map((option) => option.id));
  const generated = marketData ? null : generateCandles(normalizedSetup);
  const candles = marketData?.executionCandles || marketData?.candles || generated.candles;
  const contextCandles = marketData?.contextCandles || candles;
  const contextTimeframe = marketData?.contextTimeframe || normalizedSetup.timeframe;
  const executionTimeframe = marketData?.executionTimeframe || normalizedSetup.timeframe;
  const profile = marketData?.profile || generated.profile;
  const referencedTimeframes = getReferencedConditionTimeframes(rules, normalizedSetup.timeframe);
  const evaluationContexts = buildEvaluationContexts(normalizedSetup.timeframe, indicators, contextCandles, referencedTimeframes, contextTimeframe);
  const { indicatorOutputs, indicatorMap } = getIndicatorOutputs(indicators, candles);
  const longestPeriod = indicators.reduce((maxPeriod, indicator) => {
    const values = [indicator.params.period, indicator.params.fast, indicator.params.slow, indicator.params.signal]
      .map((value) => Number(value) || 1);
    return Math.max(maxPeriod, ...values);
  }, 1);
  const highestMultiplier = referencedTimeframes.reduce((maximum, timeframe) => {
    const multiplier = Math.max(1, getTimeframeMinutes(timeframe) / Math.max(1, getTimeframeMinutes(contextTimeframe)));
    return Math.max(maximum, multiplier);
  }, 1);
  const indicatorWarmupFloor = indicators.length ? 20 : 1;
  const warmupSignalStartIndex = Math.min(
    candles.length - 2,
    Math.max(indicatorWarmupFloor, Math.ceil((longestPeriod + getMaxConditionShift(rules) + 2) * highestMultiplier)),
  );
  const hasContextWarmupHistory = Array.isArray(contextCandles)
    && contextCandles.length
    && candles.length
    && Number(contextCandles[0]?.time) < Number(candles[0]?.time);
  const signalStartIndex = hasContextWarmupHistory ? 1 : warmupSignalStartIndex;
  const startIndex = rules.rangeBreakoutEnabled ? Math.min(signalStartIndex, 1) : signalStartIndex;
  const baseLotSize = Number(normalizedSetup.lotSize) || 0.1;
  // rangeBreakoutOnce: when true (default), a timed range can only be traded once — after it
  // breaks you wait for the next range. cooldownBars: ignore new entries until N signal-timeframe
  // bars have passed since the last filled entry (applies to every strategy).
  const rangeBreakoutOnce = rules.rangeBreakoutOnce !== false;
  const cooldownBars = Math.max(0, Math.trunc(Number(rules.cooldownBars) || 0));
  // Partial take-profit: close partialTpPercent% of a position once price moves partialTpPoints
  // in favour, then optionally move the stop to breakeven and let the remainder run.
  const partialTpEnabled = Boolean(rules.partialTpEnabled);
  const partialTpPoints = Math.max(0, Number(rules.partialTpPoints) || 0);
  const partialTpPercent = Math.max(1, Math.min(99, Number(rules.partialTpPercent) || 50));
  const partialTpMoveBreakeven = Boolean(rules.partialTpMoveBreakeven);
  let lastEntryTime = null;
  const initialBalance = Number(normalizedSetup.initialBalance) || 10000;
  const commissionPerLot = Math.max(0, Number(normalizedSetup.commission) || 0);
  const slippagePoints = Math.max(0, Number(normalizedSetup.slippage) || 0);
  const defaultSpreadPoints = getExecutionSpreadPoints(normalizedSetup, profile);
  const modelingMode = String(normalizedSetup.modelingMode || 'open_prices');
  const executionTickBuckets = modelingMode === 'every_tick'
    ? buildExecutionTickBuckets(marketData?.executionTicks, executionTimeframe)
    : new Map();
  const stopLevelPoints = resolveBrokerDistancePoints(
    normalizedSetup.stopLevelPoints,
    profile?.instrumentSpec?.stopsLevelPoints,
    profile?.instrumentSpec?.stopLevelPoints,
  );
  const freezeLevelPoints = resolveBrokerDistancePoints(
    normalizedSetup.freezeLevelPoints,
    profile?.instrumentSpec?.freezeLevelPoints,
  );
  // MT5-tester-style journal: records order/trade events (invalid volume, adjusted stops,
  // insufficient margin, stop-out) so the UI can surface them like the MT5 Journal tab.
  const journal = [];
  const JOURNAL_CAP = 1000;
  let journalTruncated = false;
  const formatLot = (value) => Number(value || 0).toFixed(3).replace(/\.?0+$/, '');
  const formatMoney = (value) => Number(value || 0).toFixed(2);
  function logJournal(time, level, code, message) {
    if (journal.length >= JOURNAL_CAP) {
      journalTruncated = true;
      return;
    }
    journal.push({ time: time ?? null, level, code, message });
  }
  const stopOutLevel = Math.max(0, getFiniteNumber(normalizedSetup.stopOutLevel, profile?.instrumentSpec?.stopOutLevel) ?? 50);
  const resolveSwapPerLot = (value, fallback) => {
    if (value === '' || value === null || value === undefined) {
      const fallbackNumber = Number(fallback);
      return Number.isFinite(fallbackNumber) ? fallbackNumber : 0;
    }
    const numeric = Number(value);
    if (Number.isFinite(numeric)) {
      return numeric;
    }
    const fallbackNumber = Number(fallback);
    return Number.isFinite(fallbackNumber) ? fallbackNumber : 0;
  };
  const swapLongPerLot = resolveSwapPerLot(normalizedSetup.swapLongPerLot, profile?.instrumentSpec?.swapLongPerLot);
  const swapShortPerLot = resolveSwapPerLot(normalizedSetup.swapShortPerLot, profile?.instrumentSpec?.swapShortPerLot);
  const swapMode = normalizeSwapMode(normalizedSetup.swapMode ?? profile?.instrumentSpec?.swapMode);
  const swapTripleDay = 3;
  const stopLossInput = Number(rules.stopLoss);
  const takeProfitInput = Number(rules.takeProfit);
  const stopLossPoints = Number.isFinite(stopLossInput) ? Math.max(0, stopLossInput) : 30;
  const takeProfitPoints = Number.isFinite(takeProfitInput) ? Math.max(0, takeProfitInput) : 60;
  const martingaleFactor = Math.max(1, Number(rules.martingaleFactor) || 1);
  const martingaleMaxSteps = Math.max(0, Number(rules.martingaleMaxSteps) || 0);
  const riskMode = rules.riskMode || 'flat_lot';
  const riskAmount = Math.max(0, Number(rules.riskAmount) || 0);
  const maxOpenTrades = Math.max(1, Math.trunc(Number(rules.maxOpenTrades) || 1));
  const rangeStartMinutes = (Math.max(0, Math.min(23, Number(rules.rangeStartHour) || 0)) * 60) + Math.max(0, Math.min(59, Number(rules.rangeStartMinute) || 0));
  const rangeEndMinutes = (Math.max(0, Math.min(23, Number(rules.rangeEndHour) || 0)) * 60) + Math.max(0, Math.min(59, Number(rules.rangeEndMinute) || 0));
  const timeExitMinutes = (Math.max(0, Math.min(23, Number(rules.timeExitHour) || 0)) * 60) + Math.max(0, Math.min(59, Number(rules.timeExitMinute) || 0));
  const trades = [];
  // Risk limits, read the same way the backend reads them.
  const maxDailyLossMode = rules.maxDailyLossMode || 'off';
  const maxDailyLossValue = Math.max(0, Number(rules.maxDailyLossValue) || 0);
  const maxDrawdownPctLimit = Math.max(0, Number(rules.maxDrawdownPct) || 0);
  const maxConsecutiveLossesLimit = Math.max(0, Math.trunc(Number(rules.maxConsecutiveLosses) || 0));
  const equityProtectionEnabled = Boolean(rules.equityProtectionEnabled);
  const equityProtectionMode = rules.equityProtectionMode === 'usd' ? 'usd' : 'pct';
  const equityProtectionValue = Math.max(0, Number(rules.equityProtectionValue) || 0);

  const equity = [];
  let balance = initialBalance;
  let peakEquity = initialBalance;
  let positions = [];
  let lossStreak = 0;
  let winStreak = 0;
  // Risk-limit state. Previously absent from this copy of the engine, which meant the browser
  // replay happily opened trades the server backtest refused once a daily-loss or drawdown
  // limit had tripped — a silent divergence on any prop-firm style strategy.
  let consecutiveLosses = 0;
  let dayStartBalance = initialBalance;
  let currentDayKey = '';
  let tradingPausedRisk = false;
  let rangeState = { dayKey: '', high: null, low: null, ready: false, traded: false };
  let structuralState = { key: null, curHigh: null, curLow: null, prevHigh: null, prevLow: null };
  let structuralTradedKey = null; // period key of the last structural-breakout entry (for "trade once")
  let currentStructuralPeriodKey = null;
  let lastTimeExitDayKey = '';
  let lastProcessedSignalClosedTime = null;

  // Phase 2 overlay/filter rule values (instant-replay mirror of the server engine).
  const antiMartingaleEnabled = Boolean(rules.antiMartingaleEnabled);
  const antiMartingaleFactor = Math.max(1, Number(rules.antiMartingaleFactor) || 1);
  const antiMartingaleMaxSteps = Math.max(0, Math.trunc(Number(rules.antiMartingaleMaxSteps) || 0));
  const timedEntryEnabled = Boolean(rules.timedEntryEnabled);
  const timedEntryStartMin = (Math.max(0, Math.min(23, Number(rules.timedEntryStartHour) || 0)) * 60) + Math.max(0, Math.min(59, Number(rules.timedEntryStartMinute) || 0));
  const timedEntryEndMin = (Math.max(0, Math.min(23, Number(rules.timedEntryEndHour) || 0)) * 60) + Math.max(0, Math.min(59, Number(rules.timedEntryEndMinute) || 0));
  const breakevenOnlyEnabled = Boolean(rules.breakevenOnlyEnabled);
  const basketTpEnabled = Boolean(rules.basketTpEnabled);
  const basketTpUsd = Math.max(0, Number(rules.basketTpUsd) || 0);
  const basketSlUsd = Math.max(0, Number(rules.basketSlUsd) || 0);

  // Phase 2 trend filter — precompute the higher-timeframe MA series once.
  let trendMaSeries = null;
  let trendHtfOpenTimes = null;
  if (rules.trendFilterEnabled) {
    const chartMin = getTimeframeMinutes(normalizedSetup.timeframe);
    const tfMin = getTimeframeMinutes(rules.trendFilterTimeframe);
    const effectiveTf = tfMin >= chartMin ? rules.trendFilterTimeframe : normalizedSetup.timeframe;
    const htfCandles = aggregateCandlesToTimeframe(candles, effectiveTf);
    const closes = htfCandles.map((c) => c.close);
    const maFn = rules.trendFilterMaType === 'SMA' ? calculateSma : calculateEma;
    trendMaSeries = maFn(closes, Number(rules.trendFilterMaPeriod) || 50);
    trendHtfOpenTimes = htfCandles.map((c) => c.time);
  }

  function createMarketCandle(candle) {
    const spreadPoints = getCandleSpreadPoints(candle, defaultSpreadPoints);
    // MetaTrader bars are BID-based: the OHLC is the bid, and ask = bid + full spread.
    // Modeling it this way (rather than OHLC-as-mid with half-spread each side) makes VAB
    // fills match the exported EA's fills bar for bar.
    const spread = spreadPoints * profile.point;
    return {
      ...candle,
      spread: spreadPoints,
      bidOpen: candle.open,
      bidHigh: candle.high,
      bidLow: candle.low,
      bidClose: candle.close,
      askOpen: candle.open + spread,
      askHigh: candle.high + spread,
      askLow: candle.low + spread,
      askClose: candle.close + spread,
    };
  }

  function getBarOpenSnapshot(marketCandle, executionTicks) {
    if (Array.isArray(executionTicks) && executionTicks.length) {
      const snapshot = buildTickSnapshot(executionTicks[0], marketCandle.spread, profile);
      if (snapshot) {
        return snapshot;
      }
    }
    return {
      bid: marketCandle.bidOpen,
      ask: marketCandle.askOpen,
    };
  }

  function getBarCloseSnapshot(marketCandle, executionTicks) {
    if (Array.isArray(executionTicks) && executionTicks.length) {
      for (let index = executionTicks.length - 1; index >= 0; index -= 1) {
        const snapshot = buildTickSnapshot(executionTicks[index], marketCandle.spread, profile);
        if (snapshot) {
          return snapshot;
        }
      }
    }
    return {
      bid: marketCandle.bidClose,
      ask: marketCandle.askClose,
    };
  }

  function getOpenExecutionPrice(side, marketCandle, isExit = false, barOpenSnapshot = null) {
    const snapshot = barOpenSnapshot || {
      bid: marketCandle.bidOpen,
      ask: marketCandle.askOpen,
    };
    if (side === 'long') {
      return isExit ? snapshot.bid : snapshot.ask;
    }
    return isExit ? snapshot.ask : snapshot.bid;
  }

  function getCloseMarkPrice(side, marketCandle, barCloseSnapshot = null) {
    const snapshot = barCloseSnapshot || {
      bid: marketCandle.bidClose,
      ask: marketCandle.askClose,
    };
    return side === 'long' ? snapshot.bid : snapshot.ask;
  }

  function applySwapIfNeeded(position, candle, previousCandle) {
    if (!previousCandle) {
      position.swapDayKey = getStrategyDayKey(candle.time, rules);
      return;
    }
    const previousDayKey = getStrategyDayKey(previousCandle.time, rules);
    const currentDayKey = getStrategyDayKey(candle.time, rules);
    if (previousDayKey === currentDayKey || position.swapDayKey === currentDayKey) {
      return;
    }
    const rolloverDayIndex = getStrategyDayIndex(previousCandle.time, rules);
    if (rolloverDayIndex === 0 || rolloverDayIndex === 6) {
      position.swapDayKey = currentDayKey;
      return;
    }
    const multiplier = rolloverDayIndex === swapTripleDay ? 3 : 1;
    const swapPerLot = position.side === 'long' ? swapLongPerLot : swapShortPerLot;
    const referencePrice = Number(candle.bidClose ?? candle.close) || position.entry;
    position.accruedSwap += swapChargePerLot(swapMode, swapPerLot, profile, referencePrice) * position.lotSize * multiplier;
    position.swapDayKey = currentDayKey;
  }

  function closePosition(position, index, rawExitPrice, reason) {
    const exitPrice = applyDirectionalSlippage(rawExitPrice, position.side, profile.point, slippagePoints, true);
    const pnl = calculateRealizedPnl(position.entry, exitPrice, position.side, position.lotSize, profile)
      - position.commissionCost
      + (position.accruedSwap || 0);
    balance += pnl;
    // Capture the final stop/target on the exit bar itself. The per-bar level recorder runs
    // after close and only sees still-open positions, so a trade that trails and then exits on
    // the same bar would never record that last move — the chart then falls back to one flat
    // line at the final stop across the whole trade, making price look like it ran past a
    // stationary SL. Appending here keeps the stair-step complete.
    if (Array.isArray(position.levelHistory)) {
      const lastLevel = position.levelHistory[position.levelHistory.length - 1];
      const stopNow = position.stop ?? null;
      const targetNow = position.target ?? null;
      if (!lastLevel || lastLevel.stop !== stopNow || lastLevel.target !== targetNow) {
        position.levelHistory.push({ index, stop: stopNow, target: targetNow });
      }
    }
    trades.push({
      id: `${position.side}_${position.entryIndex}_${index}_${trades.length}`,
      side: position.side === 'long' ? 'BUY' : 'SELL',
      entry: position.entry,
      exit: exitPrice,
      pnl,
      reason,
      symbol: normalizedSetup.symbol,
      entryIndex: position.entryIndex,
      exitIndex: index,
      entryTime: position.entryTime,
      exitTime: candles[index].time,
      // Final (not initial) levels, so the chart shows what actually governed the exit —
      // script-managed targets, trailing stops, and breakeven moves included.
      stopPrice: position.stop ?? position.initialStop,
      targetPrice: position.target ?? position.initialTarget,
      initialStopPrice: position.initialStop,
      initialTargetPrice: position.initialTarget,
      levels: Array.isArray(position.levelHistory) && position.levelHistory.length > 1
        ? position.levelHistory
        : null,
    });
    lossStreak = pnl < 0 ? Math.min(martingaleMaxSteps, lossStreak + 1) : 0;
    winStreak = pnl > 0 ? Math.min(antiMartingaleMaxSteps, winStreak + 1) : 0;
    consecutiveLosses = pnl < 0 ? consecutiveLosses + 1 : 0;
  }

  // Close a FRACTION of a position at rawExitPrice (partial take-profit). Records a trade for
  // the closed volume with proportional commission/swap and shrinks the position; the remainder
  // keeps running. Returns true if the whole position ended up closed.
  function closePartial(position, index, rawExitPrice, fraction, reason) {
    const requested = position.lotSize * Math.max(0, Math.min(1, fraction));
    const closeLot = normalizeLotSizeForSpec(requested, profile.instrumentSpec);
    // Can't close a sub-minimum sliver, and closing ~all just becomes a full close.
    if (closeLot <= 0 || closeLot >= position.lotSize - 1e-9) {
      closePosition(position, index, rawExitPrice, closeLot <= 0 ? reason : 'TP');
      return true;
    }
    const exitPrice = applyDirectionalSlippage(rawExitPrice, position.side, profile.point, slippagePoints, true);
    const portion = closeLot / position.lotSize;
    const commissionPortion = (position.commissionCost || 0) * portion;
    const swapPortion = (position.accruedSwap || 0) * portion;
    const pnl = calculateRealizedPnl(position.entry, exitPrice, position.side, closeLot, profile)
      - commissionPortion
      + swapPortion;
    balance += pnl;
    trades.push({
      id: `${position.side}_${position.entryIndex}_${index}_${trades.length}`,
      side: position.side === 'long' ? 'BUY' : 'SELL',
      entry: position.entry,
      exit: exitPrice,
      pnl,
      reason,
      partial: true,
      lotSize: closeLot,
      symbol: normalizedSetup.symbol,
      entryIndex: position.entryIndex,
      exitIndex: index,
      entryTime: position.entryTime,
      exitTime: candles[index].time,
      stopPrice: position.stop ?? position.initialStop,
      targetPrice: exitPrice,
      initialStopPrice: position.initialStop,
      initialTargetPrice: position.initialTarget,
      levels: null,
    });
    position.lotSize -= closeLot;
    position.commissionCost = (position.commissionCost || 0) - commissionPortion;
    position.accruedSwap = (position.accruedSwap || 0) - swapPortion;
    return false;
  }

  // Direct port of the backend's checkRiskLimits. Returns true when trading is paused, and
  // latches `tradingPausedRisk` for the rest of the day once a limit is breached.
  function checkRiskLimits(index) {
    const candleDayKey = getStrategyDayKey(candles[index].time, rules);
    if (candleDayKey !== currentDayKey) {
      currentDayKey = candleDayKey;
      dayStartBalance = balance;
      tradingPausedRisk = false;
    }
    if (tradingPausedRisk) return true;
    const equityNow = balance + positions.reduce((sum, pos) => sum + calculateFloatingPnl(pos.entry, candles[index].close, pos.side, pos.lotSize, profile), 0);
    if (equityNow > peakEquity) peakEquity = equityNow;
    if (maxDailyLossMode !== 'off' && maxDailyLossValue > 0) {
      const threshold = maxDailyLossMode === 'pct' ? dayStartBalance * maxDailyLossValue / 100 : maxDailyLossValue;
      if (dayStartBalance - equityNow >= threshold) { tradingPausedRisk = true; return true; }
    }
    if (maxDrawdownPctLimit > 0 && peakEquity > 0) {
      const drawdown = (peakEquity - equityNow) / peakEquity * 100;
      if (drawdown >= maxDrawdownPctLimit) { tradingPausedRisk = true; return true; }
    }
    if (maxConsecutiveLossesLimit > 0 && consecutiveLosses >= maxConsecutiveLossesLimit) {
      tradingPausedRisk = true; return true;
    }
    if (equityProtectionEnabled && equityProtectionValue > 0) {
      const breached = equityProtectionMode === 'usd'
        ? equityNow <= equityProtectionValue
        : (peakEquity > 0 && ((peakEquity - equityNow) / peakEquity) * 100 >= equityProtectionValue);
      if (breached) { tradingPausedRisk = true; return true; }
    }
    return false;
  }

  function openPosition(side, index, rawEntry) {
    if (checkRiskLimits(index)) return null;
    let sizeMultiplier = rules.martingaleEnabled ? martingaleFactor ** Math.min(lossStreak, martingaleMaxSteps) : 1;
    if (antiMartingaleEnabled) sizeMultiplier *= antiMartingaleFactor ** Math.min(winStreak, antiMartingaleMaxSteps);
    let lotSize = baseLotSize * sizeMultiplier;
    if (riskMode !== 'flat_lot' && riskAmount > 0 && stopLossPoints > 0) {
      const pnlPerPointPerLot = calculateRealizedPnl(candles[index].close, candles[index].close + profile.point, 'long', 1.0, profile) || 1;
      const equity = balance + positions.reduce((sum, pos) => sum + calculateFloatingPnl(pos.entry, candles[index].close, pos.side, pos.lotSize, profile), 0);
      const baseBalance = riskMode === 'pct_equity' ? equity : balance;
      const targetRisk = riskMode === 'fixed_usd' ? riskAmount : baseBalance * riskAmount / 100;
      lotSize = targetRisk / (stopLossPoints * pnlPerPointPerLot);
    }
    const requestedLot = lotSize;
    const effectiveLotSize = normalizeLotSizeForSpec(requestedLot, profile.instrumentSpec);
    if (effectiveLotSize <= 0) {
      logJournal(candles[index].time, 'error', 'invalid_volume',
        `Order skipped: requested volume ${formatLot(requestedLot)} is invalid for this symbol.`);
      return null;
    }
    if (Math.abs(effectiveLotSize - requestedLot) > 1e-9) {
      logJournal(candles[index].time, 'warning', 'volume_adjusted',
        `Volume adjusted from ${formatLot(requestedLot)} to ${formatLot(effectiveLotSize)} to meet broker min/step/max.`);
    }
    const entry = applyDirectionalSlippage(rawEntry, side, profile.point, slippagePoints);
    const requiredMargin = estimateMarginRequired(effectiveLotSize, profile, entry);
    const usedMargin = positions.reduce((total, position) => total + estimateMarginRequired(position.lotSize, profile, position.entry), 0);
    if (requiredMargin > 0 && usedMargin + requiredMargin > Math.max(0, balance)) {
      logJournal(candles[index].time, 'error', 'not_enough_money',
        `Order skipped: insufficient margin (need ${formatMoney(requiredMargin)}, free ${formatMoney(Math.max(0, balance) - usedMargin)}).`);
      return null;
    }
    if (stopLossPoints > 0 && stopLevelPoints > 0 && stopLossPoints < stopLevelPoints) {
      logJournal(candles[index].time, 'warning', 'invalid_stops',
        `Stop loss ${stopLossPoints} pts is inside broker minimum ${stopLevelPoints} pts; widened to ${stopLevelPoints}.`);
    }
    if (!breakevenOnlyEnabled && takeProfitPoints > 0 && stopLevelPoints > 0 && takeProfitPoints < stopLevelPoints) {
      logJournal(candles[index].time, 'warning', 'invalid_stops',
        `Take profit ${takeProfitPoints} pts is inside broker minimum ${stopLevelPoints} pts; widened to ${stopLevelPoints}.`);
    }
    const effectiveStopLossPoints = stopLossPoints > 0 ? Math.max(stopLossPoints, stopLevelPoints) : 0;
    const effectiveTakeProfitPoints = breakevenOnlyEnabled ? 0 : (takeProfitPoints > 0 ? Math.max(takeProfitPoints, stopLevelPoints) : 0);
    const initialStop = effectiveStopLossPoints > 0
      ? normalizePriceToTick(
        side === 'long' ? entry - (effectiveStopLossPoints * profile.point) : entry + (effectiveStopLossPoints * profile.point),
        profile,
      )
      : null;
    const initialTarget = effectiveTakeProfitPoints > 0
      ? normalizePriceToTick(
        side === 'long' ? entry + (effectiveTakeProfitPoints * profile.point) : entry - (effectiveTakeProfitPoints * profile.point),
        profile,
      )
      : null;
    const position = {
      side,
      entry,
      lotSize: effectiveLotSize,
      entryIndex: index,
      entryTime: candles[index].time,
      initialStop,
      initialTarget,
      stop: initialStop,
      target: initialTarget,
      commissionCost: calculateCommissionCost(commissionPerLot, effectiveLotSize),
      accruedSwap: 0,
      swapDayKey: getStrategyDayKey(candles[index].time, rules),
      stopLevelPoints,
      freezeLevelPoints,
      // Bar-by-bar stop/target path (trailing, breakeven, script-managed) for the chart.
      levelHistory: [{ index, stop: initialStop, target: initialTarget }],
    };
    positions = [...positions, position];
    lastEntryTime = candles[index].time; // for the entry cooldown
    return position;
  }

  // ── Pending orders ────────────────────────────────────────────────────────
  const pendingOrderEnabled = Boolean(rules.pendingOrderEnabled);
  const pendingOffsetPoints = Math.max(0, Number(rules.pendingOffsetPoints) || 10);
  const pendingExpiryBars = Math.max(0, Math.trunc(Number(rules.pendingExpiryBars) || 0));
  const pendingIsStop = rules.pendingOrderType !== 'limit';
  const pendingDeleteOpposite = rules.pendingDeleteOpposite !== false;
  const structuralBreakoutOnce = rules.structuralBreakoutOnce === true;
  let pendingOrders = [];
  const cancelledOrders = [];

  function placePendingOrder(side, index) {
    const refPrice = candles[index].close;
    const rawPrice = pendingIsStop
      ? (side === 'long' ? refPrice + pendingOffsetPoints * profile.point : refPrice - pendingOffsetPoints * profile.point)
      : (side === 'long' ? refPrice - pendingOffsetPoints * profile.point : refPrice + pendingOffsetPoints * profile.point);
    pendingOrders.push({
      side,
      price: normalizePriceToTick(rawPrice, profile),
      placedIndex: index,
      placedTime: candles[index].time,
    });
  }

  // Phase 2 proactive breakout pending: rest a STOP order AT the breakout barrier; refresh on move.
  function syncBreakoutPending(side, barrierPrice, index, marketCandle, origin = 'structural') {
    const target = normalizePriceToTick(barrierPrice, profile);
    const ask = marketCandle.askClose ?? marketCandle.close;
    const bid = marketCandle.bidClose ?? marketCandle.close;
    const valid = side === 'long' ? ask < target : bid > target;
    const existing = pendingOrders.find((o) => o.breakout && o.side === side);
    if (existing) {
      if (valid && Math.abs(existing.price - target) < profile.point / 2) return;
      cancelledOrders.push({ ...existing, cancelIndex: index, cancelReason: 'barrier_update' });
      pendingOrders = pendingOrders.filter((o) => o !== existing);
    }
    if (!valid) return;
    pendingOrders.push({ side, type: 'stop', breakout: true, origin, price: target, placedIndex: index, placedTime: candles[index].time });
  }

  function processPendingOrders(index, marketCandle, executionTicks) {
    if (!pendingOrders.length) return;
    const nextPending = [];
    let filledSide = null;
    for (const order of pendingOrders) {
      if (pendingExpiryBars > 0 && index - order.placedIndex >= pendingExpiryBars) {
        cancelledOrders.push({ ...order, cancelIndex: index, cancelReason: 'expired' });
        continue;
      }
      const orderIsStop = order.type ? order.type === 'stop' : pendingIsStop;
      let triggered = false;
      if (order.side === 'long') {
        triggered = orderIsStop ? marketCandle.askHigh >= order.price : marketCandle.askLow <= order.price;
      } else {
        triggered = orderIsStop ? marketCandle.bidLow <= order.price : marketCandle.bidHigh >= order.price;
      }
      if (triggered && positions.length < maxOpenTrades) {
        const newPosition = openPosition(order.side, index, order.price);
        if (newPosition) {
          filledSide = order.side;
        }
        if (newPosition && rangeBreakoutOnce && order.origin === 'range') {
          rangeState.traded = true; // a range-breakout pending filled — don't re-arm this range
        }
        if (newPosition && structuralBreakoutOnce && order.origin === 'structural') {
          structuralTradedKey = currentStructuralPeriodKey; // structural pending filled — don't re-arm this period
        }
        if (newPosition) {
          const sameBarExit = modelingMode === 'every_tick' && executionTicks.length
            ? chooseTickExit(newPosition, executionTicks, marketCandle.spread, profile) || chooseIntrabarExit(newPosition, marketCandle)
            : chooseIntrabarExit(newPosition, marketCandle);
          if (sameBarExit) {
            closePosition(newPosition, index, sameBarExit.price, sameBarExit.reason);
            positions = positions.filter((p) => p !== newPosition);
          }
        }
      } else {
        nextPending.push(order);
      }
    }
    pendingOrders = nextPending;
    // OCO: once a pending order triggers, cancel the still-resting opposite-side pending(s).
    if (pendingDeleteOpposite && filledSide) {
      pendingOrders = pendingOrders.filter((o) => {
        if (o.side !== filledSide) {
          cancelledOrders.push({ ...o, cancelIndex: index, cancelReason: 'oco' });
          return false;
        }
        return true;
      });
    }
  }

  // ── Grid / DCA ────────────────────────────────────────────────────────────
  const gridEnabled = Boolean(rules.gridEnabled);
  const freeGrid = gridEnabled && rules.indicatorEntriesEnabled === false && !rules.rangeBreakoutEnabled;
  const gridOrderCount = Math.max(2, Math.trunc(Number(rules.gridOrderCount) || 3));
  const gridSpacingPoints = Math.max(1, Number(rules.gridSpacingPoints) || 30);
  const gridLotMultiplier = Math.max(1, Number(rules.gridLotMultiplier) || 1);
  const gridBasketTpPoints = Math.max(0, Number(rules.gridBasketTpPoints) || 0);
  const gridBasketSlPoints = Math.max(0, Number(rules.gridBasketSlPoints) || 0);

  function placeGridOrders(side, index, marketCandle, barOpenSnapshot) {
    const baseFill = getOpenExecutionPrice(side, marketCandle, false, barOpenSnapshot);
    // The grid's own gridOrderCount is the intended concurrency — maxOpenTrades is a
    // single-entry cap and must not throttle the grid to one order. Re-entry of a fresh
    // grid is already gated by the freeGrid longCount/shortCount guards.
    const martingaleMultiplier = rules.martingaleEnabled
      ? martingaleFactor ** Math.min(lossStreak, martingaleMaxSteps)
      : 1;
    for (let level = 0; level < gridOrderCount; level += 1) {
      const levelOffset = level * gridSpacingPoints * profile.point;
      const fillPrice = side === 'long' ? baseFill - levelOffset : baseFill + levelOffset;
      // Each deeper grid level scales by gridLotMultiplier; martingale-on-loss scales the
      // whole basket. A grid-martingale uses gridLotMultiplier > 1 for per-level growth.
      const levelLot = normalizeLotSizeForSpec(
        baseLotSize * (gridLotMultiplier ** level) * martingaleMultiplier,
        profile.instrumentSpec,
      );
      if (levelLot <= 0) break;
      const pos = openPosition(side, index, fillPrice);
      if (pos) {
        pos.lotSize = levelLot;
        pos.gridLevel = level;
      }
    }
  }

  // Phase 2 basket TP/SL (non-grid): close ALL positions together when combined floating P/L
  // (USD) reaches +basketTpUsd or -basketSlUsd. Works with any entry model.
  function checkBasketExit(index, marketCandle, barCloseSnapshot) {
    if (!basketTpEnabled || !positions.length) return;
    if (basketTpUsd <= 0 && basketSlUsd <= 0) return;
    const basketPnl = positions.reduce((sum, p) => (
      sum + calculateFloatingPnl(p.entry, getCloseMarkPrice(p.side, marketCandle, barCloseSnapshot), p.side, p.lotSize, profile)
        - p.commissionCost + (p.accruedSwap || 0)
    ), 0);
    const shouldClose = (basketTpUsd > 0 && basketPnl >= basketTpUsd)
      || (basketSlUsd > 0 && basketPnl <= -basketSlUsd);
    if (shouldClose) {
      const reason = basketPnl >= 0 ? 'BasketTP' : 'BasketSL';
      for (const pos of positions) {
        closePosition(pos, index, getCloseMarkPrice(pos.side, marketCandle, barCloseSnapshot), reason);
      }
      positions = [];
    }
  }

  function checkGridBasketExit(index, marketCandle, barCloseSnapshot) {
    if (!gridEnabled || !positions.length) return;
    if (gridBasketTpPoints <= 0 && gridBasketSlPoints <= 0) return;
    const basketPnl = positions.reduce((sum, p) => (
      sum + calculateFloatingPnl(p.entry, getCloseMarkPrice(p.side, marketCandle, barCloseSnapshot), p.side, p.lotSize, profile)
    ), 0);
    const shouldClose = (gridBasketTpPoints > 0 && basketPnl >= gridBasketTpPoints * profile.point * baseLotSize * 10000)
      || (gridBasketSlPoints > 0 && basketPnl <= -(gridBasketSlPoints * profile.point * baseLotSize * 10000));
    if (shouldClose) {
      const reason = basketPnl > 0 ? 'GridTP' : 'GridSL';
      const exitSnapshot = barCloseSnapshot;
      for (const pos of positions) {
        closePosition(pos, index, getCloseMarkPrice(pos.side, marketCandle, exitSnapshot), reason);
      }
      positions = [];
    }
  }

  // Broker stop-out: while the margin level (equity / used margin) sits below stopOutLevel,
  // force-close the worst-performing position at the current mark, mirroring a margin call.
  // Ported from the server engine so instant replay matches the server backtest and MT5.
  function checkMarginStopOut(index, marketCandle, barCloseSnapshot) {
    if (stopOutLevel <= 0 || !positions.length) return;
    let guard = 0;
    while (positions.length && guard < 200) {
      guard += 1;
      const usedMargin = positions.reduce((sum, p) => sum + estimateMarginRequired(p.lotSize, profile, p.entry), 0);
      if (usedMargin <= 0) return; // no margin data for this instrument — nothing to stop out
      let worst = null;
      let worstPnl = Infinity;
      let floating = 0;
      for (const p of positions) {
        const pnl = calculateFloatingPnl(p.entry, getCloseMarkPrice(p.side, marketCandle, barCloseSnapshot), p.side, p.lotSize, profile)
          - p.commissionCost + (p.accruedSwap || 0);
        floating += pnl;
        if (pnl < worstPnl) { worstPnl = pnl; worst = p; }
      }
      const marginLevel = ((balance + floating) / usedMargin) * 100;
      if (marginLevel >= stopOutLevel || !worst) return;
      logJournal(candles[index].time, 'error', 'stop_out',
        `Stop out: margin level ${marginLevel.toFixed(1)}% below stop-out ${stopOutLevel}%. Force-closed ${worst.side} ${formatLot(worst.lotSize)} lots.`);
      closePosition(worst, index, getCloseMarkPrice(worst.side, marketCandle, barCloseSnapshot), 'StopOut');
      positions = positions.filter((p) => p !== worst);
    }
  }

  // Per-signal-bar decision trace for the strategy debugger: what every entry model and
  // filter decided, and why an entry did or did not happen. Recorded by the simulation
  // itself so the debugger can never drift from engine behaviour.
  const SIGNAL_TRACE_LIMIT = 20000;
  const signalTrace = [];
  let signalTraceTruncated = false;

  // ── VixScript (Phase B): compile once; parse/runtime errors journal once and disable the
  // script for the rest of the run (deterministic — never a partial bar).
  const scriptEnabled = Boolean(rules.scriptEnabled) && String(rules.scriptSource || '').trim().length > 0;
  let scriptCompiled = null;
  let scriptDisabledReason = '';
  let scriptErrorLogged = false;
  const scriptState = {};
  if (scriptEnabled) {
    const compiled = compileVixScript(rules.scriptSource);
    if (compiled.ok) scriptCompiled = compiled;
    else scriptDisabledReason = compiled.error;
  }

  for (let index = startIndex; index < candles.length; index += 1) {
    const candle = candles[index];
    const previousExecutionCandle = candles[index - 1] || null;
    const marketCandle = createMarketCandle(candle);
    const executionTicks = modelingMode === 'every_tick' ? (executionTickBuckets.get(candle.time) || []) : [];
    const barOpenSnapshot = getBarOpenSnapshot(marketCandle, executionTicks);
    const barCloseSnapshot = getBarCloseSnapshot(marketCandle, executionTicks);
    const marketReopenExecutionBar = isMarketReopenExecutionBar(candle, previousExecutionCandle, executionTimeframe);
    const signalContext = evaluationContexts[normalizedSetup.timeframe];
    const currentSignalAnchorIndex = signalContext?.openTimes?.length
      ? findLastOpenCandleIndex(signalContext.openTimes, candle.time)
      : -1;
    const latestClosedSignalIndex = currentSignalAnchorIndex > 0 ? currentSignalAnchorIndex - 1 : -1;
    const latestClosedSignalTime = latestClosedSignalIndex >= 0
      ? Number(signalContext.openTimes[latestClosedSignalIndex])
      : null;
    const rawSignalEvaluationBar = latestClosedSignalTime !== null
      && latestClosedSignalTime !== lastProcessedSignalClosedTime;
    if (rawSignalEvaluationBar) {
      lastProcessedSignalClosedTime = latestClosedSignalTime;
    }
    const isSignalEvaluationBar = rawSignalEvaluationBar;
    // Conditions evaluate on the LAST CLOSED signal bar (shift 0 = that bar), matching the
    // exported EA which only ever sees closed bars. Anchoring on latestClosedSignalTime (not the
    // forming bar's open) avoids look-ahead — otherwise shift 0 would read the current, not-yet-
    // closed bar's complete OHLC and massively inflate signals/win rate.
    const signalEvaluationTime = latestClosedSignalTime !== null
      ? latestClosedSignalTime
      : candle.time;
    // Match the exported EA: strategy logic runs when a new signal-timeframe bar has closed,
    // even if the first execution tick after that close arrives late after a market gap.
    const signalCandle = isSignalEvaluationBar ? signalContext.candles[latestClosedSignalIndex] : null;
    const previousSignalCandle = isSignalEvaluationBar ? signalContext.candles[latestClosedSignalIndex - 1] || null : null;
    const signalContextTime = signalCandle?.time ?? candle.time;
    const dayKey = getStrategyDayKey(signalContextTime, rules);
    const minuteOfDay = getStrategyMinutesOfDay(signalContextTime, rules);
    const previousClose = previousSignalCandle?.close ?? signalCandle?.open ?? candle.open;

    if (rangeState.dayKey !== dayKey) {
      rangeState = { dayKey, high: null, low: null, ready: false, traded: false };
    }

    if (rules.rangeBreakoutEnabled && signalCandle) {
      if (rangeStartMinutes <= rangeEndMinutes) {
        if (minuteOfDay >= rangeStartMinutes && minuteOfDay < rangeEndMinutes) {
          rangeState.high = rangeState.high === null ? signalCandle.high : Math.max(rangeState.high, signalCandle.high);
          rangeState.low = rangeState.low === null ? signalCandle.low : Math.min(rangeState.low, signalCandle.low);
        } else if (minuteOfDay >= rangeEndMinutes && rangeState.high !== null && rangeState.low !== null) {
          rangeState.ready = true;
        }
      }
    }

    const longConditionSignal = rules.indicatorEntriesEnabled
      && isSignalEvaluationBar
      && index >= signalStartIndex
      ? evaluateConditionGroup(rules.longConditions, rules.longMode, evaluationContexts, signalEvaluationTime, normalizedSetup.timeframe)
      : false;
    const shortConditionSignal = rules.indicatorEntriesEnabled
      && isSignalEvaluationBar
      && index >= signalStartIndex
      ? evaluateConditionGroup(rules.shortConditions, rules.shortMode, evaluationContexts, signalEvaluationTime, normalizedSetup.timeframe)
      : false;
    let breakoutSignals = { long: false, short: false };
    let rangeBarrierLong = null;
    let rangeBarrierShort = null;
    if (rules.rangeBreakoutEnabled && signalCandle && rangeState.ready && (!rangeBreakoutOnce || !rangeState.traded) && rangeState.high !== null && rangeState.low !== null) {
      const buffer = Math.max(0, Number(rules.rangeBreakoutBuffer) || 0) * profile.point;
      const longBarrier = rangeState.high + buffer;
      const shortBarrier = rangeState.low - buffer;
      if (rules.rangeBreakoutSide === 'both' || rules.rangeBreakoutSide === 'long') rangeBarrierLong = longBarrier;
      if (rules.rangeBreakoutSide === 'both' || rules.rangeBreakoutSide === 'short') rangeBarrierShort = shortBarrier;
      breakoutSignals = {
        long: (rules.rangeBreakoutSide === 'both' || rules.rangeBreakoutSide === 'long')
          && previousClose <= longBarrier
          && signalCandle.close > longBarrier,
        short: (rules.rangeBreakoutSide === 'both' || rules.rangeBreakoutSide === 'short')
          && previousClose >= shortBarrier
          && signalCandle.close < shortBarrier,
      };
    }
    // ── Phase 2 structural-breakout entry model (OR-combine) ──────────────────
    let structuralSignals = { long: false, short: false };
    let structuralBarrierLong = null;
    let structuralBarrierShort = null;
    if (rules.structuralBreakoutEnabled && signalCandle && isSignalEvaluationBar) {
      const ref = rules.structuralBreakoutRef;
      const sbBuffer = Math.max(0, Number(rules.structuralBreakoutBuffer) || 0) * profile.point;
      let longBarrier = null;
      let shortBarrier = null;
      // Period for the "trade once" gate: the week for prevWeekHL, otherwise the day.
      currentStructuralPeriodKey = dayKey;
      if (ref === 'prevWeekHL') {
        const sd = getStrategyDate(signalContextTime, rules);
        const isoDay = (sd.getUTCDay() + 6) % 7;
        currentStructuralPeriodKey = String(Date.UTC(sd.getUTCFullYear(), sd.getUTCMonth(), sd.getUTCDate()) - (isoDay * 86400000));
      }
      if (ref === 'prevDayHL' || ref === 'prevWeekHL') {
        const periodKey = currentStructuralPeriodKey;
        if (structuralState.key !== periodKey) {
          structuralState = {
            key: periodKey,
            curHigh: signalCandle.high,
            curLow: signalCandle.low,
            prevHigh: structuralState.curHigh,
            prevLow: structuralState.curLow,
          };
        } else {
          structuralState.curHigh = Math.max(structuralState.curHigh, signalCandle.high);
          structuralState.curLow = Math.min(structuralState.curLow, signalCandle.low);
        }
        if (structuralState.prevHigh !== null && structuralState.prevLow !== null) {
          longBarrier = structuralState.prevHigh + sbBuffer;
          shortBarrier = structuralState.prevLow - sbBuffer;
        }
      } else if (ref === 'donchian') {
        const n = Math.max(2, Math.trunc(Number(rules.donchianPeriod) || 20));
        const startK = latestClosedSignalIndex - n;
        if (startK >= 0) {
          let hi = -Infinity;
          let lo = Infinity;
          for (let k = startK; k < latestClosedSignalIndex; k += 1) {
            const c = signalContext.candles[k];
            if (c) { hi = Math.max(hi, c.high); lo = Math.min(lo, c.low); }
          }
          if (Number.isFinite(hi) && Number.isFinite(lo)) { longBarrier = hi + sbBuffer; shortBarrier = lo - sbBuffer; }
        }
      } else if (ref === 'atrVolatility') {
        const p = Math.max(2, Math.trunc(Number(rules.atrBreakoutPeriod) || 14));
        const mult = Math.max(0, Number(rules.atrBreakoutMultiple) || 1.5);
        const startK = latestClosedSignalIndex - p;
        if (startK >= 1) {
          let trSum = 0;
          let cnt = 0;
          for (let k = startK; k < latestClosedSignalIndex; k += 1) {
            const c = signalContext.candles[k];
            const pc = signalContext.candles[k - 1];
            if (c && pc) {
              trSum += Math.max(c.high - c.low, Math.abs(c.high - pc.close), Math.abs(c.low - pc.close));
              cnt += 1;
            }
          }
          if (cnt) { const atr = trSum / cnt; longBarrier = previousClose + (mult * atr); shortBarrier = previousClose - (mult * atr); }
        }
      }
      if (longBarrier !== null && shortBarrier !== null) {
        const side = rules.structuralBreakoutSide;
        if (side === 'both' || side === 'long') structuralBarrierLong = longBarrier;
        if (side === 'both' || side === 'short') structuralBarrierShort = shortBarrier;
        structuralSignals = {
          long: (side === 'both' || side === 'long') && previousClose <= longBarrier && signalCandle.close > longBarrier,
          short: (side === 'both' || side === 'short') && previousClose >= shortBarrier && signalCandle.close < shortBarrier,
        };
      }
      // Trade-once gate: once this period's structural level has been traded, stop re-arming it.
      if (structuralBreakoutOnce && structuralTradedKey !== null && structuralTradedKey === currentStructuralPeriodKey) {
        structuralBarrierLong = null;
        structuralBarrierShort = null;
        structuralSignals = { long: false, short: false };
      }
    }

    // ── Phase 2 candle-pattern entry model (OR-combine) ───────────────────────
    let candlePatternSignals = { long: false, short: false };
    if (rules.candlePatternEntryEnabled && signalCandle && isSignalEvaluationBar) {
      const detected = detectCandlePatterns(rules.candlePatternList, signalCandle, previousSignalCandle, signalContext.candles[latestClosedSignalIndex - 2] || null);
      const side = rules.candlePatternSide;
      candlePatternSignals = {
        long: (side === 'both' || side === 'long') && detected.long,
        short: (side === 'both' || side === 'short') && detected.short,
      };
    }

    // ── Pattern-by-example entry model (OR-combine) — independent long & short templates ──
    let patternSignals = { long: false, short: false };
    if (rules.patternEntryEnabled && signalCandle && isSignalEvaluationBar) {
      const patternThreshold = Number(rules.patternThreshold);
      patternSignals.long = patternMatchAny(signalContext.candles, latestClosedSignalIndex, rules.patternLongTemplates, rules.patternMatchMode, rules.patternSimilarity, patternThreshold);
      patternSignals.short = patternMatchAny(signalContext.candles, latestClosedSignalIndex, rules.patternShortTemplates, rules.patternMatchMode, rules.patternSimilarity, patternThreshold);
    }

    // ── VixScript entry model (OR-combine) — deterministic scripted logic ─────────────────
    let scriptSignals = { long: false, short: false };
    if (scriptEnabled && isSignalEvaluationBar && signalCandle) {
      if (scriptDisabledReason) {
        if (!scriptErrorLogged) {
          logJournal(candle.time, 'error', 'script_error', `VixScript disabled: ${scriptDisabledReason}`);
          scriptErrorLogged = true;
        }
      } else {
        const scriptActions = { buy: false, sell: false, closeLong: false, closeShort: false, stopPoints: null, targetPoints: null, stopPrice: null, targetPrice: null, logs: [] };
        const scriptAnchor = latestClosedSignalIndex;
        const scriptNum = (value) => (Number.isFinite(Number(value)) ? Number(value) : 0);
        const scriptShiftIndex = (shift) => scriptAnchor - Math.max(0, Math.trunc(scriptNum(shift)));
        const scriptPriceAt = (field, shift) => {
          const bar = signalContext.candles[scriptShiftIndex(shift)];
          return bar ? bar[field] : null;
        };
        const scriptOperandAt = (id, shift) => resolveOperandValue(String(id), signalContext, scriptShiftIndex(shift));
        // The host closures intentionally read live engine state (balance/positions) at call
        // time within this same iteration — they never escape the loop.
        /* eslint-disable no-loop-func */
        const scriptHost = {
          open: (s) => scriptPriceAt('open', s),
          high: (s) => scriptPriceAt('high', s),
          low: (s) => scriptPriceAt('low', s),
          close: (s) => scriptPriceAt('close', s),
          ind: (id, s) => scriptOperandAt(id, s),
          highest: (id, count, s) => {
            let best = null;
            const bars = Math.min(500, Math.max(1, Math.trunc(scriptNum(count))));
            for (let k = 0; k < bars; k += 1) {
              const value = scriptOperandAt(id, scriptNum(s) + k);
              if (value !== null && Number.isFinite(value)) best = best === null ? value : Math.max(best, value);
            }
            return best;
          },
          lowest: (id, count, s) => {
            let best = null;
            const bars = Math.min(500, Math.max(1, Math.trunc(scriptNum(count))));
            for (let k = 0; k < bars; k += 1) {
              const value = scriptOperandAt(id, scriptNum(s) + k);
              if (value !== null && Number.isFinite(value)) best = best === null ? value : Math.min(best, value);
            }
            return best;
          },
          crossover: (a, b) => {
            const a0 = scriptOperandAt(a, 0);
            const b0 = scriptOperandAt(b, 0);
            const a1 = scriptOperandAt(a, 1);
            const b1 = scriptOperandAt(b, 1);
            return a0 !== null && b0 !== null && a1 !== null && b1 !== null && a1 <= b1 && a0 > b0 ? 1 : 0;
          },
          crossunder: (a, b) => {
            const a0 = scriptOperandAt(a, 0);
            const b0 = scriptOperandAt(b, 0);
            const a1 = scriptOperandAt(a, 1);
            const b1 = scriptOperandAt(b, 1);
            return a0 !== null && b0 !== null && a1 !== null && b1 !== null && a1 >= b1 && a0 < b0 ? 1 : 0;
          },
          barIndex: () => scriptAnchor,
          hour: () => getStrategyDate(signalContextTime, rules).getUTCHours(),
          minute: () => getStrategyDate(signalContextTime, rules).getUTCMinutes(),
          dayOfWeek: () => getStrategyDayIndex(signalContextTime, rules),
          spread: () => marketCandle.spread,
          point: () => profile.point,
          balance: () => balance,
          equity: () => balance + positions.reduce((sum, position) => (
            sum + calculateFloatingPnl(position.entry, getCloseMarkPrice(position.side, marketCandle, barOpenSnapshot), position.side, position.lotSize, profile)
          ), 0),
          positionCount: () => positions.length,
          hasLong: () => (positions.some((position) => position.side === 'long') ? 1 : 0),
          hasShort: () => (positions.some((position) => position.side === 'short') ? 1 : 0),
          avgEntry: () => (positions.length ? positions.reduce((sum, position) => sum + position.entry, 0) / positions.length : 0),
          buy: () => { scriptActions.buy = true; },
          sell: () => { scriptActions.sell = true; },
          closeAll: () => { scriptActions.closeLong = true; scriptActions.closeShort = true; },
          closeLong: () => { scriptActions.closeLong = true; },
          closeShort: () => { scriptActions.closeShort = true; },
          setStop: (price) => { scriptActions.stopPrice = scriptNum(price); },
          setTarget: (price) => { scriptActions.targetPrice = scriptNum(price); },
          setStopPoints: (points) => { scriptActions.stopPoints = scriptNum(points); },
          setTargetPoints: (points) => { scriptActions.targetPoints = scriptNum(points); },
          log: (message) => { if (scriptActions.logs.length < 3) scriptActions.logs.push(String(message).slice(0, 200)); },
          abs: (x) => Math.abs(scriptNum(x)),
          min: (a, b) => Math.min(scriptNum(a), scriptNum(b)),
          max: (a, b) => Math.max(scriptNum(a), scriptNum(b)),
          round: (x) => Math.round(scriptNum(x)),
          floor: (x) => Math.floor(scriptNum(x)),
          ceil: (x) => Math.ceil(scriptNum(x)),
        };
        /* eslint-enable no-loop-func */
        const scriptRun = runVixScriptBar(scriptCompiled, scriptHost, scriptState);
        if (scriptRun.error) {
          scriptDisabledReason = scriptRun.error;
          logJournal(candle.time, 'error', 'script_error', `VixScript disabled: ${scriptRun.error}`);
          scriptErrorLogged = true;
        } else {
          scriptSignals = {
            long: scriptActions.buy && !scriptActions.sell,
            short: scriptActions.sell && !scriptActions.buy,
          };
          scriptActions.logs.forEach((message) => logJournal(candle.time, 'info', 'script_log', message));
          if ((scriptActions.closeLong || scriptActions.closeShort) && positions.length) {
            const remaining = [];
            for (const position of positions) {
              const shouldClose = (position.side === 'long' && scriptActions.closeLong)
                || (position.side === 'short' && scriptActions.closeShort);
              if (shouldClose) {
                closePosition(position, index, getOpenExecutionPrice(position.side, marketCandle, true, barOpenSnapshot), 'Script');
              } else {
                remaining.push(position);
              }
            }
            positions = remaining;
          }
          if (positions.length && (scriptActions.stopPoints !== null || scriptActions.stopPrice !== null || scriptActions.targetPoints !== null || scriptActions.targetPrice !== null)) {
            for (const position of positions) {
              if (scriptActions.stopPoints !== null) {
                position.stop = normalizePriceToTick(position.side === 'long'
                  ? position.entry - (scriptActions.stopPoints * profile.point)
                  : position.entry + (scriptActions.stopPoints * profile.point), profile);
              }
              if (scriptActions.stopPrice !== null) position.stop = normalizePriceToTick(scriptActions.stopPrice, profile);
              if (scriptActions.targetPoints !== null) {
                position.target = normalizePriceToTick(position.side === 'long'
                  ? position.entry + (scriptActions.targetPoints * profile.point)
                  : position.entry - (scriptActions.targetPoints * profile.point), profile);
              }
              if (scriptActions.targetPrice !== null) position.target = normalizePriceToTick(scriptActions.targetPrice, profile);
            }
          }
        }
      }
    }

    // ── Phase 2 FILTERS — boolean vetoes that AND-gate the OR-combined signal ──
    // The spread filter skips ABNORMALLY wide moments, which only means something with real
    // per-bar spread. When the data has none (Deriv candles carry no spread — the engine uses a
    // realistic per-symbol CONSTANT for fill pricing), there's no per-bar variation to filter on,
    // so the filter passes rather than blocking every bar against that constant.
    const perBarSpread = Number(candle?.spread);
    const hasRealBarSpread = Number.isFinite(perBarSpread) && perBarSpread > 0;
    const passesSpreadFilter = !rules.spreadFilterEnabled
      || Number(rules.maxSpreadPoints) <= 0
      || !hasRealBarSpread
      || perBarSpread <= Number(rules.maxSpreadPoints);
    let trendLongOk = true;
    let trendShortOk = true;
    if (rules.trendFilterEnabled && trendHtfOpenTimes && signalCandle) {
      const anchor = findLastOpenCandleIndex(trendHtfOpenTimes, signalContextTime);
      const closedIdx = anchor > 0 ? anchor - 1 : -1;
      const ma = closedIdx >= 0 ? trendMaSeries[closedIdx] : null;
      if (ma != null && Number.isFinite(ma)) {
        if (rules.trendFilterMode === 'price') {
          trendLongOk = signalCandle.close > ma;
          trendShortOk = signalCandle.close < ma;
        } else {
          const prevMa = closedIdx >= 1 ? trendMaSeries[closedIdx - 1] : null;
          if (prevMa != null && Number.isFinite(prevMa)) {
            trendLongOk = ma > prevMa;
            trendShortOk = ma < prevMa;
          }
        }
      }
    }
    const passesTimedEntry = !timedEntryEnabled
      || (timedEntryStartMin <= timedEntryEndMin
        ? (minuteOfDay >= timedEntryStartMin && minuteOfDay < timedEntryEndMin)
        : (minuteOfDay >= timedEntryStartMin || minuteOfDay < timedEntryEndMin));

    const longSignal = (longConditionSignal || breakoutSignals.long || structuralSignals.long || candlePatternSignals.long || patternSignals.long || scriptSignals.long)
      && passesSpreadFilter && trendLongOk;
    const shortSignal = (shortConditionSignal || breakoutSignals.short || structuralSignals.short || candlePatternSignals.short || patternSignals.short || scriptSignals.short)
      && passesSpreadFilter && trendShortOk;
    let brokerExitThisBar = false;

    if (positions.length) {
      positions.forEach((position) => applySwapIfNeeded(position, candle, previousExecutionCandle));
    }

    if (isSignalEvaluationBar && lastTimeExitDayKey !== dayKey && minuteOfDay >= timeExitMinutes && rules.timeExitEnabled) {
      if (positions.length) {
        const nextPositions = [];
        for (const position of positions) {
          closePosition(position, index, getOpenExecutionPrice(position.side, marketCandle, true, barOpenSnapshot), 'Time');
        }
        positions = nextPositions;
      }
      lastTimeExitDayKey = dayKey;
    }

    // Swing levels for structure trailing: lowest low / highest high of the last N closed
    // signal bars. Computed once per bar and shared by all managed positions.
    let structureLevels = null;
    if (rules.structureTrailingEnabled && isSignalEvaluationBar && latestClosedSignalIndex >= 0) {
      const lookback = Math.max(1, Math.trunc(Number(rules.structureTrailingLookback) || 10));
      const startK = Math.max(0, latestClosedSignalIndex - lookback + 1);
      let swingLow = Infinity;
      let swingHigh = -Infinity;
      for (let k = startK; k <= latestClosedSignalIndex; k += 1) {
        const bar = signalContext.candles[k];
        if (bar) { swingLow = Math.min(swingLow, bar.low); swingHigh = Math.max(swingHigh, bar.high); }
      }
      structureLevels = {
        swingLow: Number.isFinite(swingLow) ? swingLow : null,
        swingHigh: Number.isFinite(swingHigh) ? swingHigh : null,
      };
    }

    if (positions.length) {
      const nextPositions = [];
      for (const position of positions) {
        if (isSignalEvaluationBar) {
          applyManagedStops(position, marketCandle, rules, profile, structureLevels);
        }
        const barOpenExit = chooseBarOpenExit(position, marketCandle);
        if (barOpenExit) {
          closePosition(position, index, barOpenExit.price, barOpenExit.reason);
          brokerExitThisBar = true;
        } else {
          nextPositions.push(position);
        }
      }
      positions = nextPositions;
    }

    if (positions.length && rules.closeOnOpposite) {
      const nextPositions = [];
      for (const position of positions) {
        const oppositeSignal = position.side === 'long' ? shortSignal : longSignal;
        const sameDirectionSignal = position.side === 'long' ? longSignal : shortSignal;
        if (oppositeSignal && !sameDirectionSignal) {
          closePosition(position, index, getOpenExecutionPrice(position.side, marketCandle, true, barOpenSnapshot), 'Flip');
        } else {
          nextPositions.push(position);
        }
      }
      positions = nextPositions;
    }

    if (positions.length) {
      const nextPositions = [];
      for (const position of positions) {
        // Partial take-profit: close a slice at TP1, then let the rest run to full TP/SL/trail.
        if (partialTpEnabled && !position.partialDone && partialTpPoints > 0) {
          const tp1 = position.side === 'long'
            ? position.entry + (partialTpPoints * profile.point)
            : position.entry - (partialTpPoints * profile.point);
          const reached = position.side === 'long'
            ? (marketCandle.bidHigh ?? marketCandle.high) >= tp1
            : (marketCandle.askLow ?? marketCandle.low) <= tp1;
          if (reached) {
            position.partialDone = true;
            const fullyClosed = closePartial(position, index, tp1, partialTpPercent / 100, 'TP1');
            if (fullyClosed) {
              brokerExitThisBar = true;
              continue;
            }
            if (partialTpMoveBreakeven) {
              position.stop = position.side === 'long'
                ? Math.max(Number.isFinite(position.stop) ? position.stop : -Infinity, position.entry)
                : Math.min(Number.isFinite(position.stop) ? position.stop : Infinity, position.entry);
            }
          }
        }
        const forcedExit = modelingMode === 'every_tick' && executionTicks.length
          ? chooseTickExit(position, executionTicks, marketCandle.spread, profile) || chooseIntrabarExit(position, marketCandle)
          : chooseIntrabarExit(position, marketCandle);
        if (forcedExit) {
          closePosition(position, index, forcedExit.price, forcedExit.reason);
          brokerExitThisBar = true;
        } else {
          nextPositions.push(position);
        }
      }
      positions = nextPositions;
    }

    // Process pending order fills and check grid basket exit
    if (pendingOrderEnabled) {
      processPendingOrders(index, marketCandle, executionTicks);
      if (rules.closeOnOpposite && isSignalEvaluationBar) {
        pendingOrders = pendingOrders.filter((order) => {
          if (longSignal && order.side === 'short') {
            cancelledOrders.push({ ...order, cancelIndex: index, cancelReason: 'opposite_signal' });
            return false;
          }
          if (shortSignal && order.side === 'long') {
            cancelledOrders.push({ ...order, cancelIndex: index, cancelReason: 'opposite_signal' });
            return false;
          }
          return true;
        });
      }
    }
    if (gridEnabled) {
      checkGridBasketExit(index, marketCandle, barCloseSnapshot);
    }
    if (basketTpEnabled) {
      checkBasketExit(index, marketCandle, barCloseSnapshot);
    }

    const entryFilterTime = signalCandle?.time ?? previousExecutionCandle?.time ?? candle.time;
    const pendingBreakoutLong = structuralBarrierLong ?? rangeBarrierLong;
    const pendingBreakoutShort = structuralBarrierShort ?? rangeBarrierShort;
    const reactiveLong = (longConditionSignal || candlePatternSignals.long) && passesSpreadFilter && trendLongOk;
    const reactiveShort = (shortConditionSignal || candlePatternSignals.short) && passesSpreadFilter && trendShortOk;
    // Entry cooldown: block new entries until cooldownBars signal-timeframe bars have elapsed
    // since the last filled entry.
    const passesCooldown = cooldownBars <= 0 || lastEntryTime === null
      || (candle.time - lastEntryTime) >= cooldownBars * getTimeframeMs(normalizedSetup.timeframe);
    const tracePositionsBefore = positions.length;
    const traceTradesBefore = trades.length;
    const traceBrokerExitBeforeEntry = brokerExitThisBar;
    if (passesCooldown && isSignalEvaluationBar && passesTimedEntry && (!brokerExitThisBar || marketReopenExecutionBar) && isDayAllowed(entryFilterTime, rules.dayFilters, rules) && isSessionActive(entryFilterTime, sessions, rules)) {
      if (pendingOrderEnabled) {
        if (pendingBreakoutLong !== null && passesSpreadFilter && trendLongOk && positions.length < maxOpenTrades) {
          syncBreakoutPending('long', pendingBreakoutLong, index, marketCandle, structuralBarrierLong !== null ? 'structural' : 'range');
        }
        if (pendingBreakoutShort !== null && passesSpreadFilter && trendShortOk && positions.length < maxOpenTrades) {
          syncBreakoutPending('short', pendingBreakoutShort, index, marketCandle, structuralBarrierShort !== null ? 'structural' : 'range');
        }
        if (reactiveLong !== reactiveShort) {
          placePendingOrder(reactiveLong ? 'long' : 'short', index);
        }
      } else if (longSignal !== shortSignal) {
        const entrySide = longSignal ? 'long' : 'short';
        if (gridEnabled) {
          placeGridOrders(entrySide, index, marketCandle, barOpenSnapshot);
          if (breakoutSignals.long || breakoutSignals.short) rangeState.traded = true;
        } else if (positions.length < maxOpenTrades) {
          const openedPosition = openPosition(entrySide, index, getOpenExecutionPrice(entrySide, marketCandle, false, barOpenSnapshot));
          if (openedPosition) {
            if (breakoutSignals.long || breakoutSignals.short) {
              rangeState.traded = true;
            }
            if (structuralSignals.long || structuralSignals.short) {
              structuralTradedKey = currentStructuralPeriodKey;
            }
            const sameBarExit = modelingMode === 'every_tick' && executionTicks.length
              ? chooseTickExit(openedPosition, executionTicks, marketCandle.spread, profile) || chooseIntrabarExit(openedPosition, marketCandle)
              : chooseIntrabarExit(openedPosition, marketCandle);
            if (sameBarExit) {
              closePosition(openedPosition, index, sameBarExit.price, sameBarExit.reason);
              positions = positions.filter((position) => position !== openedPosition);
              brokerExitThisBar = true;
            }
          }
        }
      }
    }

    if (freeGrid && passesCooldown && isSignalEvaluationBar && passesTimedEntry && !brokerExitThisBar && isDayAllowed(entryFilterTime, rules.dayFilters, rules) && isSessionActive(entryFilterTime, sessions, rules)) {
      const longCount = positions.filter((p) => p.side === 'long').length;
      const shortCount = positions.filter((p) => p.side === 'short').length;
      if (longCount === 0) placeGridOrders('long', index, marketCandle, barOpenSnapshot);
      if (shortCount === 0) placeGridOrders('short', index, marketCandle, barOpenSnapshot);
    }

    if (isSignalEvaluationBar) {
      if (signalTrace.length >= SIGNAL_TRACE_LIMIT) {
        signalTraceTruncated = true;
      } else {
        const traceDayOk = isDayAllowed(entryFilterTime, rules.dayFilters, rules);
        const traceSessionOk = isSessionActive(entryFilterTime, sessions, rules);
        let entered = null;
        if (positions.length > tracePositionsBefore) {
          entered = positions[positions.length - 1].side;
        } else if (trades.length > traceTradesBefore) {
          // Same-bar entry+exit: the position is already closed into the trades ledger,
          // which stores display sides — normalize back to long/short.
          entered = trades[trades.length - 1].side === 'BUY' ? 'long' : 'short';
        }
        let veto = null;
        if (!entered && (longSignal || shortSignal)) {
          if (longSignal && shortSignal) veto = 'conflicting_signals';
          else if (!passesCooldown) veto = 'cooldown';
          else if (!passesTimedEntry) veto = 'timed_entry';
          else if (traceBrokerExitBeforeEntry && !marketReopenExecutionBar) veto = 'exit_this_bar';
          else if (!traceDayOk) veto = 'day_filter';
          else if (!traceSessionOk) veto = 'session_filter';
          else if (pendingOrderEnabled) veto = 'pending_order_mode';
          else if (gridEnabled) veto = 'grid_mode';
          else if (tracePositionsBefore >= maxOpenTrades) veto = 'max_open_trades';
          else veto = 'order_rejected';
        }
        signalTrace.push({
          index,
          signalIndex: latestClosedSignalIndex,
          signalTime: latestClosedSignalTime,
          conditionLong: longConditionSignal,
          conditionShort: shortConditionSignal,
          rangeLong: breakoutSignals.long,
          rangeShort: breakoutSignals.short,
          structuralLong: structuralSignals.long,
          structuralShort: structuralSignals.short,
          candleLong: candlePatternSignals.long,
          candleShort: candlePatternSignals.short,
          patternLong: patternSignals.long,
          patternShort: patternSignals.short,
          scriptLong: scriptSignals.long,
          scriptShort: scriptSignals.short,
          spreadOk: passesSpreadFilter,
          trendLongOk,
          trendShortOk,
          timedEntryOk: passesTimedEntry,
          cooldownOk: passesCooldown,
          dayOk: traceDayOk,
          sessionOk: traceSessionOk,
          openPositions: tracePositionsBefore,
          entered,
          veto,
        });
      }
    }

    checkMarginStopOut(index, marketCandle, barCloseSnapshot);

    // Record stop/target changes after all per-bar management (trailing, breakeven, script)
    // so the chart can draw the moving-level path bar by bar.
    for (const position of positions) {
      const history = position.levelHistory;
      if (!Array.isArray(history) || history.length >= 2000) continue;
      const last = history[history.length - 1];
      const stopNow = position.stop ?? null;
      const targetNow = position.target ?? null;
      if (!last || last.stop !== stopNow || last.target !== targetNow) {
        history.push({ index, stop: stopNow, target: targetNow });
      }
    }

    const floating = positions.reduce((sum, position) => (
      sum + calculateFloatingPnl(position.entry, getCloseMarkPrice(position.side, marketCandle, barCloseSnapshot), position.side, position.lotSize, profile)
        - position.commissionCost
        + (position.accruedSwap || 0)
    ), 0);
    const currentEquity = balance + floating;
    peakEquity = Math.max(peakEquity, currentEquity);
    equity.push({
      index,
      balance,
      equity: currentEquity,
      drawdown: peakEquity ? ((peakEquity - currentEquity) / peakEquity) * 100 : 0,
      time: candle.time,
    });
  }

  // Snapshot taken BEFORE the end-of-run forced close below.
  //
  // A backtest closes every remaining position on the last bar (reason 'End'), matching the
  // MT5 tester. A LIVE deployment must not: the position is genuinely still open, and treating
  // the artificial close as real would fire a phantom exit on every single tick. Cloud Signals
  // reads these two fields and ignores every 'End' trade.
  const openPositionsAtEnd = positions.map((position) => ({ ...position }));
  const balanceBeforeFinalClose = balance;

  if (positions.length && candles.length) {
    const finalIndex = candles.length - 1;
    const finalCandle = candles[finalIndex];
    const finalMarketCandle = createMarketCandle(finalCandle);
    const finalExecutionTicks = modelingMode === 'every_tick'
      ? (executionTickBuckets.get(finalCandle.time) || [])
      : [];
    const finalBarCloseSnapshot = getBarCloseSnapshot(finalMarketCandle, finalExecutionTicks);
    const finalPositions = positions;
    positions = [];

    for (const position of finalPositions) {
      closePosition(
        position,
        finalIndex,
        getCloseMarkPrice(position.side, finalMarketCandle, finalBarCloseSnapshot),
        'End',
      );
    }

    peakEquity = Math.max(peakEquity, balance);
    const finalDrawdown = peakEquity ? ((peakEquity - balance) / peakEquity) * 100 : 0;
    const finalEquityPoint = {
      index: finalIndex,
      balance,
      equity: balance,
      drawdown: finalDrawdown,
      time: finalCandle.time,
    };
    if (equity.length) {
      equity[equity.length - 1] = finalEquityPoint;
    } else {
      equity.push(finalEquityPoint);
    }
  }

  const oscillatorAreaIds = new Set(indicators
    .filter((indicator) => INDICATOR_LIBRARY[indicator.type]?.area === 'oscillator')
    .map((indicator) => indicator.id));
  // MAs applied to an oscillator render inside that oscillator's subwindow, not on price.
  const isSubwindowIndicator = (indicator) => oscillatorAreaIds.has(getAppliedIndicatorTargetId(indicator) || '');
  const priceIndicatorOverlays = indicators
    .filter((indicator) => INDICATOR_LIBRARY[indicator.type]?.area === 'price' && !isSubwindowIndicator(indicator))
    .map((indicator) => ({
      id: indicator.id,
      color: indicator.color,
      label: getIndicatorLabel(indicator),
      values: indicatorMap[indicator.id],
      series: indicatorOutputs[indicator.id]?.series || [],
    }));
  const rangeBreakoutOverlay = buildRangeBreakoutOverlay(candles, rules, profile);
  const structuralBreakoutOverlay = buildStructuralBreakoutOverlay(candles, rules, profile);
  const overlays = [
    ...priceIndicatorOverlays,
    ...(rangeBreakoutOverlay ? [rangeBreakoutOverlay] : []),
    ...(structuralBreakoutOverlay ? [structuralBreakoutOverlay] : []),
  ];

  // Every oscillator-area indicator gets its own subwindow (like MT5), with any MAs applied
  // to it rendered as extra series inside that subwindow.
  const oscillators = indicators
    .filter((indicator) => INDICATOR_LIBRARY[indicator.type]?.area === 'oscillator')
    .map((indicator) => {
      const descriptor = buildOscillatorDescriptor(indicator, indicatorOutputs[indicator.id]);
      if (!descriptor) {
        return null;
      }
      const attachedSeries = indicators
        .filter((candidate) => getAppliedIndicatorTargetId(candidate) === indicator.id)
        .flatMap((candidate) => indicatorOutputs[candidate.id]?.series || []);
      return attachedSeries.length
        ? { ...descriptor, series: [...descriptor.series, ...attachedSeries] }
        : descriptor;
    })
    .filter(Boolean);
  const oscillator = oscillators[0] || null;

  return {
    setup: normalizedSetup,
    profile,
    candles,
    indicators,
    indicatorMap,
    indicatorOutputs,
    overlays,
    oscillator,
    oscillators,
    trades,
    equity,
    startIndex,
    initialBalance,
    rules,
    sessions,
    signalTrace,
    signalTraceTruncated,
    pendingOrders,
    cancelledOrders,
    journal,
    journalTruncated,
    // Positions still open when the run ended, captured before the end-of-run forced close,
    // plus the balance at that moment. `trades` only ever holds CLOSED trades, so without
    // these a live consumer cannot see the position a strategy is currently sitting in.
    // Additive only — nothing reads them inside the engine, so backtest output is unchanged.
    openPositions: openPositionsAtEnd,
    balanceBeforeFinalClose,
  };
}

export function summarizeBacktest(engine, currentBar) {
  return buildSummary(engine, currentBar);
}

export function getWindow(engine, currentBar, size = 90) {
  const end = Math.max(engine.startIndex + 1, currentBar + 1);
  const start = Math.max(0, end - size);
  return { start, end };
}

export function metricTone(metric, value) {
  if (metric === 'totalTrades') {
    return 'neutral';
  }
  if (metric === 'maxDrawdown' || metric === 'averageLoss') {
    return value > 0 ? 'negative' : 'positive';
  }
  return value >= 0 ? 'positive' : 'negative';
}

















